import { Location } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { fabric } from 'fabric';
import { element } from 'protractor';
import { AreasSeatService } from 'src/app/services/areas-seat.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CreateEventService } from 'src/app/services/create-event.service';
import { EventosService } from 'src/app/services/eventos.service';
import { PlacesService } from 'src/app/services/places.service';
import { SeatMapService } from 'src/app/services/seat-map.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { NameMapComponent } from '../name-map/name-map.component';
import { SelectTypeComponent } from '../select-type/select-type.component';
import { CreateLevelsComponent } from '../create-levels/create-levels.component';
import { GenerateMapService } from 'src/app/services/generate-map.service';
import { CreateSeatsComponent } from '../create-seats/create-seats.component';
import { LegendConfigComponent } from '../legend-config/legend-config.component';
import { GenerateSeatsService } from 'src/app/services/generate-seats.service';

interface SeatElement {
  id: number;
  row: number;
  column: number;
  seat: number;
  section: number;
  configuration: any; // JSON del elemento específico
}

interface SectionData {
  section: {
    id: number;
    name: string;
    color: string;
    columns: number;
    rows: number;
    level: number;
    configuration: any; // JSON de la configuración completa
  };
  elements: SeatElement[];
}

@Component({
  selector: 'app-generate-canvas',
  templateUrl: './generate-canvas.component.html',
  styleUrls: ['./generate-canvas.component.scss']
})
export class GenerateCanvasComponent implements OnInit, OnChanges {

  output: string[] = [];
  selectObject!: any;

  canvas: fabric.Canvas;

  pausePanning = true;
  zoomStartScale = 0;
  // Modo de selección múltiple: al activarlo, el siguiente arrastre dibuja un recuadro de selección.
  // Es "de un solo uso": tras crear la selección se desactiva solo (hay que volver a pulsarlo).
  massSelectMode = false;
  // true mientras hay una selección múltiple (activeSelection) activa: muestra acciones de bloque.
  multiSelectionActive = false;
  // Ángulo (grados, -180/180) del panel "Rotar selección": rota la ActiveSelection completa sobre
  // su propio centro, igual que arrastrar el tirador mtr pero desde un input numérico/slider como
  // el de "Rotación de la sección" en edit-section. Al deseleccionar, fabric bakea el ángulo final
  // en cada hijo y persistGroupTransform (selection:cleared) lo guarda — no hace falta lógica extra.
  groupRotationAngle = 0;
  // Último objeto fabric creado por pasteCopied (para reseleccionar el bloque duplicado).
  private lastPastedObject: any = null;

  // ==== Curvar selección múltiple arbitraria (circular/elíptica/parabólica) ====
  // A diferencia de la curvatura por sección (edit-section.component.ts), aquí los objetos son
  // heterogéneos e independientes: se bakea la posición/ángulo final una sola vez al confirmar
  // (ver plan de diseño), sin guardar ninguna relación de curvatura persistente.
  curveSelectionActive = false;
  curveMode: 'circular' | 'elliptical' | 'parabolic' = 'circular';
  curveCenter: { x: number, y: number } | null = null;
  curveRadius = 0;
  curveArcDeg = 60;
  curveEllipseAspect = 1;
  curveEllipseRotation = 0;
  curveCurvature = 0;
  curveInvert = false;
  curvePlacingCenter = false;
  private curveSelectionItems: { id: string, t: number, angle: number, fabricObj: any, originalLeft: number, originalTop: number, originalAngle: number }[] = [];
  private curveAxisOrigin: { x: number, y: number } | null = null;
  private curveAxisAngleDeg = 0;
  private curveAxisLength = 1;
  private curveCenterMarker: any = null;
  private curveMovingHandler: any = null;
  // layerGroupId (si existe) al que pertenece la sesión de curva en curso: null => se creará uno
  // nuevo al confirmar; con valor => se reutiliza (reedición de un grupo ya curvado antes).
  private curveGroupId: string | null = null;

  canvasWidth!: any;
  canvasHeight!: any;
  groupGrid!: any;

  @Input() fromVenue!: boolean;
  @Input() fromEvent!: boolean;
  @Input() fromCreate!: boolean;
  @Input() idMap!: number;
  @Input() idEvent!: number;
  @Input() idSpace!: number;
  @Input() titleMap: string = '';
  @Input() editEvent!: boolean;
  @Input() capacity: number = 0;
  @Input() mapSaved!: any;
  elements: any = 0;

  @Output() loadCanvas = new EventEmitter<any>();
  subscribeSaveBtn!: any;
  sectionNumber = 1;
  numberSeats = 0;

  activeTab: boolean = false;
  openedEditSection: boolean = false;
  openedEditSeats: boolean = false;
  openedHidden: boolean = false;
  titleTab: string = '';
  isOffCanvasOpen: boolean = true;

  // Panel de capas: lista de todos los elementos del canvas en orden de apilamiento (z-order),
  // de arriba (frente) a abajo (fondo), como en Photoshop.
  openLayersPanel: boolean = false;
  // Cada entrada es una capa suelta (fabricObject) o un grupo de capas (isGroup + children)
  // creado con "Agrupar en una capa" a partir de una selección múltiple.
  layersList: { fabricObject?: any; icon: string; label: string; hidden: boolean; isGroup?: boolean; groupId?: string; children?: any[]; renaming?: boolean; renameValue?: string }[] = [];

  // Sections
  sectionsCreated: any[] = [];

  // Default colors
  colorDefaultSeat = this.areaSeatService.colorDefaultSeat;
  colorDefaultStand = this.areaSeatService.colorDefaultStand;
  colorDefaultFree = this.areaSeatService.colorDefaultFree;
  colorDefaultStage = this.areaSeatService.colorDefaultStage;
  colorDefaultHidden = this.areaSeatService.colorDefaultHidden;
  colorDefaultDisplay = this.areaSeatService.colorDefaultDisplay;
  colorDefaultBasic = this.areaSeatService.colorDefaultBasic;
  colorDefaultVisibility = this.areaSeatService.colorDefaultVisibility;

  // Levels
  levels: any[] = [];
  idLevel: number = 1;
  selectedSeats: any[] = [];
  levelEdit!: any;

  // Hidden
  selectedHidden: any[] = [];
  idHidden: number = 1;
  hiddenTypes: any[] = [];
  hiddenSeats: any[] = [];
  hiddenTypeEdit!: any;

  seatsElement: string = '/assets/img/canvas/seat-airline-light.svg';
  shoesElement: string = '/assets/img/canvas/shoe-prints-light.svg';
  microElement: string = '/assets/img/canvas/microphone-light.svg';
  screenElement: string = '/assets/img/canvas/screen-users-light.svg';

  //Edit Object
  objectEditing!: any;
  openSeatEditing!: boolean;
  openEditObject: boolean = false;
  openEditSection: boolean = false;
  openEditText: boolean = false;
  openEditImage: boolean = false;
  editingImageObject: any = null;
  editingImageAngle: number = 0;
  // Baja los listeners de arrastrar-soltar registrados a mano fuera de la zona de Angular.
  private removeFileDropListeners: (() => void) | null = null;
  // true mientras se está seleccionando el área de recorte sobre una imagen (recuadro superpuesto).
  cropModeActive: boolean = false;
  private cropRect: any = null;
  zoneNavigation: boolean = false;
  // Escena activa del editor: 'seats' = mapa de butacas, 'zones' = plano general de zonas
  // (dibujo libre desacoplado). El switch alterna visibilidad/edición de cada escena.
  mapMode: 'seats' | 'zones' = 'seats';
  editingTextObject: any = null;
  editingTextFontSize: number = 24;
  editingTextLineHeight: number = 1;
  editingTextContent: string = '';
  editingTextColor: string = '#000000';
  editingTextObjectId: string = '';
  beforeCleared!: any;
  blockComponents: boolean = false;
  // true mientras se reconstruye una sección (cambio de filas/columnas): suprime los handlers
  // de selección para no recrear el panel ni cerrarlo al intercambiar el grupo en el canvas.
  rebuildingSection: boolean = false;
  hiddenSectionEditMode: boolean = false;
  specialSeatEditMode: boolean = false;
  specialSeatTargetLevel: any = null;

  sitSelect!: any;
  seatsEditSelected: any[] = [];
  privateMap: boolean = false;

  get isViewOnly(): boolean {
    return !!(this.fromVenue && !this.allowCreate);
  }

  /** Lista de niveles disponibles para asignar a zonas de navegación. */
  levelsList: { id: number; name: string }[] = [];

  private refreshLevelsList() {
    this.levelsList = (this.levels || []).map((l: any) => ({
      id: l.id,
      name: l.name || ('Nivel ' + l.id)
    }));
  }

  /** Lista de formas (no-zona, no-butaca) disponibles para asociar como elementos de referencia. */
  availableShapesList: { id: string; name: string; type: string }[] = [];

  private static readonly REFERENCE_SHAPE_TYPES = new Set(['polygon', 'rect', 'ellipse', 'line', 'text']);

  private refreshAvailableShapesList(excludeObjectId?: string) {
    const objects = this.generateMapService.getObjectsMap() || {};
    this.availableShapesList = Object.entries(objects)
      .filter(([id, obj]: any) =>
        GenerateCanvasComponent.REFERENCE_SHAPE_TYPES.has(obj?.type) &&
        !obj?.configuration?.previewLayer &&
        id !== excludeObjectId
      )
      .map(([id, obj]: any) => ({
        id,
        name: obj?.configuration?.name || (obj?.type === 'text' ? obj?.configuration?.text : null) || id,
        type: obj?.type || 'unknown'
      }));
  }

  profile!: any;
  isSuperAdmin!: boolean;
  @Input() bookings!: any;
  @Input() allowCreate!: any;
  @Input() isSuperAdminEditMode: boolean = false;

  seatSections: { [key: number]: any } = {};
  canvasObjects: { [key: string]: any } = {};
  objectIdCounter: number = 1;
  clipboardObjectId: string | null = null;
  clipboardSectionKey: number | null = null;
  pasteOffset: number = 20;

  // Historial de cambios (Ctrl+Z)
  historyStack: Array<any> = [];
  historyMaxSize: number = 50;
  isUndoing: boolean = false;

  loadedMap: boolean = false;
  openBackgroundSection: boolean = false;
  openScenaryInput: boolean = false;
  scenaryText: string = 'Escenario';
  openEditScenary: boolean = false;
  editingScenaryText: string = 'Escenario';
  editingScenaryColor: string = '#bae4ff';
  editingScenaryShowIcon: boolean = true;
  editingScenaryFontSize: number = 20;
  editingScenaryTextColor: string = '#000000';
  editingScenaryObject: any = null;
  @Input() blockedSeats: any[] = [];
  bookedSeats: any[] = [];
  bookedSeatsShowed: boolean = true;

  @Input() selectedSession!: number;

  // Pedido al que pertenece cada butaca ocupada (indexado por id_seat). Al editar un
  // evento, al hacer hover sobre una butaca ocupada se muestra la info de su pedido.
  @Input() seatsOrders: { [id: number]: any } = {};
  // Mapa id_channel → nombre del canal, para mostrar el canal del pedido en el tooltip.
  @Input() channelsMap: { [id: number]: string } = {};
  seatOrderTooltip: { visible: boolean; x: number; y: number; data: any } = {
    visible: false, x: 0, y: 0, data: null
  };
  // Resaltado (borde rosa) de las butacas del pedido bajo el puntero.
  private static readonly SEAT_HIGHLIGHT_COLOR = '#FF4D80';
  private highlightedOrderId: any = null;
  // Butacas resaltadas actualmente + su borde original para poder restaurarlo.
  private highlightedSeats: { circle: any; stroke: any; strokeWidth: any }[] = [];
  // Posición del puntero al pulsar, para distinguir click de arrastre (paneo) al abrir el pedido.
  private seatPointerDown: { x: number; y: number } | null = null;

  constructor(private dialog: MatDialog, private seatMapService: SeatMapService, private activatedRoute: ActivatedRoute,
    private location: Location, private router: Router, private areaSeatService: AreasSeatService, private auth: AuthenticationService,
    private apiEvents: EventosService, private apiVenues: PlacesService, private createEventService: CreateEventService,
    private generateMapService: GenerateMapService, private generateSeatsService: GenerateSeatsService,
    private ngZone: NgZone) { }

  // Etiqueta en español del estado del pedido para el tooltip de butaca ocupada.
  seatOrderStatusLabel(data: any): string {
    if (!data) {
      return '';
    }
    const labels: { [key: string]: string } = {
      completed: 'Completado',
      partial_refund: 'Reembolso parcial',
      refunded: 'Reembolsado',
      pending: 'Pendiente',
      processing: 'En proceso'
    };
    return labels[data.status_short] || data.status || '';
  }

  // Color del estado del pedido, igual que el listado de pedidos del panel (getColorStatus).
  seatOrderStatusColor(data: any): string {
    switch (data?.status_short) {
      case 'pending':
      case 'processing':
        return '#E9A41B';
      case 'paid':
      case 'completed':
        return '#2DAE29';
      case 'refund':
      case 'partial_refund':
        return '#13CDE2';
      default:
        return '#ff0000';
    }
  }

  // Nombre del canal del pedido para el tooltip (resuelto contra channelsMap).
  seatOrderChannelLabel(data: any): string {
    if (!data || data.id_channel == null) {
      return '';
    }
    return this.channelsMap[data.id_channel] || '';
  }

  // Muestra/actualiza/oculta el tooltip del pedido según la butaca ocupada bajo el puntero.
  private updateSeatOrderTooltip(e: any): void {
    // Sin datos de pedidos (evento no editado / sin ventas) no hay nada que mostrar.
    if (!this.seatsOrders || Object.keys(this.seatsOrders).length === 0) {
      if (this.seatOrderTooltip.visible) { this.hideSeatOrderTooltip(); }
      return;
    }
    const elementSeat = this.resolveHoveredSeat(e);
    const data = elementSeat && elementSeat.id != null ? this.seatsOrders[elementSeat.id] : null;
    if (data && e && e.e) {
      this.seatOrderTooltip = {
        visible: true,
        x: (e.e as MouseEvent).offsetX,
        y: (e.e as MouseEvent).offsetY,
        data
      };
      // Resaltar (borde rosa) todas las butacas del mismo pedido. Solo se recalcula
      // cuando cambia el pedido bajo el puntero, no en cada movimiento.
      if (data.order_id !== this.highlightedOrderId) {
        this.clearSeatHighlight();
        this.applySeatHighlight(data.order_id);
        this.highlightedOrderId = data.order_id;
      }
      // Fabric fija el cursor en _setCursorFromEvent antes de disparar 'mouse:move',
      // así que aquí (después) podemos forzar el pointer sobre la butaca ocupada.
      this.canvas.setCursor('pointer');
    } else if (this.seatOrderTooltip.visible || this.highlightedSeats.length > 0) {
      this.hideSeatOrderTooltip();
      this.clearSeatHighlight();
    }
  }

  private hideSeatOrderTooltip(): void {
    this.seatOrderTooltip = { visible: false, x: 0, y: 0, data: null };
  }

  // Pone el borde rosa a todas las butacas cuyo pedido sea `orderId`.
  private applySeatHighlight(orderId: any): void {
    if (orderId == null || !this.seatsOrders) {
      return;
    }
    // Ids de butaca que pertenecen a ese pedido.
    const seatIds = new Set<string>();
    Object.keys(this.seatsOrders).forEach(seatId => {
      if (this.seatsOrders[seatId]?.order_id === orderId) {
        seatIds.add(String(seatId));
      }
    });
    if (seatIds.size === 0) {
      return;
    }
    this.forEachSeatObject(seat => {
      if (seat.id == null || !seatIds.has(String(seat.id))) {
        return;
      }
      const circle = seat._objects?.find((o: any) => o.type != 'text');
      if (!circle) {
        return;
      }
      this.highlightedSeats.push({ circle, stroke: circle.stroke, strokeWidth: circle.strokeWidth });
      circle.set({ stroke: GenerateCanvasComponent.SEAT_HIGHLIGHT_COLOR, strokeWidth: 6 });
      seat.dirty = true;
    });
    if (this.highlightedSeats.length > 0) {
      this.canvas.renderAll();
    }
  }

  // Restaura el borde original de las butacas resaltadas.
  private clearSeatHighlight(): void {
    if (this.highlightedSeats.length === 0) {
      this.highlightedOrderId = null;
      return;
    }
    this.highlightedSeats.forEach(({ circle, stroke, strokeWidth }) => {
      circle.set({ stroke, strokeWidth });
    });
    this.highlightedSeats = [];
    this.highlightedOrderId = null;
    this.canvas?.renderAll();
  }

  // Devuelve la info de pedido de la butaca sobre la que se ha hecho click (sin arrastre),
  // o null si no es una butaca ocupada o si el gesto fue un paneo.
  private getClickedSeatOrder(e: any): any {
    if (!this.seatsOrders || Object.keys(this.seatsOrders).length === 0) {
      return null;
    }
    // Descartar arrastres (paneo): si el puntero se movió más de unos pocos px, no es click.
    if (this.seatPointerDown && e && e.e) {
      const dx = (e.e as MouseEvent).clientX - this.seatPointerDown.x;
      const dy = (e.e as MouseEvent).clientY - this.seatPointerDown.y;
      if (Math.hypot(dx, dy) > 5) {
        return null;
      }
    }
    const elementSeat = this.resolveHoveredSeat(e);
    return elementSeat && elementSeat.id != null ? this.seatsOrders[elementSeat.id] : null;
  }

  // Abre el detalle del pedido en una pestaña nueva (no se pierde la edición del evento).
  private openSeatOrder(orderId: any): void {
    if (orderId == null) {
      return;
    }
    const url = `/panel-control/orders/detail/info-order?search=${orderId}`;
    window.open(url, '_blank');
  }

  // Recorre todas las butacas (objetos fabric con eventSeat) del canvas.
  private forEachSeatObject(cb: (seat: any) => void): void {
    const walk = (objs: any[]) => {
      (objs || []).forEach(o => {
        if (o.eventSeat) {
          cb(o);
        }
        if (o._objects && o._objects.length) {
          walk(o._objects);
        }
      });
    };
    walk(this.canvas.getObjects());
  }

  // Resuelve la butaca (subtarget) bajo el puntero, replicando la detección usada en
  // mouse:down. Devuelve el objeto fabric de la butaca o null si no hay ninguna.
  private resolveHoveredSeat(e: any): any {
    if (!e || !e.target) {
      return null;
    }
    if (e.target.eventSeat) {
      return e.target;
    }
    if (e.target.groupSeat && e.subTargets && e.subTargets.length > 0) {
      return e.subTargets[0];
    }
    return null;
  }

  ngOnInit(): void {
    // Limpiar estado anterior del service para evitar que datos de sesiones previas se pinten
    this.generateMapService.resetState();

    // ngOnChanges fires before ngOnInit, so blocked seats set there are wiped by resetState — restore them
    if (this.blockedSeats?.length > 0) {
      this.generateMapService.setBlockedSeats(this.blockedSeats);
      this.hiddenTypes = this.blockedSeats;
    }

    // Si está en modo edición y es superadmin, pasar la bandera al servicio
    this.isSuperAdminEditMode = !!(this.allowCreate && this.isSuperAdmin);
    this.subscribeSaveBtn = this.seatMapService.saveEvent.subscribe({ next: (event: any) => { if (event) { this.save(); } } })
    let subcribe = this.activatedRoute.params.subscribe({
      next: () => {
        params => {
          this.privateMap = params.newLok ? true : false;
        }
      }
    });

    // const res = JSON.parse(localStorage.getItem('map_event_res') || '{}');
    // this.mapSaved = this.generateMapService.convertMapOldToNew(res);

    if (this.mapSaved) {
      // Los niveles son obligatorios
      const levels = this.mapSaved.levels;
        this.generateMapService.setLevelsMap(levels);

      // Flag de navegación por zonas (mapas sin zonas no lo traen → false).
      // Se soporta camelCase (zoneNavigation) y snake_case (zone_navigation).
      // Si el flag está apagado pero ya existen objetos en la preview, activarlo igualmente
      // (puede ocurrir si el guardado anterior calculó false por no haber secciones asignadas).
      const previewRaw = this.mapSaved.navPreview || this.mapSaved.map_nav_preview || [];
      this.zoneNavigation = !!(this.mapSaved.zoneNavigation || this.mapSaved.zone_navigation) || previewRaw.length > 0;
      this.generateMapService.setZoneNavigation(this.zoneNavigation);

      // Configuración de la leyenda (mapas antiguos no la traen → null → leyenda por defecto).
      // Se soporta camelCase (legendConfig) y snake_case (legend_config) por el round-trip del editor.
      this.generateMapService.setLegendConfig(this.mapSaved.legendConfig || this.mapSaved.legend_config || null);

      // Escena de butacas (configuration[]) + escena del plano general de zonas (navPreview).
      // La preview es un dibujo libre independiente: cada objeto se marca con previewLayer:true
      // para distinguirlo de las butacas y poder alternarlo con el switch del editor.
      const configuration = this.mapSaved.configuration || [];
      const previewObjects = previewRaw.map((o: any) => ({
        ...o,
        configuration: { ...(o.configuration || {}), previewLayer: true }
      }));
      const allObjects = [...configuration, ...previewObjects];
      if (allObjects.length > 0) {
        const canvasObjects = this.convertArrayToKeyValueObject(allObjects);
        this.generateMapService.setObjectsMap(canvasObjects);
      }

      // ✅ Agrupar secciones y asientos desde mapSaved
      if (this.mapSaved.sections && this.mapSaved.seats) {
        const seatSections = this.groupSectionsAndSeats(this.mapSaved.sections, this.mapSaved.seats);
        this.generateMapService.setSeatSections(seatSections);
      }

      // @Input blockedSeats has full objects (name/color/code/id_seats) and takes priority.
      // mapSaved.blocked_seats from the public endpoint is a flat array of seat IDs used only
      // for coloring — using it as hiddenTypes corrupts the blocked-seats UI.
      if (this.blockedSeats?.length > 0) {
        this.generateMapService.setBlockedSeats(this.blockedSeats);
      } else if (this.mapSaved.blocked_seats) {
        this.generateMapService.setBlockedSeats(this.mapSaved.blocked_seats);
        this.hiddenTypes = this.mapSaved.blocked_seats;
      }

      if (this.mapSaved.booked_seats) {
        this.generateMapService.setBookedSeats(this.mapSaved.booked_seats);
        this.bookedSeats = this.mapSaved.booked_seats;
      }
    } else {
      // Cargar seatSections desde localStorage al iniciar el componente
      // const seatLocalStorage = localStorage.getItem('seatSection');
      // this.generateMapService.setSeatSections(seatLocalStorage ? JSON.parse(seatLocalStorage) : {});

      // // Cargar otros datos del mapa desde localStorage
      // const objectsStorage = localStorage.getItem('canvasObjects');
      // this.generateMapService.setObjectsMap(objectsStorage ? JSON.parse(objectsStorage) : {});

      // // Cargar niveles y tipos de asiento ocultos
      // const levelsStorage = localStorage.getItem('seatLevels');
      // this.generateMapService.setLevelsMap(levelsStorage ? JSON.parse(levelsStorage) : []);

      // const blockedStorage = localStorage.getItem('blockedSeats');
      // this.generateMapService.setBlockedSeats(blockedStorage ? JSON.parse(blockedStorage) : []);
    }
    // Pintar mapa de localstorage
    this.loadSectionsFromStorage();
  }

  toggleOffcanvas() {
    this.isOffCanvasOpen = !this.isOffCanvasOpen;
  }

  getDataCanvas(mapSaved: any) {
    if (this.mapSaved.blocked_seats) {
      this.generateMapService.setBlockedSeats(this.mapSaved.blocked_seats);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blockedSeats']) {
      this.generateMapService.setBlockedSeats(this.blockedSeats);
      this.hiddenTypes = this.generateMapService.getBlockedSeats();
      // If map is already rendered, apply colors immediately
      if (this.loadedMap && this.canvas) {
        this.canvasColorHidden(this.bookedSeatsShowed);
      }
    }

    if (changes['mapSaved'] && this.mapSaved && this.loadedMap) {
      this.bookedSeats = this.mapSaved.booked_seats;
      this.generateMapService.setBookedSeats(this.bookedSeats);
      this.canvasColorHidden(this.bookedSeatsShowed);
    }

    if (changes['allowCreate'] && this.canvas) {
      this.isSuperAdminEditMode = !!(this.allowCreate && this.isSuperAdmin);
      if (this.isSuperAdminEditMode) {
        this.canvas._objects?.forEach((obj: any) => {
          if (obj.groupSeat || obj.objectId || obj.isInfoSection || obj.isScenary || obj.isSection) {
            obj.set({
              selectable: true,
              evented: true,
              lockMovementX: false,
              lockMovementY: false,
              lockRotation: false,
              lockScalingX: false,
              lockScalingY: false,
              lockScalingFlip: false,
              hasControls: true,
              hasBorders: true,
              hoverCursor: 'move',
            });
          }
        });
      } else {
        this.canvas._objects?.forEach((obj: any) => {
          obj.set({ selectable: false, evented: false });
        });
        this.clearedObjectSelect();
      }
      this.canvas.renderAll();
    }
  }

  showBookedSeats(show: boolean) {
    this.bookedSeatsShowed = show;
    this.canvasColorHidden(show);
    // this.generateSeatsService.setShowBookedSeats(show);
  }

  // ✅ Método para convertir array a objeto de clave-valor
  convertArrayToKeyValueObject(configurationArray: any[]): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    if (Array.isArray(configurationArray)) {
      configurationArray.forEach(item => {
        // Nuevo formato: { id: "obj_1", type: "text", configuration: {...} }
        if (item.id && item.type !== undefined) {
          result[item.id] = item;
        } else {
          // Formato legacy: { "obj_1": {...} }
          const keys = Object.keys(item);
          if (keys.length > 0) {
            const key = keys[0];
            result[key] = item[key];
          }
        }
      });
    }

    return result;
  }

  // ✅ Método para agrupar secciones y asientos (si es necesario)
  groupSectionsAndSeats(sections: any[], seats: any[]): any {
    const seatSections: any = {};

    sections.forEach(section => {
      // Soporte para id_section (API legacy) y id (payload guardado)
      const sectionId = section.id_section ?? section.id;
      // Filtrar asientos que pertenecen a esta sección (por id local o por id de bbdd)
      const sectionSeats = seats.filter(seat => +seat.section === +sectionId || +seat.section === +section.id);
      const sectionObject = {
        id: sectionId,
        name: section.name,
        seats: sectionSeats.length,
        color: section.color,
        columns: section.configuration?.seatsGroupConfig?.columns ?? section.columns,
        rows: section.configuration?.seatsGroupConfig?.rows ?? section.rows,
        level: section.level != null ? +section.level : (section.id_level != null ? +section.id_level : null),
        configuration: section.configuration,
        id_bbdd: section.id
      };

      seatSections[sectionId] = {
        section: sectionObject,
        elements: sectionSeats
      };
    });

    return seatSections;
  }

  openLevelsMap() {
    this.openInitialSectionsDialog(false);
  }

  openLegendConfig() {
    const dialogRef = this.dialog.open(LegendConfigComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      data: {
        legendConfig: this.generateMapService.getLegendConfig(),
        levels: this.generateMapService.getLevelsMap(),
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result || !result.confirmed) {
        return;
      }
      // legendConfig puede ser null (restablecer) o el objeto configurado.
      this.generateMapService.setLegendConfig(result.legendConfig);
    });
  }

  loadSectionsFromStorage() {
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        this.seatSections = storedSections;

        // Actualizar el número de sección para que sea mayor que las existentes
        const sectionIds = Object.keys(this.seatSections).map(id => parseInt(id));
        if (sectionIds.length > 0) {
          this.sectionNumber = Math.max(...sectionIds) + 1;
        }
      } catch (error) {
        this.seatSections = {};
      }
    }

    // ✅ Cargar otros objetos del canvas (escenarios, etc.)
    const storedObjects = this.generateMapService.getObjectsMap();
    if (storedObjects) {
      try {
        this.canvasObjects = storedObjects;

        // Actualizar el contador de objetos
        const objectIds = Object.keys(this.canvasObjects).map(id => {
          // Buscar números en el ID usando regex
          const match = id.match(/(\d+)$/); // Busca números al final del string
          return match ? parseInt(match[1]) : 0;
        }).filter(num => num > 0); // Filtrar números válidos

        if (objectIds.length > 0) {
          this.objectIdCounter = Math.max(...objectIds) + 1;
        }
      } catch (error) {
        this.canvasObjects = {};
      }
    }

    this.levels = this.generateMapService.getLevelsMap();
    this.refreshLevelsList();
    this.hiddenTypes = this.generateMapService.getBlockedSeats();
    // console.log(this.hiddenTypes);
  }

  // Nuevo método para recrear las secciones en el canvas desde localStorage
  async recreateSectionsFromStorage() {
    await this.recreateAllLayers();
    this.applyHiddenLayerState();

    this.loadedMap = true;
    this.canvas.renderAll();

    // Apply blocked seat colors after map is fully rendered
    if (this.hiddenTypes?.length > 0) {
      this.canvasColorHidden(this.bookedSeatsShowed);
    }

    if (this.isViewOnly) {
      this.canvas.hoverCursor = 'default';
      this.canvas._objects?.forEach((obj: any) => {
        obj.hoverCursor = 'default';
        if (obj._objects) {
          obj._objects.forEach((child: any) => { child.hoverCursor = 'default'; });
        }
      });
    }
  }

  // Recrea todos los elementos (formas/texto/escenario/imagen de canvasObjects + secciones de
  // butacas de seatSections) en un único orden combinado, respetando el zIndex guardado en
  // `configuration.zIndex` de cada uno (el panel de Capas lo mantiene al día). Los elementos
  // que aún no tengan zIndex (mapas antiguos) caen al orden clásico: formas/objetos primero,
  // secciones de butacas después. Se crean de forma SECUENCIAL (await uno a uno) porque el
  // escenario y las imágenes se cargan de forma asíncrona (SVG/imagen): si no se esperan,
  // siempre terminan añadiéndose al canvas los últimos, por encima de todo lo demás,
  // independientemente del orden guardado.
  private async recreateAllLayers() {
    const layerEntries: { kind: 'object' | 'section'; key: string; zIndex: number }[] = [];

    const objectKeys = Object.keys(this.canvasObjects);
    objectKeys.forEach((key, idx) => {
      const zi = this.canvasObjects[key]?.configuration?.zIndex;
      layerEntries.push({ kind: 'object', key, zIndex: zi != null ? zi : idx });
    });

    const sectionKeys = Object.keys(this.seatSections);
    sectionKeys.forEach((key, idx) => {
      const zi = this.seatSections[+key]?.section?.configuration?.zIndex;
      layerEntries.push({ kind: 'section', key, zIndex: zi != null ? zi : objectKeys.length + idx });
    });

    layerEntries.sort((a, b) => a.zIndex - b.zIndex);

    for (const entry of layerEntries) {
      if (entry.kind === 'object') {
        const objectData = this.canvasObjects[entry.key];
        if (objectData) {
          await this.createObjectFromData(objectData);
        }
      } else {
        const sectionData = this.seatSections[+entry.key];
        if (sectionData) {
          this.createSectionFromData(sectionData, +entry.key);
        }
      }
    }
  }

  // ✅ Método para crear objetos desde datos guardados
  async createObjectFromData(objectData: any) {
    const { type, configuration, id } = objectData;
    // Asegurar que objectId siempre esté propagado desde el id del entry del canvasObjects
    const configWithId = { ...configuration, objectId: configuration?.objectId || id };
    // Devuelve el objeto fabric creado (para los tipos síncronos) por si el llamador necesita
    // reseleccionarlo (p. ej. duplicar en bloque).
    switch (type) {
      case 'scenary':
        await this.recreateScenary(configWithId, this.isSuperAdminEditMode);
        return null;
      case 'polygon':
        return this.recreatePolygon(configWithId, this.isSuperAdminEditMode);
      case 'rect':
        return this.recreateRect(configWithId, this.isSuperAdminEditMode);
      case 'ellipse':
        return this.recreateEllipse(configWithId, this.isSuperAdminEditMode);
      case 'line':
        return this.recreateLine(configWithId, this.isSuperAdminEditMode);
      case 'standSection':
        await this.recreateStandSection(configWithId, this.isSuperAdminEditMode);
        return null;
      case 'text':
        return this.recreateText(configWithId, this.isSuperAdminEditMode);
      case 'groupCircles':
        this.createCircleInfo(configWithId, this.isSuperAdminEditMode);
        return null;
      case 'image':
      case 'svg':
        await this.recreateImage(configWithId, this.isSuperAdminEditMode);
        return null;
      default:
        console.warn('Tipo de objeto no reconocido:', type);
        return null;
    }
  }

  // ✅ Métodos para recrear cada tipo de objeto
  async recreateScenary(config: any, unlock = false) {
    const obj = await this.generateMapService.createScenary(
      this.canvas,
      config.fill || this.colorDefaultStage,
      this.screenElement,
      config, // Pasar toda la configuración guardada
      this.fromEvent,
      unlock
    );
    // El escenario se crea de forma asíncrona (carga el SVG), así que puede añadirse al canvas
    // DESPUÉS de applyMapModeVisibility(). Por eso fija aquí su propia visibilidad según la
    // escena activa para no quedar visible en el modo equivocado tras recargar.
    if (obj?.group) {
      const isPreview = !!config?.previewLayer;
      obj.group.set('previewLayer', isPreview);
      obj.group.visible = isPreview ? (this.mapMode === 'zones') : (this.mapMode === 'seats');
    }
    if (obj && obj.group) {
      this.canvas.renderAll();
    }
  }

  recreatePolygon(config: any, unlock = false) {
    let polygon = this.generateMapService.addPoligonObject(config);
    // Restaurar metadatos de la capa preview (zona del plano general) para re-serializar igual.
    if (config?.previewLayer) {
      const rawNavZoneLevels: number[] = Array.isArray(config.levels) ? config.levels : [];
      const navZoneLevels = this.levels?.length > 0
        ? rawNavZoneLevels.map((id: number) => {
            const byId = this.levels.find((l: any) => +l.id === +id);
            if (byId) return +byId.id;
            const byIdLevel = this.levels.find((l: any) => l.id_level != null && +l.id_level === +id);
            if (byIdLevel) return +byIdLevel.id;
            const byOrderBuy = this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +id);
            if (byOrderBuy) return +byOrderBuy.id;
            return +id;
          })
        : rawNavZoneLevels;
      polygon.set({ previewLayer: true, name: config.name ?? null, labelFontSize: config.labelFontSize ?? 40, labelAngle: config.labelAngle ?? 0, navZoneLevels, hideLabel: config.hideLabel ?? false, navZoneShapes: Array.isArray(config.navZoneShapes) ? config.navZoneShapes : [] });
      // Persistir los IDs normalizados para que el próximo save ya tenga los IDs correctos.
      if (config.objectId && this.canvasObjects[config.objectId]) {
        this.canvasObjects[config.objectId].configuration.levels = navZoneLevels;
      }
    }
    // Normalizar referencia de nivel: el id guardado puede no coincidir con los niveles actuales
    // porque el backend crea nuevos IDs de BD en cada versión del mapa.
    // Estrategia: 1) buscar por id directo, 2) por levelOrderBuy anotado al guardar,
    // 3) por orderBuy igual al level (compatibilidad con IDs temporales de primera creación).
    if (polygon.level != null && this.levels?.length > 0) {
      const objId = config.objectId;
      const byId = this.levels.find((l: any) => +l.id === +polygon.level);
      const byIdLevel = !byId ? this.levels.find((l: any) => l.id_level != null && +l.id_level === +polygon.level) : null;
      const byAnnotatedOrderBuy = !byIdLevel && config.levelOrderBuy != null
        ? this.levels.find((l: any) => +l.orderBuy === +config.levelOrderBuy)
        : null;
      const byOrderBuy = !byIdLevel && !byAnnotatedOrderBuy
        ? this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +polygon.level)
        : null;
      const found = byId || byIdLevel || byAnnotatedOrderBuy || byOrderBuy;
      if (found && !byId) {
        polygon.set('level', +found.id);
        if (objId && this.canvasObjects[objId]) {
          this.canvasObjects[objId].configuration.level = +found.id;
        }
      } else if (byId && objId && this.canvasObjects[objId]) {
        this.canvasObjects[objId].configuration.level = +byId.id;
      }
    }
    if (this.idEvent) {
      polygon = this.generateMapService.limitObjectMovement(polygon);
    }
    if (unlock && polygon) {
      polygon.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    } else if (polygon) {
      polygon.set({ selectable: false, evented: false, hoverCursor: 'default' });
    }
    this.canvas.add(polygon);
    if (config?.previewLayer && config?.name && !config?.hideLabel) {
      this.syncZoneLabel(polygon);
    }
    this.canvas.renderAll();
    return polygon;
  }

  recreateRect(config: any, unlock = false) {
    let rect = this.generateMapService.addRectObject(config);
    // Restaurar metadatos de la capa preview (zona del plano general) para re-serializar igual.
    if (config?.previewLayer) {
      const rawNavZoneLevels: number[] = Array.isArray(config.levels) ? config.levels : [];
      const navZoneLevels = this.levels?.length > 0
        ? rawNavZoneLevels.map((id: number) => {
            const byId = this.levels.find((l: any) => +l.id === +id);
            if (byId) return +byId.id;
            const byIdLevel = this.levels.find((l: any) => l.id_level != null && +l.id_level === +id);
            if (byIdLevel) return +byIdLevel.id;
            const byOrderBuy = this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +id);
            if (byOrderBuy) return +byOrderBuy.id;
            return +id;
          })
        : rawNavZoneLevels;
      rect.set({ previewLayer: true, name: config.name ?? null, labelFontSize: config.labelFontSize ?? 40, labelAngle: config.labelAngle ?? 0, navZoneLevels, hideLabel: config.hideLabel ?? false, navZoneShapes: Array.isArray(config.navZoneShapes) ? config.navZoneShapes : [] });
      if (config.objectId && this.canvasObjects[config.objectId]) {
        this.canvasObjects[config.objectId].configuration.levels = navZoneLevels;
      }
    }
    // Normalizar referencia de nivel (mismo criterio que recreatePolygon)
    if (rect.level != null && this.levels?.length > 0) {
      const objId = config.objectId;
      const byId = this.levels.find((l: any) => +l.id === +rect.level);
      const byIdLevel = !byId ? this.levels.find((l: any) => l.id_level != null && +l.id_level === +rect.level) : null;
      const byAnnotatedOrderBuy = !byIdLevel && config.levelOrderBuy != null
        ? this.levels.find((l: any) => +l.orderBuy === +config.levelOrderBuy)
        : null;
      const byOrderBuy = !byIdLevel && !byAnnotatedOrderBuy
        ? this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +rect.level)
        : null;
      const found = byId || byIdLevel || byAnnotatedOrderBuy || byOrderBuy;
      if (found && !byId) {
        rect.set('level', +found.id);
        if (objId && this.canvasObjects[objId]) {
          this.canvasObjects[objId].configuration.level = +found.id;
        }
      } else if (byId && objId && this.canvasObjects[objId]) {
        this.canvasObjects[objId].configuration.level = +byId.id;
      }
    }
    if (this.idEvent) {
      rect = this.generateMapService.limitObjectMovement(rect);
    }
    if (unlock && rect) {
      rect.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    } else if (rect) {
      rect.set({ selectable: false, evented: false, hoverCursor: 'default' });
    }
    this.canvas.add(rect);
    if (config?.previewLayer && config?.name && !config?.hideLabel) {
      this.syncZoneLabel(rect);
    }
    this.canvas.renderAll();
    return rect;
  }

  recreateEllipse(config: any, unlock = false) {
    let ellipse = this.generateMapService.addEllipseObject(config);
    // Restaurar metadatos de la capa preview (zona del plano general) para re-serializar igual.
    if (config?.previewLayer) {
      ellipse.set({ previewLayer: true, name: config.name ?? null, labelFontSize: config.labelFontSize ?? 40, labelAngle: config.labelAngle ?? 0, navZoneSections: Array.isArray(config.sections) ? config.sections : [], hideLabel: config.hideLabel ?? false, navZoneShapes: Array.isArray(config.navZoneShapes) ? config.navZoneShapes : [] });
    }
    // Normalizar referencia de nivel (mismo criterio que recreateRect/recreatePolygon)
    if (ellipse.level != null && this.levels?.length > 0) {
      const objId = config.objectId;
      const byId = this.levels.find((l: any) => +l.id === +ellipse.level);
      const byIdLevel = !byId ? this.levels.find((l: any) => l.id_level != null && +l.id_level === +ellipse.level) : null;
      const byAnnotatedOrderBuy = !byIdLevel && config.levelOrderBuy != null
        ? this.levels.find((l: any) => +l.orderBuy === +config.levelOrderBuy)
        : null;
      const byOrderBuy = !byIdLevel && !byAnnotatedOrderBuy
        ? this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +ellipse.level)
        : null;
      const found = byId || byIdLevel || byAnnotatedOrderBuy || byOrderBuy;
      if (found && !byId) {
        ellipse.set('level', +found.id);
        if (objId && this.canvasObjects[objId]) {
          this.canvasObjects[objId].configuration.level = +found.id;
        }
      } else if (byId && objId && this.canvasObjects[objId]) {
        this.canvasObjects[objId].configuration.level = +byId.id;
      }
    }
    if (this.idEvent) {
      ellipse = this.generateMapService.limitObjectMovement(ellipse);
    }
    if (unlock && ellipse) {
      ellipse.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    } else if (ellipse) {
      ellipse.set({ selectable: false, evented: false, hoverCursor: 'default' });
    }
    this.canvas.add(ellipse);
    if (config?.previewLayer && config?.name && !config?.hideLabel) {
      this.syncZoneLabel(ellipse);
    }
    this.canvas.renderAll();
    return ellipse;
  }

  // Recrea tanto imágenes rasterizadas (configuration.src, data-url) como SVG vectoriales
  // (configuration.svg, markup). Comparten todo el resto del tratamiento: niveles, bloqueo,
  // capa de zonas y visibilidad por modo.
  async recreateImage(config: any, unlock = false) {
    if (!config?.src && !config?.svg) return null;
    let img = config.svg
      ? await this.generateMapService.addSvgObject(config.svg, config)
      : await this.generateMapService.addImageObject(config.src, config);
    if (!img) return null;
    // Normalizar referencia de nivel (mismo criterio que recreateRect/recreateEllipse)
    if (img.level != null && this.levels?.length > 0) {
      const objId = config.objectId;
      const byId = this.levels.find((l: any) => +l.id === +img.level);
      const byIdLevel = !byId ? this.levels.find((l: any) => l.id_level != null && +l.id_level === +img.level) : null;
      const byAnnotatedOrderBuy = !byIdLevel && config.levelOrderBuy != null
        ? this.levels.find((l: any) => +l.orderBuy === +config.levelOrderBuy)
        : null;
      const byOrderBuy = !byIdLevel && !byAnnotatedOrderBuy
        ? this.levels.find((l: any) => l.orderBuy != null && +l.orderBuy === +img.level)
        : null;
      const found = byId || byIdLevel || byAnnotatedOrderBuy || byOrderBuy;
      if (found && !byId) {
        img.set('level', +found.id);
        if (objId && this.canvasObjects[objId]) {
          this.canvasObjects[objId].configuration.level = +found.id;
        }
      } else if (byId && objId && this.canvasObjects[objId]) {
        this.canvasObjects[objId].configuration.level = +byId.id;
      }
    }
    if (this.idEvent) {
      img = this.generateMapService.limitObjectMovement(img);
    }
    if (unlock && img) {
      img.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    } else if (img) {
      img.set({ selectable: false, evented: false, hoverCursor: 'default' });
    }
    if (config?.previewLayer) {
      img.set('previewLayer', true);
      img.visible = this.mapMode === 'zones';
    } else if (this.mapMode) {
      img.visible = this.mapMode === 'seats';
    }
    this.canvas.add(img);
    this.canvas.renderAll();
    return img;
  }

  recreateLine(config: any, unlock = false) {
    let line = this.generateMapService.addLineObject(config);
    if (config?.previewLayer) {
      line.set({ previewLayer: true, name: config.name ?? null, navZoneSections: Array.isArray(config.sections) ? config.sections : [], navZoneShapes: Array.isArray(config.navZoneShapes) ? config.navZoneShapes : [] });
    }
    if (this.idEvent) {
      line = this.generateMapService.limitObjectMovement(line);
    }
    if (unlock && line) {
      line.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    } else if (line) {
      line.set({ selectable: false, evented: false, hoverCursor: 'default' });
    }
    this.canvas.add(line);
    this.canvas.renderAll();
    return line;
  }

  recreateStandSection(config: any, unlock = false): Promise<any> {
    return this.recreateGroupInfo(this.shoesElement, config.text || 'Pista', config.color || this.colorDefaultStand, 'Capacidad', config, unlock);
  }

  recreateGroupInfo(icon: string, text: string, color: any, subtitle: string, config: any, unlock = false): Promise<any> {
    const rectangle = this.generateMapService.createRect(color, 300, 150);
    const textComponent = this.generateMapService.createTextComponent(text, 18, -30);
    let elements = [rectangle, textComponent];

    if (subtitle) {
      const textCapacity = this.generateMapService.createTextComponent(subtitle, 16, 40);
      elements.push(textCapacity);
    }

    var canvas = this.canvas;
    const self = this;
    return new Promise((resolve) => {
      fabric.loadSVGFromURL(icon, function (objects: any, options: any) {
        var obj = fabric.util.groupSVGElements(objects, options);
        obj.set({ top: -5, scaleX: 0.05, scaleY: 0.05, originX: 'center', hasControls: false });
        elements.push(obj);

        var group = new fabric.Group(elements, {
          left: config.left,
          top: config.top,
          width: 300,
          height: 150,
          scaleX: config.scaleX || 1,
          scaleY: config.scaleY || 1,
          angle: config.angle || 0,
          capacity: config.capacity || 50,
          lockRotation: true,
          eventSeat: true,
          isSection: true,
          section: config.section,
          objectId: config.objectId
        });
        if (self.idEvent) {
          group = self.generateMapService.limitObjectMovement(group);
        }
        if (unlock && group) {
          group.set({
            lockMovementX: false,
            lockMovementY: false,
            lockRotation: false,
            lockScalingFlip: false,
            lockScalingY: false,
            lockScalingX: false,
            hasControls: true,
            selectable: true,
            evented: true,
            hasBorders: true,
            hoverCursor: 'move',
          });
        } else {
          group.set({ selectable: false, evented: false, hoverCursor: 'default' });
        }
        group.setControlVisible('mtr', false);
        canvas.add(group);
        canvas.renderAll();
        resolve(group);
      });
    });
  }

  recreateText(config: any, unlock = false) {
    let text = new fabric.Textbox(config.text || 'Escribe un texto...', {
      width: config.width || 200,
      height: config.height || 100,
      fontSize: config.fontSize || 24,
      lineHeight: config.lineHeight || 1,
      fontFamily: config.fontFamily || 'Satoshi-Regular',
      fill: config.fill || '#000000',
      cursorColor: config.cursorColor || '#FF4D80',
      left: config.left,
      top: config.top,
      scaleX: config.scaleX || 1,
      scaleY: config.scaleY || 1,
      angle: config.angle || 0,
      eventSeat: false,
      objectId: config.objectId,
      hasControls: false,
      subTargetCheck: true,
      perPixelTargetFind: true,
      lockMovementY: !unlock,
      lockMovementX: !unlock,
      lockRotation: !unlock,
      lockScalingFlip: !unlock,
      lockScalingY: !unlock,
      lockScalingX: !unlock,
      hoverCursor: unlock ? 'move' : 'pointer',
      hasBorders: unlock ? true : false,
      selectable: unlock,
      evented: unlock,
    });
    if (config?.previewLayer) {
      (text as any).set('previewLayer', true);
    }
    if (this.idEvent) {
      text = this.generateMapService.limitObjectMovement(text);
    }
    this.canvas.add(text);
    this.canvas.renderAll();
    return text;
  }

  // Método para crear una sección desde los datos guardados
  createSectionFromData(sectionData: any, sectionKey?: any) {
    const { section, elements } = sectionData;
    if (!section.rows || !section.columns) {
      console.warn('[createSectionFromData] Sección sin rows/columns, ignorando:', section.id, section);
      return;
    }
    let { mainGroup, sectionObject } = this.generateMapService.addGroupSeats(section.rows, section.columns, this.sectionNumber, sectionData, this.isSuperAdminEditMode, [], this.isSuperAdminEditMode);
    if (section.level != null) {
      mainGroup.set('area', +section.level);
    }
    // Etiquetar el grupo con su clave en seatSections para poder duplicarlo de forma fiable
    // (la id interna del grupo puede no coincidir con la clave en mapas cargados).
    mainGroup.sectionKey = sectionKey != null ? sectionKey : section?.id;
    this.canvas.add(mainGroup);
    this.canvas.renderAll();
  }

  createCircleInfo(sectionData: any, unlock = false) {
    let mainGroup = this.generateMapService.addGroupNumbers(sectionData.rows, sectionData.columns, sectionData, this.fromEvent || this.fromVenue);
    if (this.idEvent) {
      mainGroup = this.generateMapService.limitObjectMovement(mainGroup);
    }
    if (unlock && mainGroup) {
      mainGroup.set({
        lockMovementX: false,
        lockMovementY: false,
        lockRotation: false,
        lockScalingFlip: false,
        lockScalingY: false,
        lockScalingX: false,
        hasControls: true,
        selectable: true,
        evented: true,
        hasBorders: true,
        hoverCursor: 'move',
      });
    }
    this.canvas.add(mainGroup);
    this.canvas.renderAll();
  }

  openSelect(): void {
    const dialogRef = this.dialog.open(SelectTypeComponent, {
      panelClass: ['info-dialog', 'not-padding'],

    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  async ngAfterViewInit(): Promise<void> {
    this.canvas = new fabric.Canvas('myCanvas', {
      backgroundColor: '#fff',
      selection: false,
    });
    this.isSuperAdmin = this.auth.isSuperAdmin();
    this.isSuperAdminEditMode = !!(this.allowCreate && this.isSuperAdmin);
    this.setupFileDropListeners();
    this.onResize();
    // Los escenarios e imágenes se crean de forma asíncrona (cargan SVG/imagen), así que hay que
    // esperar a que recreateSectionsFromStorage termine de recrear TODO antes de tocar
    // canvas._objects (controles de edición, visibilidad de escena…) o se perdería el orden y
    // la visibilidad de los elementos que aún no se hubieran añadido al canvas.
    await this.recreateSectionsFromStorage();
    this.canvas.renderAll();

    // Si estamos en modo edición, asegurar que todos los objetos tengan controles habilitados
    if (this.isSuperAdminEditMode) {
      this.canvas._objects?.forEach((obj: any) => {
        if (obj.userHiddenLayer) return;
        if (obj.groupSeat || obj.objectId || obj.isInfoSection || obj.isScenary || obj.isSection) {
          obj.set({
            selectable: true,
            evented: true,
            lockMovementX: false,
            lockMovementY: false,
            lockRotation: false,
            lockScalingX: false,
            lockScalingY: false,
            lockScalingFlip: false,
            hasControls: true,
            hasBorders: true,
            hoverCursor: 'move',
          });
        }
      });
      this.canvas.renderAll();
    }

    // Aplicar la escena activa (por defecto butacas): oculta la capa preview al cargar.
    this.applyMapModeVisibility();

    this.canvas.on('touch:gesture', e => {
      if (e.e.touches && e.e.touches.length == 2) {
        this.pausePanning = true;
        var point = new fabric.Point(e.self.x, e.self.y);
        if (e.self.state == "start") {
          this.zoomStartScale = this.canvas.getZoom();
        }
        var delta = this.zoomStartScale * e.self.scale;
        this.canvas.zoomToPoint(point, delta);
        this.output.push(`zoom`);
        this.pausePanning = false;
      }
    });

    this.canvas.on('selection:created', opt => {
      if (this.rebuildingSection) return;
      // El marcador del centro de curvatura no debe abrir/cerrar el panel de sección.
      if ((this.canvas as any)._pivotMode || (this.canvas as any)._pivotInternal || opt.selected?.[0]?.isCurvatureCenter) return;
      if (this.handleMultiSelection()) return;
      if (opt.selected?.length > 0) {
        const el = opt.selected[0];
        if ((el.isSection || el.groupSeat) && this.isSuperAdminEditMode) {
          el.set('hasControls', true);
          this.blockComponents = false;
          this.clickSelectObject(opt.selected[0]);
        } else if (el.isInfoSection && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectSection(opt.selected[0]);
        } else if (el.isScenary && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectScenary(opt.selected[0]);
        } else if ((el.type === 'textbox' || el.type === 'text') && el.objectId && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectText(opt.selected[0]);
        } else if ((el.type === 'image' || el.isSvgImage) && el.objectId && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectImage(opt.selected[0]);
        } else if (!this.blockComponents) {
          el.set('hasControls', true);
        }
      }
    })

    this.canvas.on('selection:updated', opt => {
      if (this.rebuildingSection) return;
      if ((this.canvas as any)._pivotMode || (this.canvas as any)._pivotInternal || opt.selected?.[0]?.isCurvatureCenter) return;
      if (this.handleMultiSelection()) return;
      if (opt.selected?.length > 0) {
        const el = opt.selected[0];
        if ((el.isSection || el.groupSeat) && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectObject(opt.selected[0]);
        } else if (el.isInfoSection && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.clickSelectSection(opt.selected[0]);
        } else if (el.isScenary && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.openEditScenary = false;
          this.clickSelectScenary(opt.selected[0]);
        } else if ((el.type === 'textbox' || el.type === 'text') && el.objectId && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.openEditText = false;
          this.clickSelectText(opt.selected[0]);
        } else if ((el.type === 'image' || el.isSvgImage) && el.objectId && this.isSuperAdminEditMode) {
          this.blockComponents = false;
          this.openEditImage = false;
          this.clickSelectImage(opt.selected[0]);
        } else if (!this.blockComponents) {
          this.clearedObjectSelect();
        }
      }
    })

    this.canvas.on('before:selection:cleared', opt => {
      this.beforeCleared = this.canvas.getActiveObject();
    })

    this.canvas.on('selection:cleared', opt => {
      if (this.rebuildingSection) return;
      // Solo ignorar el cleared transitorio de las transiciones internas del marcador (crear/quitar).
      // Un cleared real (clic en el fondo) SÍ debe cerrar el panel aunque el modo marcador siga activo.
      if ((this.canvas as any)._pivotInternal) return;
      // Excepción: al hacer clic en el mapa para recolocar el centro de curvatura, fabric deselecciona
      // el marcador. Ese cleared NO debe cerrar el panel de sección (el marcador se recoloca donde se
      // hizo clic; ver curvaturePlaceHandler en edit-section).
      if (opt.deselected?.some((o: any) => o.isCurvatureCenter)) return;
      // Al deseleccionar un bloque múltiple, fabric ya ha "desagrupado" la activeSelection y
      // restaurado en cada hijo sus left/top/scaleX/scaleY/angle absolutos definitivos (incluye
      // el redimensionado en bloque). Aprovechamos eso para persistir el estado final real,
      // en vez de intentar calcular deltas mientras seguía agrupado.
      if (this.beforeCleared?.type === 'activeSelection' && this.beforeCleared._objects?.length > 1) {
        this.persistGroupTransform(this.beforeCleared);
      }
      this.multiSelectionActive = false;
      // Si se deselecciona el recuadro de recorte (clic fuera), cancelar el modo recorte y
      // restaurar la imagen en lugar de dejarla semitransparente y no seleccionable.
      if (this.cropModeActive) {
        this.cancelCropImage();
        return;
      }
      if (opt.deselected?.length > 0 && this.openEditObject) {
        // Reset panel state without calling discardActiveObject() to avoid
        // cancelling any incoming selection when switching between sections
        this.openEditObject = false;
        this.openEditSection = false;
        this.openEditScenary = false;
        this.openEditText = false;
        this.openEditImage = false;
        this.editingScenaryObject = null;
        this.editingTextObject = null;
        this.editingImageObject = null;
        this.activeTab = false;
        this.blockComponents = false;
        this.selectedHidden = [];
        this.clearObjects();
      }
    })

    this.canvas.on('mouse:wheel', opt => {
      var delta = opt.e.deltaY;
      this.zoomMap(false, delta);
      opt.e.preventDefault();
      opt.e.stopPropagation();
    })

    this.canvas.on('mouse:down', e => {
      // Guardar posición inicial para distinguir un click de un arrastre (paneo).
      this.seatPointerDown = e.e ? { x: (e.e as MouseEvent).clientX, y: (e.e as MouseEvent).clientY } : null;

      if (e.target && (e.target.eventSeat || e.target.groupSeat && e.subTargets.length > 0)) {
        let elementSeat = e.target.groupSeat ? e.subTargets[0] : e.target;

        // En modo butacas especiales: asignar/quitar nivel especial al hacer clic
        if (this.specialSeatEditMode && elementSeat.eventSeat && !elementSeat.numberLeft && !elementSeat.numberRight) {
          const alreadyThisLevel = +elementSeat.specialLevel === +this.specialSeatTargetLevel?.id;
          if (alreadyThisLevel) {
            // Toggle off: devolver al color del nivel de la sección
            elementSeat.specialLevel = null;
            elementSeat.colorSpecial = null;
            const sectionLevel = this.levels?.find((l: any) => +l.id === +this.objectEditing?.area);
            this.generateMapService.changeSeatColor(elementSeat, sectionLevel?.color || this.colorDefaultSeat);
          } else {
            elementSeat.specialLevel = this.specialSeatTargetLevel.id;
            elementSeat.colorSpecial = this.specialSeatTargetLevel.color;
            this.generateMapService.changeSeatColor(elementSeat, this.specialSeatTargetLevel.color);
          }
          this.persistSpecialSeatChange(elementSeat);
          elementSeat.dirty = true;
          this.canvas.renderAll();
          return;
        }

        // En modo edición de asientos ocultos, permitir clic aunque el asiento no sea seleccionable
        if (this.hiddenSectionEditMode && !elementSeat.numberLeft && !elementSeat.numberRight && elementSeat.row) {
          const nowVisible = elementSeat.isVisible === false;
          elementSeat.set('isVisible', nowVisible);
          const levelColor = this.objectEditing?.area
            ? (this.levels?.find((l: any) => l.id === this.objectEditing.area)?.color || this.colorDefaultSeat)
            : this.colorDefaultSeat;
          const color = nowVisible ? levelColor : this.colorDefaultVisibility;
          this.generateMapService.changeSeatColor(elementSeat, color);
          elementSeat.dirty = true;
          this.canvas.renderAll();
          return;
        }

        if (elementSeat.selectable) {
          // Modo selección de asientos ocultos desde edición de sección (ya manejado arriba)

          // Seleccionar asientos ocultos
          if (this.openedHidden && this.hiddenTypeEdit) {
            if (elementSeat.eventSeat) {
              // elementSeat.selected = elementSeat.selected || elementSeat.hiddenType ? false : true;
              // elementSeat.hidden = elementSeat.hidden ? false : true;
              // El color por defecto será la variable color del asiento o el color de la seccion
              let existHidden = this.hiddenTypes.findIndex(value => value.id_seats?.includes(elementSeat.id));
              if (existHidden != -1) {
                this.hiddenTypes[existHidden].id_seats.splice(this.hiddenTypes[existHidden].id_seats.indexOf(elementSeat.id), 1);
              }

              if (existHidden == -1 || this.hiddenTypeEdit.id != this.hiddenTypes[existHidden].id) {
                if (!this.hiddenTypeEdit.id_seats) {
                  this.hiddenTypeEdit.id_seats = [];
                }
                // this.hiddenTypeEdit.id_seats.push(elementSeat.id);
                let hiddenIndex = this.hiddenTypes.findIndex(value => value.id == this.hiddenTypeEdit.id);
                this.hiddenTypes[hiddenIndex].id_seats.push(elementSeat.id);
              }
              this.canvasColorHidden(this.bookedSeatsShowed);
            }
          }

          // Editar asientos
          if (this.openEditObject) {
            this.sitSelect = elementSeat
            if (elementSeat.eventSeat) {
              if (elementSeat.indexEditing) {
                elementSeat.editing = !elementSeat.editing;
                this.seatsEditSelected[elementSeat.indexEditing - 1] = elementSeat.editing ? elementSeat : null;
              }
              if (!elementSeat.indexEditing) {
                elementSeat.indexEditing = this.seatsEditSelected.push(elementSeat);
                elementSeat.editing = true;
              }
              let color = !elementSeat.editing ? (this.fromCreate || this.fromEvent ? this.colorDefaultBasic : this.colorDefaultSeat) : this.colorDefaultDisplay;
              elementSeat = this.generateMapService.changeSeatColor(elementSeat, color);
              let arrayActive = this.seatsEditSelected.filter(value => value != null);
              if (arrayActive.length == 1) {
                this.sitSelect = arrayActive[0];
              }
            }
            elementSeat.editSeat = !elementSeat.editSeat;
          }
        }
      }

      // Snapshot para poder deshacer el movimiento en bloque de una selección múltiple.
      if (this.canvas.getActiveObject()?.type === 'activeSelection') {
        this.saveHistorySnapshot();
      }

      // No iniciar el paneo en modo selección múltiple ni mientras se coloca el marcador de
      // centro de curvatura: el arrastre debe mover el marcador, no panear el mapa.
      if (!this.massSelectMode && !(this.canvas as any)._pivotMode && !this.canvas.getActiveObject() && this.pausePanning == true) {
        this.pausePanning = false;
        this.canvas.discardActiveObject(this.canvas.getActiveObject());
        if (!this.isViewOnly) {
          this.canvas.defaultCursor = 'move';
        }
      }

      this.canvas.renderAll();
    });

    var previousTouch;
    this.canvas.on('mouse:move', e => {
      // Hover sobre butacas ocupadas (solo edición de evento): muestra a qué pedido
      // pertenece la butaca. La info por butaca llega en `seatsOrders` (indexado por id_seat).
      // Se resuelve en cada movimiento para que funcione al pasar entre butacas de una misma sección.
      this.updateSeatOrderTooltip(e);
      if (this.pausePanning == false && !(this.canvas as any)._pivotMode && e && e.e) {
        if (!e.e.touches) {
          this.canvas = keepPositionInBounds(this.canvas, e);
        }
        if (e.e.touches) {
          const touch = e.e.touches[0];
          if (previousTouch) {
            // be aware that these only store the movement of the first touch in the touches array
            e.e.movementX = touch.pageX - previousTouch.pageX;
            e.e.movementY = touch.pageY - previousTouch.pageY;
            this.canvas = keepPositionInBounds(this.canvas, e);
          };
          previousTouch = touch;
        }
      }
    });

    // Al salir del canvas ocultamos el tooltip y quitamos el resaltado del pedido.
    this.canvas.on('mouse:out', () => {
      this.hideSeatOrderTooltip();
      this.clearSeatHighlight();
    });

    this.canvas.on('mouse:up', e => {
      // Click (sin arrastre) sobre una butaca ocupada → abrir su pedido en una pestaña nueva.
      const seatOrder = this.getClickedSeatOrder(e);
      if (seatOrder) {
        this.openSeatOrder(seatOrder.order_id);
      }
      this.seatPointerDown = null;

      if (!this.canvas.getActiveObject() && this.pausePanning == false) {
        if (e.target && (e.target.eventSeat || e.target.groupSeat && e.subTargets.length > 0)) {
          let elementSeat = e.target?.groupSeat ? e.subTargets[0] : e.target;
          if (this.idEvent && !elementSeat.selectable && this.openedHidden && this.hiddenTypeEdit) {
            alert('No se pueden editar asientos reservados');
          }
        }
        this.pausePanning = true;
        this.canvas.defaultCursor = 'default';
      }
    });
    this.profile = this.auth.profileStorage.pipe();

    if (this.fromVenue) {
      this.apiVenues.mapSaveObservable.subscribe({
        next: (save) => {
          if (save === null) return;
          if (save) {
            this.apiVenues.saveMapAction(null);
            this.setActionRoute(save);
          } else {
            this.closeTab();
          }
        }
      });
    } else if (this.fromEvent) {
      this.apiEvents.mapSaveObservable.subscribe({
        next: (save) => {
          if (save === null) return;
          if (save) {
            this.apiEvents.saveMapAction(null);
            this.setActionRoute(save);
          } else {
            this.closeTab();
          }
        }
      });
      this.openLevelsHidden('hidden');
    }

    this.canvas.on('object:scaling', (e: any) => {
      if (e.target?.isScenary) {
        this.generateMapService.applyScenaryChildScales(e.target);
        this.canvas.requestRenderAll();
      }
      if (e.target?.previewLayer && e.target?.objectId) {
        this.syncZoneLabelPosition(e.target);
      }
    });

    this.canvas.on('object:moving', (e: any) => {
      if (e.target?.previewLayer && e.target?.objectId) {
        this.syncZoneLabelPosition(e.target);
      }
    });

    this.canvas.on('before:transform', () => {
      this.saveHistorySnapshot();
    });

    this.canvas.on('object:rotating', (e: any) => {
      if (e.target?.previewLayer && e.target?.objectId) {
        this.syncZoneLabelPosition(e.target);
      }
      // Mantiene sincronizado el slider del panel "Rotar selección" mientras se arrastra el tirador mtr.
      if (e.target?.type === 'activeSelection') {
        let angle = Math.round(e.target.angle) % 360;
        if (angle > 180) angle -= 360;
        this.groupRotationAngle = angle;
      }
      if (e.target && e.target.groupSeat && this.openEditObject && this.objectEditing === e.target) {
        // Normalizar ángulo de 0-360 a -180/180 para sincronizar con el panel lateral
        let angle = Math.round(e.target.angle) % 360;
        if (angle > 180) angle -= 360;
        this.objectEditing._lastCanvasAngle = angle;
        // Aplicar el ángulo normalizado al objeto fabric
        e.target.set('angle', angle).setCoords();
      }
    });

    this.canvas.on('object:modified', (e: any) => {
      // El marcador del centro de curvatura no persiste nada al moverse (lo gestiona edit-section).
      if (e.target?.isCurvatureCenter) return;
      // Movimiento en bloque de una selección múltiple.
      if (e.target && (e.target.type === 'activeSelection' || (e.target._objects && !e.target.objectId && !e.target.groupSeat))) {
        const dx = e.target.left - (e.transform?.original?.left ?? e.target.left);
        const dy = e.target.top - (e.transform?.original?.top ?? e.target.top);
        this.persistGroupMove(e.target, dx, dy);
        return;
      }
      if (e.target && e.target.groupSeat) {
        this.createOrUpdateSectionData(e.target);
      }
      // ✅ Guardar cambios en otros objetos (escenarios, etc.)
      else if (e.target && e.target.objectId) {
        this.updateCanvasObject(e.target);
        // Sincronizar posición del label de zona si aplica.
        if (e.target.previewLayer) {
          this.syncZoneLabelPosition(e.target);
        }
        // Mantener el slider/número de rotación del panel de imagen sincronizado si el ángulo
        // se cambió arrastrando el tirador del canvas en lugar del control del panel.
        if (e.target === this.editingImageObject) {
          this.editingImageAngle = e.target.angle || 0;
        }
      }
    });

    // ✅ Listener específico para cambios de texto
    this.canvas.on('text:changed', (e) => {
      if (e.target && e.target.objectId) {
        this.updateCanvasObject(e.target);
      }
    });

    // Listener para eliminación de objetos
    this.canvas.on('object:removed', (e) => {
      if (this.isUndoing) return;
      // Durante una reconstrucción de sección (cambio de filas/columnas) el grupo antiguo se
      // elimina del canvas para sustituirlo por el regenerado: NO debe borrarse su entrada en
      // seatSections, o la sección desaparecería del almacenamiento y no podría re-editarse.
      if (this.rebuildingSection) { this.refreshLayersList(); return; }
      if (e.target && e.target.groupSeat) {
        const sectionObject = e.target._objects.find((obj: any) => obj.section);
        const sectionId = sectionObject ? sectionObject.section.id : null;
        this.removeSectionData(sectionId);
      }
      // ✅ Eliminar otros objetos
      else if (e.target && e.target.objectId) {
        this.removeCanvasObject(e.target.objectId);
        // Si era una zona de la capa preview, eliminar también su label flotante.
        const orphanLabel = this.canvas._objects?.find((o: any) => o.zoneLabelFor === e.target.objectId);
        if (orphanLabel) this.canvas.remove(orphanLabel);
      }
      this.refreshLayersList();
    });

    // Mantiene el panel de capas al día cuando se añaden nuevos elementos al canvas.
    this.canvas.on('object:added', () => {
      if (this.rebuildingSection) return;
      this.refreshLayersList();
    });
  }

  // ✅ Método para actualizar objetos del canvas cuando se mueven
  updateCanvasObject(fabricObject: any) {
    const objectId = fabricObject.objectId;

    if (this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration = {
        ...this.canvasObjects[objectId].configuration,
        left: fabricObject.left,
        top: fabricObject.top,
        scaleX: fabricObject.scaleX,
        scaleY: fabricObject.scaleY,
        angle: fabricObject.angle || 0
      };

      // ✅ Actualizar propiedades específicas según el tipo
      if (fabricObject.type === 'textbox' || fabricObject.type === 'text') {
        this.canvasObjects[objectId].configuration.text = fabricObject.text;
        this.canvasObjects[objectId].configuration.fontSize = fabricObject.fontSize;
        this.canvasObjects[objectId].configuration.width = fabricObject.width;
        this.canvasObjects[objectId].configuration.height = fabricObject.height;
      }

      if (fabricObject.type === 'polygon') {
        this.canvasObjects[objectId].configuration.fill = fabricObject.fill;
        this.canvasObjects[objectId].configuration.stroke = fabricObject.stroke;
        this.canvasObjects[objectId].configuration.strokeWidth = fabricObject.strokeWidth;
        this.canvasObjects[objectId].configuration.points = fabricObject.points;
        this.canvasObjects[objectId].configuration.level = fabricObject.level;
        this.canvasObjects[objectId].configuration.cornerRadius = fabricObject.cornerRadius || 0;
        this.canvasObjects[objectId].configuration.edgeCurvatures = Array.isArray(fabricObject.edgeCurvatures) ? [...fabricObject.edgeCurvatures] : undefined;
      }

      if (fabricObject.type === 'rect') {
        this.canvasObjects[objectId].configuration.fill = fabricObject.fill;
        this.canvasObjects[objectId].configuration.stroke = fabricObject.stroke;
        this.canvasObjects[objectId].configuration.strokeWidth = fabricObject.strokeWidth;
        this.canvasObjects[objectId].configuration.width = fabricObject.width;
        this.canvasObjects[objectId].configuration.height = fabricObject.height;
        this.canvasObjects[objectId].configuration.level = fabricObject.level;
      }

      if (fabricObject.type === 'ellipse') {
        this.canvasObjects[objectId].configuration.fill = fabricObject.fill;
        this.canvasObjects[objectId].configuration.stroke = fabricObject.stroke;
        this.canvasObjects[objectId].configuration.strokeWidth = fabricObject.strokeWidth;
        this.canvasObjects[objectId].configuration.rx = fabricObject.rx;
        this.canvasObjects[objectId].configuration.ry = fabricObject.ry;
        this.canvasObjects[objectId].configuration.level = fabricObject.level;
      }

      // La línea es un fabric.Path (type 'path'), se identifica por el flag isLine.
      if (fabricObject.isLine) {
        this.canvasObjects[objectId].configuration.stroke = fabricObject.stroke;
        this.canvasObjects[objectId].configuration.strokeWidth = fabricObject.strokeWidth;
        this.canvasObjects[objectId].configuration.points = fabricObject.linePoints;
        this.canvasObjects[objectId].configuration.curvature = fabricObject.curvature || 0;
        this.canvasObjects[objectId].configuration.level = fabricObject.level;
      }

      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
      this.refreshLayersList();
    }
  }

  // ✅ Método para eliminar objetos del canvas
  removeCanvasObject(objectId: string) {
    if (this.canvasObjects[objectId]) {
      delete this.canvasObjects[objectId];
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }
  // ...existing code...

  setActionRoute(save: boolean) {
    this.closeTab();
    if (save) {
      // this.mapSaved ? this.editMap() : this.editName();
    } else {
      // this.getMap();
    }
  }

  getMap() {
    let event = this.fromCreate ? null : this.idEvent;
  }

  openInitialSectionsDialog(isInitial: boolean = true) {
    const dialogRef = this.dialog.open(CreateLevelsComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      data: {
        levels: this.levels
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === null || result?.levels?.length === 0) {
        // Solo navegar atrás si es la apertura inicial obligatoria
        if (isInitial) {
          this.location.back();
        }
        return;
      }

      if (result.confirmed && result.levels.length > 0) {
        // Configurar las secciones iniciales
        this.setupInitialSections(result.levels);
      }

      // Continuar con la inicialización normal del canvas
      // this.initializeCanvasEvents();
    });
  }

  setupInitialSections(initialLevels: any[]) {
    // Configurar los niveles iniciales
    this.levels = initialLevels.map((level, index) => ({
      ...level,
      orderBuy: index + 1,
      seats: level.seats || 0
    }));

    this.idLevel = this.levels.length + 1;

    // Guardar los niveles en el service para que se incluyan en el payload
    this.generateMapService.setLevelsMap(this.levels);

    // Repintar el canvas con los nuevos colores de nivel
    if (this.canvas) {
      this.repaintLevelColors();
    }

    // Mostrar mensaje informativo
    this.openInfo('Secciones configuradas correctamente. Ahora puedes empezar a crear tu mapa de asientos.');
  }

  repaintLevelColors() {
    const objects = this.canvas._objects;
    objects.forEach((element: any) => {
      // Secciones de butacas (groupSeat): el nivel está en el propio mainGroup
      if (element.groupSeat && element.area != null) {
        const level = this.levels?.find((l: any) => +l.id === +element.area);
        if (!level) return;
        const seatsGroup = element._objects?.[1];
        if (!seatsGroup) return;
        seatsGroup._objects?.forEach((seat: any) => {
          if (!seat.eventSeat) return;
          if (seat.specialLevel != null) {
            // Butaca con nivel especial: repintar con el color de su propio nivel
            const sLevel = this.levels?.find((l: any) => +l.id === +seat.specialLevel);
            if (sLevel) {
              seat.colorSpecial = sLevel.color;
              this.generateMapService.changeSeatColor(seat, sLevel.color);
            }
            return;
          }
          if (!seat.colorSpecial) this.generateMapService.changeSeatColor(seat, level.color);
        });
        element.addWithUpdate?.();
      }
      // Polígonos y rectángulos (isInfoSection): usan element.level, no element.area
      if (element.isInfoSection && element.level != null) {
        const level = this.levels?.find((l: any) => +l.id === +element.level);
        if (level) {
          element.set('fill', level.color);
          element.set('oldFill', level.color);
          // Persistir en canvasObjects para que el color correcto se guarde al salvar
          if (element.objectId && this.canvasObjects[element.objectId]) {
            this.canvasObjects[element.objectId].configuration.fill = level.color;
          }
        }
      }
    });

    // Sincronizar canvasObjects actualizados (colores de polígonos/rects) en el servicio
    this.generateMapService.setObjectsMap(this.canvasObjects);

    // Sincronizar colores en seatSections guardados
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      Object.values(storedSections).forEach((sectionData: any) => {
        const level = this.levels?.find((l: any) => +l.id === +sectionData.section?.level);
        if (level) {
          sectionData.section.color = level.color;
        }
        // Actualizar special_color de elementos con special_level cuando cambia el color de ese nivel
        sectionData.elements?.forEach((el: any) => {
          if (!el?.configuration?.special_level) return;
          const sLevel = this.levels?.find((l: any) => +l.id === +el.configuration.special_level);
          if (sLevel) {
            el.configuration.special_color = sLevel.color;
          }
        });
      });
      this.generateMapService.setSeatSections(storedSections);
    }

    this.canvas.renderAll();
  }

  // Botones externos de zoom
  zoomMap(plus: boolean, delta: any = 50) {
    var zoom = this.canvas.getZoom();
    var plusDelta = plus ? -delta : delta;
    zoom *= 0.999 ** plusDelta;
    if (zoom > 2) zoom = 2;
    if (zoom < 0.05) zoom = 0.05;
    this.canvas.setZoom(zoom);
    this.canvas.renderAll();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.canvasWidth = 2220;
    this.canvasHeight = 1400;
    this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });
    this.canvas.setZoom(0.4);
    this.idMap ? this.getMap() : this.saveBakground();
  }

  // Background canvas
  saveBakground() {
    var imageUrl = "/assets/img/canvas/svg_grid.svg";
    this.canvas.setBackgroundImage(imageUrl, this.canvas.renderAll.bind(this.canvas), {
      scaleX: 5,
      scaleY: 5,
      top: -50,
      left: -50,
      originX: "left",
      originY: "top",
    })
    this.canvas.renderAll();
    this.loadCanvas.emit(false);
  }

  @HostListener('document:keydown', ['$event'])
  onDeleteComponent(event: KeyboardEvent) {
    const key = event.key.toLowerCase();
    // Verificar si hay algún input o textarea en foco
    const activeElement = document.activeElement as HTMLElement;
    const isEditingHTMLInput = activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.contentEditable === 'true' ||
      activeElement.getAttribute('contenteditable') === 'true'
    );

    // Solo proceder con la eliminación si no se está editando texto
    const isEditingFabricText = this.canvas?.getActiveObject()?.isEditing;
    if (!this.activeTab || this.multiSelectionActive || this.openEditObject || this.openEditSection && !this.blockComponents || this.openEditText || this.openEditImage) {
      if ((key == 'backspace' || key == 'forward backspace' || key == 'delete') &&
        this.canvas.getActiveObject() &&
        !isEditingHTMLInput &&
        !isEditingFabricText &&
        !this.cropModeActive) {
        const activeObjects = this.canvas.getActiveObjects();
        this.saveHistorySnapshot();
        if (activeObjects.length > 1) {
          // Borrado en bloque: object:removed persiste cada eliminación (objectId / sección).
          this.canvas.discardActiveObject();
          activeObjects.forEach((o: any) => this.canvas.remove(o));
          this.clearedObjectSelect();
        } else {
          const obj = this.canvas.getActiveObject();
          if (obj.objectId) {
            this.removeCanvasObject(obj.objectId);
          }
          this.canvas.remove(obj);
          this.clearedObjectSelect();
        }
      }
    }

    // Copiar objeto activo (Ctrl/Cmd+C)
    if ((event.ctrlKey || event.metaKey) && key === 'c' && !isEditingHTMLInput && !isEditingFabricText && this.isSuperAdminEditMode) {
      const activeObj = this.canvas?.getActiveObject() as any;
      if (!activeObj) return;
      if (activeObj.objectId) {
        this.clipboardObjectId = activeObj.objectId;
        this.clipboardSectionKey = null;
        this.pasteOffset = 20;
      } else if (activeObj.groupSeat) {
        const seatsGroup = activeObj._objects?.[1];
        const sectionId = seatsGroup?.section?.id;
        const matchingKey = Object.keys(this.seatSections).find(k =>
          +this.seatSections[+k].section?.id === +sectionId
        );
        this.clipboardSectionKey = matchingKey != null ? +matchingKey : null;
        this.clipboardObjectId = null;
        this.pasteOffset = 20;
      }
    }

    // Pegar objeto copiado (Ctrl/Cmd+V). El pegado de imágenes desde el portapapeles del sistema
    // se gestiona aparte en onPasteImage (evento nativo "paste", único con acceso a clipboardData).
    if ((event.ctrlKey || event.metaKey) && key === 'v' && !isEditingHTMLInput && !isEditingFabricText &&
      this.isSuperAdminEditMode && (this.clipboardObjectId || this.clipboardSectionKey !== null)) {
      this.pasteCopied();
    }

    // Mover el objeto (o bloque) activo con las flechas del teclado, para ajustes finos de
    // posición: 1px por pulsación, 10px con Shift. event.repeat evita apilar un snapshot de
    // historial por cada tick de auto-repetición mientras se mantiene la tecla pulsada.
    if (
      ['arrowup', 'arrowdown', 'arrowleft', 'arrowright'].includes(key) &&
      !isEditingHTMLInput && !isEditingFabricText && !this.cropModeActive &&
      this.isSuperAdminEditMode
    ) {
      const activeObj = this.canvas?.getActiveObject() as any;
      if (activeObj && !activeObj.isCurvatureCenter) {
        event.preventDefault();
        const step = event.shiftKey ? 10 : 1;
        let dx = 0, dy = 0;
        if (key === 'arrowup') dy = -step;
        else if (key === 'arrowdown') dy = step;
        else if (key === 'arrowleft') dx = -step;
        else dx = step;

        if (!event.repeat) this.saveHistorySnapshot();

        activeObj.left = (activeObj.left || 0) + dx;
        activeObj.top = (activeObj.top || 0) + dy;
        activeObj.setCoords();

        if (activeObj.type === 'activeSelection') {
          this.persistGroupMove(activeObj, dx, dy);
        } else if (activeObj.groupSeat) {
          this.createOrUpdateSectionData(activeObj);
        } else if (activeObj.objectId) {
          this.updateCanvasObject(activeObj);
          if (activeObj.previewLayer) this.syncZoneLabelPosition(activeObj);
        }

        this.canvas.requestRenderAll();
      }
    }

    // Duplicar objeto u objetos activos (Ctrl/Cmd+D)
    if ((event.ctrlKey || event.metaKey) && key === 'd' && !isEditingHTMLInput && this.isSuperAdminEditMode) {
      event.preventDefault();
      this.duplicateSelected();
    }

    // Deshacer (Ctrl/Cmd+Z)
    if ((event.ctrlKey || event.metaKey) && key === 'z' && !isEditingHTMLInput && !isEditingFabricText && this.isSuperAdminEditMode) {
      event.preventDefault();
      this.undo();
    }
  }

  // Pegar imagen desde el portapapeles del sistema (Ctrl/Cmd+V con una imagen copiada, p. ej.
  // una captura de pantalla). Solo el evento nativo "paste" da acceso a clipboardData con archivos;
  // el HostListener de keydown no puede leer el contenido del portapapeles del SO.
  @HostListener('document:paste', ['$event'])
  async onPasteImage(event: ClipboardEvent) {
    if (!this.isSuperAdminEditMode) return;
    const activeElement = document.activeElement as HTMLElement;
    const isEditingHTMLInput = activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.contentEditable === 'true' ||
      activeElement.getAttribute('contenteditable') === 'true'
    );
    if (isEditingHTMLInput || this.canvas?.getActiveObject()?.isEditing) return;

    const clipboard = event.clipboardData;
    if (!clipboard) return;

    // El markup SVG se comprueba antes que los ficheros a propósito: las herramientas de diseño
    // (Figma, Illustrator) y los editores de código dejan el vector como texto y, a la vez,
    // suelen dejar una versión rasterizada como imagen. Quedarse con el texto conserva el vector.
    const clipboardText = clipboard.getData('text/plain');
    if (this.looksLikeSvgMarkup(clipboardText)) {
      event.preventDefault();
      await this.addSvgFromMarkup(clipboardText);
      return;
    }

    // Fichero en el portapapeles: copiar un .svg/.png desde el explorador de archivos, o una
    // captura de pantalla. El tipo declarado no siempre es fiable, de ahí el kind === 'file'.
    const fileItem = Array.from(clipboard.items || []).find(item => item.kind === 'file');
    const file = fileItem?.getAsFile();
    if (!file || !(this.isSvgFile(file) || file.type.startsWith('image/'))) return;

    event.preventDefault();
    await this.addFileToCanvas(file);
  }

  // Arrastrar y soltar ficheros sobre el mapa.
  //
  // Los listeners se registran a mano y FUERA de la zona de Angular a propósito: dragover se
  // dispara de forma continua mientras el puntero se mueve, y con un @HostListener cada uno de
  // esos eventos lanzaría una detección de cambios completa de este componente (que renderiza
  // miles de nodos), dejando la página bloqueada durante todo el arrastre. Solo se vuelve a
  // entrar en la zona al soltar, que es cuando hay que actualizar la vista de verdad.
  private setupFileDropListeners() {
    const container = document.getElementById('container-seats');
    if (!container) return;
    // Idempotente: si el componente se reinicializa no deben quedar listeners duplicados.
    this.removeFileDropListeners?.();

    // El resalte se aplica tocando la clase directamente, en vez de con un [class] enlazado a una
    // propiedad, porque fuera de la zona Angular no repintaría el binding.
    const setDropHighlight = (active: boolean) => {
      container.classList.toggle('file-drop-active', active);
    };

    // Los dos se escuchan en el documento, no en el contenedor, y se decide por geometría si el
    // puntero está sobre el mapa. Sobre el canvas hay varias capas (fabric monta su propio
    // .canvas-container con dos canvas superpuestos, más los paneles y botones flotantes), así que
    // el destino real del evento es impredecible; comprobar el rectángulo no depende de eso.
    // Además el preventDefault en dragover es incondicional: es lo que evita que el navegador se
    // quede con el fichero y lo abra en una pestaña, perdiendo el mapa sin guardar.
    const onDragOver = (event: DragEvent) => {
      event.preventDefault();
      if (!this.isSuperAdminEditMode) return;
      const overCanvas = this.isPointerOverCanvas(event);
      if (event.dataTransfer) event.dataTransfer.dropEffect = overCanvas ? 'copy' : 'none';
      setDropHighlight(overCanvas);
    };

    const onDrop = (event: DragEvent) => {
      event.preventDefault();
      setDropHighlight(false);
      if (!this.isSuperAdminEditMode || !event.dataTransfer) return;
      if (!this.isPointerOverCanvas(event)) return;
      const point = this.getScenePointFromEvent(event);
      // Los ficheros hay que capturarlos ya: el dataTransfer se vacía en cuanto termina el
      // handler, así que dentro del callback asíncrono de ngZone.run ya no estarían disponibles.
      const droppedText = event.dataTransfer.getData('text/plain');
      const files = Array.from(event.dataTransfer.files || []);
      this.ngZone.run(() => this.handleDroppedContent(droppedText, files, point));
    };

    // El arrastre puede salir de la ventana; si no se limpia, el resalte se quedaría pegado.
    const onDragEnd = () => setDropHighlight(false);

    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('dragover', onDragOver);
      document.addEventListener('drop', onDrop);
      document.addEventListener('dragend', onDragEnd);
      window.addEventListener('blur', onDragEnd);
    });

    this.removeFileDropListeners = () => {
      document.removeEventListener('dragover', onDragOver);
      document.removeEventListener('drop', onDrop);
      document.removeEventListener('dragend', onDragEnd);
      window.removeEventListener('blur', onDragEnd);
    };
  }

  // ¿El puntero está dentro del área visible del mapa?
  private isPointerOverCanvas(event: MouseEvent): boolean {
    const canvasEl: HTMLCanvasElement = this.canvas?.upperCanvasEl || this.canvas?.lowerCanvasEl;
    if (!canvasEl) return false;
    const bounds = canvasEl.getBoundingClientRect();
    return event.clientX >= bounds.left && event.clientX <= bounds.right
      && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
  }

  // Añade lo soltado en el punto del mapa donde se soltó, desplazando ligeramente los siguientes
  // ficheros para que no queden exactamente apilados.
  private async handleDroppedContent(droppedText: string, files: File[], point: { x: number, y: number }) {
    // Mismo criterio que al pegar: el markup SVG arrastrado desde un editor o una herramienta de
    // diseño tiene prioridad sobre cualquier rasterización que acompañe al arrastre.
    if (this.looksLikeSvgMarkup(droppedText)) {
      await this.addSvgFromMarkup(droppedText, point);
      return;
    }
    if (!files.length) {
      // Arrastres que no traen fichero (un enlace, texto suelto): no hay nada que añadir.
      console.warn('[mapa] Nada que añadir en lo soltado sobre el mapa.');
      return;
    }
    for (const file of files) {
      await this.addFileToCanvas(file, { ...point });
      point.x += 20;
      point.y += 20;
    }
  }

  // Reconoce un SVG servido como texto (portapapeles o arrastre) sin depender del mime type,
  // tolerando la cabecera XML, el DOCTYPE y los comentarios que suelen precederlo.
  private looksLikeSvgMarkup(text: string): boolean {
    if (!text) return false;
    // Con indexOf en vez de una expresión regular: el texto soltado puede ser muy largo y un
    // patrón con comodines abiertos se dispararía en tiempo de ejecución.
    const lower = text.toLowerCase();
    const open = lower.indexOf('<svg');
    return open !== -1 && lower.indexOf('</svg', open) > open;
  }

  // Punto único de entrada de ficheros al canvas (portapapeles y arrastrar-soltar). Si no se
  // indica posición, el objeto se coloca en el centro de la vista actual.
  private async addFileToCanvas(file: File, at?: { x: number, y: number }) {
    // Un SVG es vectorial: rasterizarlo (el downscale a PNG o el propio fabric.Image) lo dejaría
    // pixelado en cuanto se ampliara el mapa, así que se carga como grupo de paths.
    if (this.isSvgFile(file)) {
      const svgMarkup = await this.readFileAsText(file);
      await this.addSvgFromMarkup(svgMarkup, at);
      return;
    }
    if (!file.type.startsWith('image/')) {
      console.warn(`[mapa] Solo se admiten imágenes; "${file.name}" es de tipo "${file.type || 'desconocido'}".`);
      return;
    }

    const dataUrl = await this.readFileAsDataUrl(file);
    const resizedDataUrl = await this.downscaleImageDataUrl(dataUrl, 1600);
    await this.addImageFromDataUrl(resizedDataUrl, at);
  }

  // Convierte las coordenadas de pantalla del evento a coordenadas del mapa, deshaciendo el
  // desplazamiento y el zoom del viewport (mismo criterio que getCanvasCenter).
  private getScenePointFromEvent(event: MouseEvent): { x: number, y: number } {
    const canvasEl: HTMLCanvasElement = this.canvas?.upperCanvasEl || this.canvas?.lowerCanvasEl;
    if (!canvasEl) return this.getCanvasCenter();
    const bounds = canvasEl.getBoundingClientRect();
    const vpt = this.canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
    const zoom = this.canvas.getZoom() || 1;
    return {
      x: (event.clientX - bounds.left - vpt[4]) / zoom,
      y: (event.clientY - bounds.top - vpt[5]) / zoom
    };
  }

  // Algunos orígenes copian el SVG sin mime type fiable, de ahí el respaldo por extensión.
  private isSvgFile(file: File): boolean {
    return file.type === 'image/svg+xml' || /\.svg$/i.test(file.name || '');
  }

  private readFileAsText(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  // Reduce imágenes muy grandes (p. ej. capturas de pantalla en alta resolución) antes de
  // guardarlas como base64 en la configuración del canvas, para no disparar el tamaño del payload.
  private downscaleImageDataUrl(dataUrl: string, maxDim: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        if (img.width <= maxDim && img.height <= maxDim) {
          resolve(dataUrl);
          return;
        }
        const scale = maxDim / Math.max(img.width, img.height);
        const canvasEl = document.createElement('canvas');
        canvasEl.width = Math.round(img.width * scale);
        canvasEl.height = Math.round(img.height * scale);
        const ctx = canvasEl.getContext('2d');
        if (!ctx) {
          resolve(dataUrl);
          return;
        }
        ctx.drawImage(img, 0, 0, canvasEl.width, canvasEl.height);
        resolve(canvasEl.toDataURL('image/png'));
      };
      img.onerror = reject;
      img.src = dataUrl;
    });
  }

  async addImageFromDataUrl(dataUrl: string, at?: { x: number, y: number }) {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = at || this.getCanvasCenter();
    const img: any = await this.generateMapService.addImageObject(dataUrl, { objectId, left: center.x, top: center.y });

    // Encajar la imagen pegada a un tamaño visible razonable en el canvas.
    const maxDisplayDim = 400;
    const naturalWidth = img.width || 1;
    const naturalHeight = img.height || 1;
    if (naturalWidth > maxDisplayDim || naturalHeight > maxDisplayDim) {
      const scale = maxDisplayDim / Math.max(naturalWidth, naturalHeight);
      img.set({ scaleX: scale, scaleY: scale });
    }

    if (preview) img.set({ previewLayer: true });
    this.canvas.add(img);
    this.canvas.setActiveObject(img);
    const objectData: any = {
      left: img.left,
      top: img.top,
      scaleX: img.scaleX,
      scaleY: img.scaleY,
      angle: img.angle || 0,
      src: dataUrl,
      objectId: objectId,
      level: null
    };
    if (preview) objectData.previewLayer = true;
    this.saveCanvasObject(objectId, 'image', objectData);
    this.canvas.renderAll();
  }

  // Añade un SVG pegado como objeto vectorial. Se persiste el markup completo (no un data-url
  // rasterizado) para que al recargar el mapa se vuelva a construir como vector.
  async addSvgFromMarkup(svgMarkup: string, at?: { x: number, y: number }) {
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = at || this.getCanvasCenter();
    // Se parsea antes de tocar el historial: si el markup no es un SVG válido no se añade nada
    // al canvas y no debe quedar un snapshot vacío en el undo.
    const svg: any = await this.generateMapService.addSvgObject(svgMarkup, { objectId, left: center.x, top: center.y });
    if (!svg) {
      console.warn('[mapa] El SVG no se ha podido interpretar: no contiene elementos dibujables.');
      return;
    }
    this.saveHistorySnapshot();

    // Encajar el SVG a un tamaño visible razonable, igual que con las imágenes pegadas.
    const maxDisplayDim = 400;
    const naturalWidth = svg.width || 1;
    const naturalHeight = svg.height || 1;
    if (naturalWidth > maxDisplayDim || naturalHeight > maxDisplayDim) {
      const scale = maxDisplayDim / Math.max(naturalWidth, naturalHeight);
      svg.set({ scaleX: scale, scaleY: scale });
    }

    if (preview) svg.set({ previewLayer: true });
    this.canvas.add(svg);
    this.canvas.setActiveObject(svg);
    const objectData: any = {
      left: svg.left,
      top: svg.top,
      scaleX: svg.scaleX,
      scaleY: svg.scaleY,
      angle: svg.angle || 0,
      svg: svgMarkup,
      objectId: objectId,
      level: null
    };
    if (preview) objectData.previewLayer = true;
    this.saveCanvasObject(objectId, 'svg', objectData);
    this.canvas.renderAll();
  }

  // Añadir asientos y secciones
  async addScenary() {
    this.saveHistorySnapshot();
    this.canvas.discardActiveObject();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();

    const result = await this.generateMapService.createScenary(
      this.canvas,
      this.colorDefaultStage,
      this.screenElement,
      { objectId: objectId, text: 'Escenario', left: center.x, top: center.y, textColor: '#000000' },
      this.fromEvent,
      this.isSuperAdminEditMode
    );
    if (preview && result.group) result.group.set('previewLayer', true);
    // Guardar objeto en localStorage solo si se devuelven objectData
    if (result.objectData) {
      if (preview) result.objectData.previewLayer = true;
      this.saveCanvasObject(objectId, 'scenary', result.objectData);
    }
    // Auto-seleccionar el escenario recién creado y abrir panel de edición
    if (result.group) {
      this.canvas.setActiveObject(result.group);
      this.canvas.renderAll();
      this.clickSelectScenary(result.group);
    }
  }

  saveCanvasObject(objectId: string, type: string, configuration: any) {
    const objectData = {
      id: objectId,
      type: type,
      configuration: configuration,
    };
    this.canvasObjects[objectId] = objectData;
    localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
    this.generateMapService.setObjectsMap(this.canvasObjects);
    this.objectIdCounter++;
  }

  async pasteCopied(skipSnapshot = false) {
    if (!this.isSuperAdminEditMode) return;
    if (!skipSnapshot) this.saveHistorySnapshot();

    // Pegar objeto de canvas (polygon, rect, text, scenary, standSection...)
    if (this.clipboardObjectId) {
      const sourceData = this.canvasObjects[this.clipboardObjectId];
      if (!sourceData) return;
      const newId = `obj_${this.objectIdCounter}`;
      // Clonado profundo: una copia superficial compartiría las arrays anidadas
      // (points de polígono/línea, sections de zona) con el objeto original, de modo que
      // editar el duplicado mutaría también el original. La configuración siempre es
      // serializable a JSON (se persiste así en localStorage), por lo que es seguro.
      const newConfig = {
        ...JSON.parse(JSON.stringify(sourceData.configuration)),
        objectId: newId,
        left: (sourceData.configuration.left || 100) + this.pasteOffset,
        top: (sourceData.configuration.top || 50) + this.pasteOffset,
      };
      // El escenario y la imagen se crean de forma asíncrona (cargan un SVG/imagen), así que hay
      // que esperarlos explícitamente para que lastPastedObject apunte al objeto real del canvas.
      if (sourceData.type === 'scenary') {
        await this.recreateScenary(newConfig, this.isSuperAdminEditMode);
        this.lastPastedObject = this.canvas.getObjects().find((o: any) => o.objectId === newId) || null;
      } else if (sourceData.type === 'image' || sourceData.type === 'svg') {
        await this.recreateImage(newConfig, this.isSuperAdminEditMode);
        this.lastPastedObject = this.canvas.getObjects().find((o: any) => o.objectId === newId) || null;
      } else {
        const newObjectData = { id: newId, type: sourceData.type, configuration: newConfig };
        const createdObj = await this.createObjectFromData(newObjectData);
        this.lastPastedObject = createdObj || this.canvas.getObjects().find((o: any) => o.objectId === newId) || null;
      }
      this.saveCanvasObject(newId, sourceData.type, newConfig);
      // Seleccionar el duplicado recién pegado (no el original) para poder arrastrarlo de inmediato;
      // sin esto el objeto activo seguía siendo el original y el nuevo quedaba sin seleccionar.
      if (this.lastPastedObject) {
        this.canvas.discardActiveObject();
        this.canvas.setActiveObject(this.lastPastedObject);
        this.canvas.renderAll();
      }
      this.pasteOffset += 20;
      return;
    }

    // Pegar sección de butacas
    if (this.clipboardSectionKey !== null) {
      const sourceSectionData = JSON.parse(JSON.stringify(this.seatSections[this.clipboardSectionKey!]));
      const newSectionNumber = this.sectionNumber;
      sourceSectionData.section.id = newSectionNumber;
      sourceSectionData.section.configuration.left = (sourceSectionData.section.configuration.left || 0) + this.pasteOffset;
      sourceSectionData.section.configuration.top = (sourceSectionData.section.configuration.top || 0) + this.pasteOffset;
      // Update the inner seatsGroupConfig section reference so createOrUpdateSectionData
      // tracks the duplicate independently from the original when moved.
      if (sourceSectionData.section.configuration?.seatsGroupConfig) {
        sourceSectionData.section.configuration.seatsGroupConfig = {
          ...sourceSectionData.section.configuration.seatsGroupConfig,
          section: { id: newSectionNumber, name: sourceSectionData.section.name }
        };
      }
      sourceSectionData.section.id_bbdd = null;
      sourceSectionData.elements = (sourceSectionData.elements || []).map((el: any) => ({
        ...el,
        id: null,
        section: newSectionNumber,
      }));
      const { mainGroup } = this.generateMapService.addGroupSeats(
        sourceSectionData.section.rows,
        sourceSectionData.section.columns,
        newSectionNumber,
        sourceSectionData,
        false,
        [],
        this.isSuperAdminEditMode
      );
      this.seatSections[newSectionNumber] = sourceSectionData;
      this.generateMapService.setSeatSections(this.seatSections);
      this.refreshLevelsList();
      mainGroup.sectionKey = newSectionNumber;
      this.canvas.add(mainGroup);
      this.lastPastedObject = mainGroup;
      this.canvas.setActiveObject(mainGroup);
      this.canvas.renderAll();
      this.sectionNumber++;
      this.pasteOffset += 20;
    }
  }

  // Activa/desactiva el modo de selección múltiple (recuadro + shift-clic para mover/borrar en bloque).
  toggleMassSelect() {
    this.massSelectMode = !this.massSelectMode;
    if (this.massSelectMode) {
      this.canvas.selection = true;
      this.canvas.selectionColor = 'rgba(255,77,128,0.15)';
      this.canvas.selectionBorderColor = '#FF4D80';
      this.canvas.selectionLineWidth = 1;
      // Cursor de cruz para indicar que el arrastre dibuja un recuadro de selección.
      this.canvas.defaultCursor = 'crosshair';
      this.canvas.setCursor('crosshair');
    } else {
      this.canvas.selection = false;
      this.canvas.defaultCursor = 'default';
      this.canvas.setCursor('default');
    }
    this.canvas.discardActiveObject();
    this.canvas.renderAll();
  }

  // Si la selección actual es múltiple, la configura solo-mover (sin rotar/escalar) y evita
  // abrir los paneles de edición individuales. Devuelve true si el handler de selección debe parar.
  private handleMultiSelection(): boolean {
    const active = this.canvas.getActiveObject() as any;
    const armed = this.massSelectMode;
    if (active?.type === 'activeSelection') {
      // Permitimos redimensionar el bloque completo tanto desde las esquinas (proporcional) como
      // desde los laterales (estira solo ese eje), y rotarlo desde el tirador superior.
      active.set({ lockScalingFlip: true });
      active.setControlsVisibility({
        mt: true, mb: true, ml: true, mr: true,
        tl: true, tr: true, bl: true, br: true, mtr: true,
      });
      this.multiSelectionActive = true;
      this.groupRotationAngle = Math.round((active.angle || 0) * 100) / 100;
      // Cierra cualquier panel de edición individual abierto y abre la pestaña de edición: sin esto
      // el <ng-template #editTab> (que envuelve tanto el panel de curvar como el de rotar selección)
      // no se renderiza y ningún panel de bloque llega a mostrarse tras una selección múltiple.
      this.openEditObject = false;
      this.openEditSection = false;
      this.openEditScenary = false;
      this.openEditText = false;
      this.openEditImage = false;
      this.editingImageObject = null;
      this.objectEditing = null;
      this.activeTab = true;
      this.titleTab = 'Selección múltiple';
      // Selección "de un solo uso": tras crearla, desarmar el modo (hay que volver a pulsar el botón).
      if (armed) this.disarmMassSelect();
      this.canvas.renderAll();
      // Si TODA la selección pertenece a un grupo ya curvado antes, reabre el panel de curvatura
      // automáticamente con su configuración guardada (igual que reseleccionar una sección con
      // curvatura radial/elíptica reabre sus controles) — funciona tanto al reseleccionar por
      // marquee como al hacerlo desde el listado de capas (selectLayer también dispara este mismo
      // evento de selección de fabric).
      const sharedGroupId = this.getSharedCurveGroupId(active._objects || []);
      const storedConfig = sharedGroupId ? this.getStoredCurveConfig(active._objects[0]) : null;
      if (storedConfig && !this.curveSelectionActive) {
        this.startCurveSelection();
      }
      return true;
    }
    // En modo selección múltiple no abrimos paneles ni para una sola forma; también se desarma.
    if (armed) {
      this.disarmMassSelect();
      return true;
    }
    return false;
  }

  // Desactiva el recuadro de selección dejando intacta la selección actual.
  private disarmMassSelect() {
    this.massSelectMode = false;
    this.canvas.selection = false;
    // Restaurar el cursor normal al desarmar (tras crear la selección).
    this.canvas.defaultCursor = 'default';
    this.canvas.setCursor('default');
  }

  // Persiste el desplazamiento (dx, dy) de un movimiento en bloque sumándolo a la
  // configuración guardada de cada hijo (formas/zonas y secciones de butacas).
  private persistGroupMove(group: any, dx: number, dy: number) {
    if (!dx && !dy) return;
    let changedObjects = false;
    let changedSections = false;
    (group._objects || []).forEach((child: any) => {
      if (child.objectId && this.canvasObjects[child.objectId]) {
        const cfg = this.canvasObjects[child.objectId].configuration;
        cfg.left = (cfg.left || 0) + dx;
        cfg.top = (cfg.top || 0) + dy;
        changedObjects = true;
        if (child.previewLayer) this.syncZoneLabelPosition(child);
      } else if (child.groupSeat) {
        const sectionId = child._objects?.[1]?.section?.id;
        const key = Object.keys(this.seatSections).find(
          (k) => +this.seatSections[+k]?.section?.id === +sectionId,
        );
        if (key != null) {
          const cfg = this.seatSections[+key]?.section?.configuration;
          if (cfg) {
            cfg.left = (cfg.left || 0) + dx;
            cfg.top = (cfg.top || 0) + dy;
            changedSections = true;
          }
        }
      }
    });
    if (changedObjects) {
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    if (changedSections) {
      this.generateMapService.setSeatSections(this.seatSections);
    }
  }

  // Persiste el estado final (posición, escala y ángulo) de cada hijo de un bloque múltiple tras
  // desagruparse (mover y/o redimensionar). Se apoya en el mismo mecanismo usado para objetos
  // sueltos, ya que fabric restaura los valores absolutos de cada hijo antes de este punto.
  private persistGroupTransform(group: any) {
    (group._objects || []).forEach((child: any) => {
      if (child.groupSeat) {
        this.createOrUpdateSectionData(child);
      } else if (child.objectId && this.canvasObjects[child.objectId]) {
        this.updateCanvasObject(child);
        if (child.previewLayer) this.syncZoneLabelPosition(child);
      }
    });
  }

  // Entra en modo "curvar selección": bloquea otras interacciones de selección (_pivotMode, igual
  // que el marcador de centro de sección) y calcula, a partir de la ActiveSelection actual, el
  // orden/posición normalizada (t 0..1) de cada objeto a lo largo de su span original.
  startCurveSelection() {
    if (!this.multiSelectionActive || this.curveSelectionActive) return;
    const active = this.canvas.getActiveObject() as any;
    if (!active || active.type !== 'activeSelection') return;
    const objs: any[] = this.canvas.getActiveObjects().slice();
    if (objs.length < 2) return;

    (this.canvas as any)._pivotMode = true;
    (this.canvas as any)._pivotInternal = true;
    // Al descartar la ActiveSelection, fabric restaura en cada hijo su left/top/angle absolutos
    // (mismo mecanismo del que depende persistGroupTransform), necesarios para calcular posiciones
    // en coordenadas de canvas reales.
    this.canvas.discardActiveObject();

    const raw = objs.map((obj) => {
      const c = obj.getCenterPoint();
      return {
        fabricObj: obj, centerX: c.x, centerY: c.y, angle: obj.angle || 0,
        originalLeft: obj.left, originalTop: obj.top, originalAngle: obj.angle || 0,
      };
    });

    const minX = Math.min(...raw.map(r => r.centerX));
    const maxX = Math.max(...raw.map(r => r.centerX));
    const minY = Math.min(...raw.map(r => r.centerY));
    const maxY = Math.max(...raw.map(r => r.centerY));
    // Si el bloque es más alto que ancho, se ordena/parametriza por Y en vez de por X.
    const useY = (maxX - minX) < (maxY - minY);
    raw.sort((a, b) => useY ? (a.centerY - b.centerY || a.centerX - b.centerX) : (a.centerX - b.centerX || a.centerY - b.centerY));
    const lo = useY ? minY : minX, hi = useY ? maxY : maxX;
    const span = (hi - lo) || 1;

    this.curveSelectionItems = raw.map((r, idx) => ({
      id: 'item_' + idx,
      t: (( useY ? r.centerY : r.centerX) - lo) / span,
      angle: r.angle,
      fabricObj: r.fabricObj,
      originalLeft: r.originalLeft,
      originalTop: r.originalTop,
      originalAngle: r.originalAngle,
    }));

    const midX = (minX + maxX) / 2, midY = (minY + maxY) / 2;
    // Si TODOS los objetos ya pertenecen al mismo grupo lógico de capas y ese grupo tiene una
    // curvatura guardada (ver commitCurveSelection/persistCurveConfig), se reedita esa
    // configuración en vez de recalcular valores por defecto — igual que reabrir la curvatura
    // guardada de una sección de butacas.
    this.curveGroupId = this.getSharedCurveGroupId(objs);
    const storedConfig = this.curveGroupId ? this.getStoredCurveConfig(objs[0]) : null;
    if (storedConfig) {
      this.curveMode = storedConfig.mode;
      this.curveCenter = storedConfig.center;
      this.curveRadius = storedConfig.radius;
      this.curveArcDeg = storedConfig.arcDeg;
      this.curveEllipseAspect = storedConfig.ellipseAspect;
      this.curveEllipseRotation = storedConfig.ellipseRotation;
      this.curveCurvature = storedConfig.curvature;
      this.curveInvert = storedConfig.invert;
      this.curveAxisOrigin = storedConfig.axisOrigin;
      this.curveAxisAngleDeg = storedConfig.axisAngleDeg;
      this.curveAxisLength = storedConfig.axisLength;
    } else {
      // Valores por defecto: radio = mitad de la diagonal del bbox original, centro = un radio por
      // encima del punto medio (una fila recta se convierte en un arco suave hacia arriba).
      this.curveRadius = Math.round(Math.hypot(maxX - minX, maxY - minY) / 2) || 200;
      // El arco por defecto se deriva del radio para que la longitud de arco resultante
      // (radio × ángulo en radianes) sea igual al span original de la selección: si en vez de esto
      // se fija un ángulo arbitrario (p.ej. 60° fijos), objetos grandes como secciones completas
      // pueden acabar mucho más juntos de lo que estaban y solaparse por completo unos a otros
      // (el de encima "tapa" a los demás, que visualmente parecen haber desaparecido). Con esta
      // fórmula, al entrar en modo curva el grupo mantiene su separación original — curvar de más
      // pasa a ser una decisión explícita del usuario al mover los sliders o arrastrar el centro.
      const defaultArcRad = span / this.curveRadius;
      this.curveArcDeg = Math.min(180, Math.max(1, Math.round(defaultArcRad * 180 / Math.PI)));
      this.curveEllipseAspect = 1;
      this.curveEllipseRotation = 0;
      this.curveCurvature = 0;
      this.curveInvert = false;
      this.curveMode = 'circular';
      this.curveCenter = { x: midX, y: midY - this.curveRadius };
      this.curveAxisOrigin = { x: midX, y: midY };
      this.curveAxisAngleDeg = useY ? 90 : 0;
      this.curveAxisLength = Math.max(span, 1);
    }

    this.curveSelectionActive = true;
    this.curvePlacingCenter = false;
    (this.canvas as any)._pivotInternal = false;
    this.previewCurveLayout();
  }

  onCurveModeChange(mode: 'circular' | 'elliptical' | 'parabolic') {
    this.curveMode = mode;
    // El centro de curvatura solo aplica a circular/elíptica; ocultar el marcador si estaba visible.
    if (mode === 'parabolic' && this.curveCenterMarker) {
      this.curvePlacingCenter = false;
      this.removeCurveCenterMarker();
    }
    this.previewCurveLayout();
  }

  toggleCurvePlacingCenter() {
    this.curvePlacingCenter = !this.curvePlacingCenter;
    if (this.curvePlacingCenter) {
      this.createCurveCenterMarker();
    } else {
      this.removeCurveCenterMarker();
    }
  }

  // Rota la ActiveSelection completa sobre su propio centro, desde el slider del panel "Rotar
  // selección". Igual que arrastrar el tirador mtr: fabric mueve/rota cada hijo en vivo dentro del
  // grupo y, al deseleccionar, bakea left/top/angle finales (persistGroupTransform los guarda).
  onGroupRotationChange(value: any) {
    const angle = parseFloat(value) || 0;
    this.groupRotationAngle = angle;
    const active = this.canvas.getActiveObject() as any;
    if (!active || active.type !== 'activeSelection') return;
    active.set('angle', angle);
    active.setCoords();
    this.canvas.requestRenderAll();
  }

  onCurveRadiusChange(v: number) { this.curveRadius = +v || 0; this.previewCurveLayout(); }
  onCurveArcDegChange(v: number) { this.curveArcDeg = +v || 0; this.previewCurveLayout(); }
  onCurveEllipseAspectChange(v: number) { this.curveEllipseAspect = (+v > 0) ? +v : 1; this.previewCurveLayout(); }
  onCurveEllipseRotationChange(v: number) { this.curveEllipseRotation = +v || 0; this.previewCurveLayout(); }
  onCurveCurvatureChange(v: number) { this.curveCurvature = +v || 0; this.previewCurveLayout(); }
  onCurveInvertToggle() { this.curveInvert = !this.curveInvert; this.previewCurveLayout(); }

  // Recalcula y renderiza (sin persistir) la posición/ángulo final de cada objeto de la selección.
  // Llamado en cada tick de arrastre del marcador de centro / cambio de slider.
  previewCurveLayout() {
    if (!this.curveSelectionItems.length) return;
    const params: any = this.curveMode === 'parabolic'
      ? {
        curvature: this.curveCurvature,
        axisAngleDeg: this.curveAxisAngleDeg,
        axisOrigin: this.curveAxisOrigin,
        axisLength: this.curveAxisLength,
        invert: this.curveInvert,
      }
      : {
        center: this.curveCenter,
        radius: this.curveRadius,
        ellipseAspect: this.curveMode === 'elliptical' ? this.curveEllipseAspect : 1,
        ellipseRotationDeg: this.curveMode === 'elliptical' ? this.curveEllipseRotation : 0,
        totalArcDeg: this.curveArcDeg,
        invert: this.curveInvert,
        // Rumbo en vivo del centro hacia el ancla (punto medio original de la selección): así el
        // arco siempre queda centrado sobre la posición original, sea cual sea dónde esté el
        // centro respecto a los objetos (arriba, abajo, al lado…), igual que `phi` en addGroupSeats.
        centerBearingDeg: this.curveCenter && this.curveAxisOrigin
          ? Math.atan2(this.curveAxisOrigin.y - this.curveCenter.y, this.curveAxisOrigin.x - this.curveCenter.x) * 180 / Math.PI
          : -90,
      };
    const results = this.generateMapService.computeCurvedLayout(
      this.curveSelectionItems.map(i => ({ id: i.id, t: i.t, angle: i.angle })),
      this.curveMode,
      params
    );
    const byId: { [k: string]: { left: number, top: number, angle: number } } = {};
    results.forEach(r => byId[r.id] = r);
    this.curveSelectionItems.forEach(item => {
      const r = byId[item.id];
      if (!r) return;
      // Las secciones de butacas (groupSeat) nunca rotan como bloque rígido: a diferencia de un
      // objeto suelto (mesa, icono…), su rejilla interna de filas/columnas —incluidas las butacas
      // marcadas ocultas para recortar huecos— no se recalcula al rotar, así que un ángulo "mirando
      // al centro" que caiga lejos del ángulo original (p. ej. ~180°) las gira como bloque y las
      // butacas ocultas que estaban arriba-izquierda terminan abajo-derecha. Solo se reposicionan
      // a lo largo del arco, conservando su ángulo original (ver curvatura radial/elíptica propia
      // de sección en addGroupSeats, que sí compensa esto para cada butaca individualmente).
      const angle = item.fabricObj.groupSeat ? item.originalAngle : r.angle;
      item.fabricObj.set({ left: r.left, top: r.top, angle });
      item.fabricObj.setCoords();
    });
    this.canvas.requestRenderAll();
  }

  // Confirma la curva: los objetos ya están en su posición/ángulo final (último previewCurveLayout),
  // así que solo hay que persistir cada uno según su tipo (mismo mecanismo que persistGroupTransform).
  // Además, se agrupan lógicamente (layerGroupId) y se guarda la configuración de curvatura para
  // poder reabrirla y reajustarla más tarde, igual que la curvatura radial/elíptica de secciones.
  commitCurveSelection() {
    if (!this.curveSelectionItems.length) { this.cancelCurveSelection(); return; }
    this.saveHistorySnapshot();
    const groupId = this.curveGroupId || `layerGroup_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    const config = this.buildCurveConfigSnapshot();
    this.curveSelectionItems.forEach((item) => {
      const obj = item.fabricObj;
      if (obj.groupSeat) {
        this.createOrUpdateSectionData(obj);
      } else if (obj.objectId) {
        this.updateCanvasObject(obj);
      }
      obj.layerGroupId = groupId;
      obj.curveConfig = config;
      this.persistLayerGroupId(obj, groupId);
      this.persistCurveConfig(obj, config);
    });
    this.curveGroupId = null;
    this.refreshLayersList();
    this.endCurveSelection();
  }

  // Empaqueta la configuración de curvatura actual (mode + todos sus parámetros) en la forma
  // persistida (ver commitCurveSelection/getStoredCurveConfig).
  private buildCurveConfigSnapshot(): any {
    return {
      mode: this.curveMode,
      center: this.curveCenter,
      radius: this.curveRadius,
      arcDeg: this.curveArcDeg,
      ellipseAspect: this.curveEllipseAspect,
      ellipseRotation: this.curveEllipseRotation,
      curvature: this.curveCurvature,
      axisOrigin: this.curveAxisOrigin,
      axisAngleDeg: this.curveAxisAngleDeg,
      axisLength: this.curveAxisLength,
      invert: this.curveInvert,
    };
  }

  // Cancela: restaura cada objeto a su posición/ángulo original capturado al entrar en modo curva.
  // No se llama a saveHistorySnapshot ni a ningún método de persistencia: nada cambió.
  cancelCurveSelection() {
    this.curveSelectionItems.forEach((item) => {
      item.fabricObj.set({ left: item.originalLeft, top: item.originalTop, angle: item.originalAngle });
      item.fabricObj.setCoords();
    });
    this.canvas.requestRenderAll();
    this.curveGroupId = null;
    this.endCurveSelection();
  }

  private endCurveSelection() {
    this.curvePlacingCenter = false;
    this.removeCurveCenterMarker();
    this.curveSelectionActive = false;
    this.curveSelectionItems = [];
    (this.canvas as any)._pivotMode = false;
    (this.canvas as any)._pivotInternal = true;
    this.canvas.discardActiveObject();
    (this.canvas as any)._pivotInternal = false;
    this.multiSelectionActive = false;
    this.canvas.requestRenderAll();
  }

  private createCurveCenterMarker() {
    if (!this.canvas || this.curveCenterMarker || !this.curveCenter) return;
    // El centro por defecto (o uno reabierto desde una curva guardada hecha con otro zoom/pan) puede
    // caer fuera del viewport visible — sobre todo con selecciones grandes, donde el radio por
    // defecto (mitad de la diagonal del bbox) empuja el punto muy lejos de la selección. Sin este
    // ajuste el tirador ✛ se crea igualmente, pero fuera de la vista: parece que "no aparece".
    // Se clampa al viewport (con margen) y se recalcula el radio para mantener la misma invariante
    // que el arrastre en vivo (curveMovingHandler): radio = distancia centro↔ancla.
    this.curveCenter = this.clampToVisibleCanvas(this.curveCenter);
    if (this.curveAxisOrigin) {
      this.curveRadius = Math.round(Math.hypot(
        this.curveAxisOrigin.x - this.curveCenter.x,
        this.curveAxisOrigin.y - this.curveCenter.y
      )) || this.curveRadius;
    }
    const p = this.curveCenter;
    const size = 40;
    const circle = new fabric.Circle({
      radius: size, fill: 'rgba(255,77,128,0.12)', stroke: '#FF4D80', strokeWidth: 2,
      originX: 'center', originY: 'center',
    });
    const hLine = new fabric.Line([-size, 0, size, 0], { stroke: '#FF4D80', strokeWidth: 2 });
    const vLine = new fabric.Line([0, -size, 0, size], { stroke: '#FF4D80', strokeWidth: 2 });
    this.curveCenterMarker = new fabric.Group([circle, hLine, vLine], {
      left: p.x, top: p.y, originX: 'center', originY: 'center',
      hasControls: false, hasBorders: false, selectable: true, evented: true,
      hoverCursor: 'move', lockRotation: true, lockScalingX: true, lockScalingY: true,
      isCurvatureCenter: true, excludeFromExport: true,
    } as any);
    this.canvas.add(this.curveCenterMarker);
    this.curveCenterMarker.bringToFront();
    (this.canvas as any)._pivotInternal = true;
    this.canvas.setActiveObject(this.curveCenterMarker);
    (this.canvas as any)._pivotInternal = false;

    this.curveMovingHandler = (e: any) => {
      if (e.target === this.curveCenterMarker) {
        this.curveCenter = { x: e.target.left, y: e.target.top };
        // El radio sigue en vivo la distancia centro↔ancla (igual que Dcanvas en addGroupSeats):
        // acercar el centro cierra el arco, alejarlo lo abre. Así arrastrar el marcador tiene un
        // efecto visual directo; el campo/slider de radio queda para el ajuste fino entre arrastres.
        if (this.curveAxisOrigin) {
          this.curveRadius = Math.round(Math.hypot(
            this.curveAxisOrigin.x - this.curveCenter.x,
            this.curveAxisOrigin.y - this.curveCenter.y
          )) || this.curveRadius;
        }
        this.previewCurveLayout();
      }
    };
    this.canvas.on('object:moving', this.curveMovingHandler);
    // El radio pudo recalcularse arriba al clampar el centro: refleja ese ajuste en la selección ya
    // curvada (si no, el arco quedaría desincronizado del radio real hasta el primer arrastre).
    this.previewCurveLayout();
    this.canvas.requestRenderAll();
  }

  // Ajusta un punto para que quede dentro del viewport visible actual (con margen), en coordenadas
  // de canvas. Reutiliza la misma transformación que getCanvasCenter().
  private clampToVisibleCanvas(point: { x: number, y: number }, margin: number = 60): { x: number, y: number } {
    const vpt = this.canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
    const zoom = this.canvas.getZoom() || 1;
    const container = document.getElementById('container-seats');
    const w = container ? container.clientWidth : this.canvas.getWidth();
    const h = container ? container.clientHeight : this.canvas.getHeight();
    const left = (margin - vpt[4]) / zoom;
    const right = (w - margin - vpt[4]) / zoom;
    const top = (margin - vpt[5]) / zoom;
    const bottom = (h - margin - vpt[5]) / zoom;
    return {
      x: Math.min(Math.max(point.x, Math.min(left, right)), Math.max(left, right)),
      y: Math.min(Math.max(point.y, Math.min(top, bottom)), Math.max(top, bottom)),
    };
  }

  private removeCurveCenterMarker() {
    if (this.canvas && this.curveMovingHandler) {
      this.canvas.off('object:moving', this.curveMovingHandler);
      this.curveMovingHandler = null;
    }
    if (this.canvas && this.curveCenterMarker) {
      (this.canvas as any)._pivotInternal = true;
      this.canvas.remove(this.curveCenterMarker);
      this.canvas.discardActiveObject();
      (this.canvas as any)._pivotInternal = false;
      this.canvas.requestRenderAll();
    }
    this.curveCenterMarker = null;
  }

  /** Returns the center point of the currently visible canvas viewport in canvas coordinates */
  getCanvasCenter(): { x: number, y: number } {
    const vpt = this.canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
    const zoom = this.canvas.getZoom();
    const container = document.getElementById('container-seats');
    const w = container ? container.clientWidth : this.canvas.getWidth();
    const h = container ? container.clientHeight : this.canvas.getHeight();
    return {
      x: (w / 2 - vpt[4]) / zoom,
      y: (h / 2 - vpt[5]) / zoom
    };
  }

  duplicateSelected() {
    const activeObj = this.canvas?.getActiveObject() as any;
    if (!activeObj) return;
    // Duplicar en bloque toda la selección múltiple.
    const objs = this.canvas.getActiveObjects();
    if (objs.length > 1) {
      this.duplicateBlock(objs);
      return;
    }
    if (activeObj.groupSeat) {
      const key = this.getSectionKeyForGroup(activeObj);
      this.clipboardSectionKey = key != null ? +key : null;
      this.clipboardObjectId = null;
      this.pasteOffset = 20;
    } else if (activeObj.objectId) {
      this.clipboardObjectId = activeObj.objectId;
      this.clipboardSectionKey = null;
      this.pasteOffset = 20;
    }
    this.pasteCopied();
  }

  // Duplica todos los objetos de la selección, desplazados el mismo offset para conservar el
  // layout relativo del bloque. Reutiliza pasteCopied() por cada objeto (un solo snapshot) y
  // deja los duplicados seleccionados como un nuevo bloque para poder moverlos juntos.
  private async duplicateBlock(objs: any[]) {
    this.saveHistorySnapshot();
    const created: any[] = [];
    for (const o of objs) {
      const dup = await this.duplicateOne(o);
      if (dup) created.push(dup);
    }
    this.canvas.discardActiveObject();
    if (created.length > 1) {
      const sel = new fabric.ActiveSelection(created, { canvas: this.canvas });
      sel.set({ lockScalingFlip: true });
      sel.setControlsVisibility({
        mt: true, mb: true, ml: true, mr: true,
        tl: true, tr: true, bl: true, br: true, mtr: true,
      });
      this.canvas.setActiveObject(sel);
      this.multiSelectionActive = true;
    } else if (created.length === 1) {
      this.canvas.setActiveObject(created[0]);
    }
    this.canvas.renderAll();
  }

  private async duplicateOne(o: any): Promise<any> {
    // Mismo offset para todos: se restablece antes de cada copia (pasteCopied lo incrementa).
    this.pasteOffset = 20;
    this.lastPastedObject = null;
    // Comprobar groupSeat antes que objectId: una sección de butacas no se duplica como objeto suelto.
    if (o.groupSeat) {
      const key = this.getSectionKeyForGroup(o);
      if (key == null) return null;
      this.clipboardSectionKey = +key;
      this.clipboardObjectId = null;
    } else if (o.objectId) {
      this.clipboardObjectId = o.objectId;
      this.clipboardSectionKey = null;
    } else {
      return null;
    }
    await this.pasteCopied(true);
    return this.lastPastedObject;
  }

  // Resuelve la clave de this.seatSections para un grupo de butacas del canvas. La id interna del
  // grupo (seatsGroupConfig.section.id) puede no coincidir con la clave (que en mapas cargados es
  // la id de BD), así que se compara contra varias referencias.
  private getSectionKeyForGroup(group: any): string | null {
    // 1) Etiqueta fiable puesta al crear/duplicar la sección.
    if (group?.sectionKey != null && this.seatSections[+group.sectionKey]) {
      return String(group.sectionKey);
    }
    // 2) Fallback: emparejar por la id de sección del sub-grupo interno.
    const seatsChild = (group?._objects || []).find((c: any) => c?.section?.id != null);
    const sectionId = seatsChild?.section?.id;
    if (sectionId == null) return null;
    const match = Object.keys(this.seatSections).find((k) =>
      +k === +sectionId ||
      +this.seatSections[+k]?.section?.id === +sectionId ||
      +this.seatSections[+k]?.section?.configuration?.seatsGroupConfig?.section?.id === +sectionId
    );
    return match ?? null;
  }

  // Devuelve el layerGroupId común si TODOS los objetos dados ya pertenecen al mismo grupo lógico
  // de capas (ver groupSelectionAsLayer/persistLayerGroupId); null si no comparten ninguno.
  private getSharedCurveGroupId(objs: any[]): string | null {
    if (!objs.length) return null;
    const ids = objs.map((o) => o.layerGroupId).filter(Boolean);
    if (ids.length !== objs.length) return null;
    return ids.every((id) => id === ids[0]) ? ids[0] : null;
  }

  saveHistorySnapshot() {
    if (this.isUndoing) return;
    const snapshot = {
      canvasObjects: JSON.parse(JSON.stringify(this.canvasObjects)),
      seatSections: JSON.parse(JSON.stringify(this.seatSections)),
      sectionNumber: this.sectionNumber,
      objectIdCounter: this.objectIdCounter
    };
    this.historyStack.push(snapshot);
    if (this.historyStack.length > this.historyMaxSize) {
      this.historyStack.shift();
    }
  }

  undo() {
    if (this.historyStack.length === 0) return;
    const snapshot = this.historyStack.pop();
    this.restoreCanvasFromState(snapshot);
  }

  async restoreCanvasFromState(snapshot: any) {
    this.isUndoing = true;
    this.canvas.discardActiveObject();
    this.clearedObjectSelect();
    const objsToRemove = this.canvas.getObjects().slice();
    objsToRemove.forEach((obj: any) => this.canvas.remove(obj));

    this.canvasObjects = snapshot.canvasObjects;
    this.seatSections = snapshot.seatSections;
    this.sectionNumber = snapshot.sectionNumber;
    this.objectIdCounter = snapshot.objectIdCounter;

    this.generateMapService.setObjectsMap(this.canvasObjects);
    this.generateMapService.setSeatSections(this.seatSections);
    this.refreshLevelsList();
    localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));

    // Igual que en la carga inicial: respeta el zIndex guardado y espera a los elementos
    // asíncronos (escenario/imagen) para no romper el orden de apilamiento al deshacer.
    await this.recreateAllLayers();
    this.applyHiddenLayerState();

    this.applyMapModeVisibility();
    this.isUndoing = false;
    this.refreshLayersList();
  }

  addForm() {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();
    const rect = this.generateMapService.addRectObject({ objectId, left: center.x, top: center.y });
    if (preview) rect.set({ previewLayer: true, navZoneLevels: [], name: null });
    this.canvas.add(rect);
    this.canvas.sendToBack(rect);
    this.canvas.setActiveObject(rect);
    const objectData: any = {
      left: rect.left,
      top: rect.top,
      fill: rect.fill,
      stroke: rect.stroke,
      strokeWidth: rect.strokeWidth,
      scaleX: rect.scaleX,
      scaleY: rect.scaleY,
      angle: rect.angle || 0,
      width: rect.width,
      height: rect.height,
      objectId: objectId,
      level: null
    };
    if (preview) { objectData.previewLayer = true; objectData.levels = []; objectData.name = null; }
    this.saveCanvasObject(objectId, 'rect', objectData);
    this.canvas.renderAll();
  }

  addEllipse() {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();
    const ellipse = this.generateMapService.addEllipseObject({ objectId, left: center.x, top: center.y });
    if (preview) ellipse.set({ previewLayer: true, navZoneSections: [], name: null });
    this.canvas.add(ellipse);
    this.canvas.sendToBack(ellipse);
    this.canvas.setActiveObject(ellipse);
    const objectData: any = {
      left: ellipse.left,
      top: ellipse.top,
      fill: ellipse.fill,
      stroke: ellipse.stroke,
      strokeWidth: ellipse.strokeWidth,
      scaleX: ellipse.scaleX,
      scaleY: ellipse.scaleY,
      angle: ellipse.angle || 0,
      rx: ellipse.rx,
      ry: ellipse.ry,
      objectId: objectId,
      level: null
    };
    if (preview) { objectData.previewLayer = true; objectData.sections = []; objectData.name = null; }
    this.saveCanvasObject(objectId, 'ellipse', objectData);
    this.canvas.renderAll();
  }

  addLine() {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();
    const line = this.generateMapService.addLineObject({ objectId, left: center.x, top: center.y });
    if (preview) line.set({ previewLayer: true, navZoneSections: [], name: null });
    this.canvas.add(line);
    this.canvas.sendToBack(line);
    this.canvas.setActiveObject(line);
    const objectData: any = {
      left: line.left,
      top: line.top,
      stroke: line.stroke,
      strokeWidth: line.strokeWidth,
      scaleX: line.scaleX,
      scaleY: line.scaleY,
      angle: line.angle || 0,
      points: (line as any).linePoints,
      curvature: (line as any).curvature || 0,
      objectId: objectId,
      level: null
    };
    if (preview) { objectData.previewLayer = true; objectData.sections = []; objectData.name = null; }
    this.saveCanvasObject(objectId, 'line', objectData);
    this.canvas.renderAll();
  }

  async addSectionFree() {
    this.canvas.discardActiveObject();
    const center = this.getCanvasCenter();
    const result = await this.generateMapService.addGroupInfo(
      this.canvas,
      this.seatsElement,
      'Sección libre',
      this.colorDefaultFree,
      'Capacidad',
      this.sectionNumber,
      center
    );

    // this.canvas.add(result.group);
    // this.canvas.renderAll();
    this.sectionNumber++;
  }

  async addStandSection() {
    this.saveHistorySnapshot();
    this.canvas.discardActiveObject();
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();

    const result = await this.generateMapService.addGroupInfoWithSave(
      this.canvas,
      this.shoesElement,
      'Pista',
      this.colorDefaultStand,
      'Capacidad',
      objectId,
      this.sectionNumber,
      center
    );

    // ✅ Guardar objeto en localStorage
    this.saveCanvasObject(objectId, 'standSection', result.objectData);
    this.sectionNumber++;
  }

  // Añadir asiento
  openSeatConfigDialog() {
    if (!this.levels || this.levels.length === 0) {
      this.openInfo('Debes crear al menos un nivel antes de añadir una sección de butacas.');
      return;
    }
    const dialogRef = this.dialog.open(CreateSeatsComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      data: {
        rows: 15, // Valores por defecto
        columns: 12
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmed) {
        // Llamar al método actual addSeat con los parámetros del popup
        this.addSeat(result.rows, result.columns);
      }
    });
  }

  addSeat(rows: number, columns: number) {
    this.saveHistorySnapshot();
    this.canvas.discardActiveObject();
    const center = this.getCanvasCenter();

    const { mainGroup, sectionObject } = this.generateMapService.addGroupSeats(rows, columns, this.sectionNumber, undefined, false, [], this.isSuperAdminEditMode);
    // Move the group to the visible canvas center after creation
    mainGroup.set({ left: center.x, top: center.y });
    mainGroup.setCoords();
    mainGroup.sectionKey = this.sectionNumber;

    this.seatSections[this.sectionNumber] = sectionObject;
    // Update saved position to match the center
    if (this.seatSections[this.sectionNumber]?.section?.configuration) {
      this.seatSections[this.sectionNumber].section.configuration.left = center.x;
      this.seatSections[this.sectionNumber].section.configuration.top = center.y;
    }
    this.generateMapService.setSeatSections(this.seatSections);
    this.refreshLevelsList();

    this.sectionNumber++;
    this.canvas.add(mainGroup);
  }

  addPoligon() {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter}`;
    const center = this.getCanvasCenter();
    const polygon = this.generateMapService.addPoligonObject({ objectId, left: center.x, top: center.y });
    if (preview) polygon.set({ previewLayer: true, navZoneLevels: [], name: null });
    this.canvas.add(polygon);
    this.canvas.sendToBack(polygon);
    this.canvas.setActiveObject(polygon);
    const objectData: any = {
      points: polygon.points,
      left: polygon.left,
      top: polygon.top,
      fill: polygon.fill,
      stroke: polygon.stroke,
      strokeWidth: polygon.strokeWidth,
      scaleX: polygon.scaleX,
      scaleY: polygon.scaleY,
      angle: polygon.angle || 0,
      width: polygon.width,
      height: polygon.height,
      objectId: objectId,
      level: null,
      cornerRadius: polygon.cornerRadius || 0,
      edgeCurvatures: Array.isArray(polygon.edgeCurvatures) ? [...polygon.edgeCurvatures] : undefined
    };
    if (preview) { objectData.previewLayer = true; objectData.levels = []; objectData.name = null; }
    this.saveCanvasObject(objectId, 'polygon', objectData);
    this.canvas.renderAll();
  }

  addText() {
    this.saveHistorySnapshot();
    const preview = this.creatingInPreview;
    const objectId = `obj_${this.objectIdCounter++}`;
    const center = this.getCanvasCenter();
    const text = new fabric.Textbox('Escribe un texto...', {
      width: 200,
      height: 100,
      fontSize: 24,
      lineHeight: 1,
      fontFamily: 'Satoshi-Regular',
      cursorColor: '#FF4D80',
      fill: '#000000',
      left: center.x,
      top: center.y,
      eventSeat: false,
      objectId: objectId
    });
    if (preview) (text as any).set('previewLayer', true);
    this.canvas.add(text);
    this.canvas.setActiveObject(text);
    this.canvas.renderAll();

    this.saveCanvasObject(objectId, 'text', {
      left: text.left,
      top: text.top,
      scaleX: text.scaleX || 1,
      scaleY: text.scaleY || 1,
      angle: text.angle || 0,
      objectId: objectId,
      text: 'Escribe un texto...',
      width: 200,
      height: 100,
      fontSize: 24,
      lineHeight: 1,
      fill: '#000000',
      cursorColor: '#FF4D80',
      previewLayer: preview
    });
  }

  // Select Object and Edit
  clickSelectObject(element: any) {
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditScenary = false;
    this.openEditText = false;
    this.openEditImage = false;
    this.editingImageObject = null;
    this.objectEditing = null;
    setTimeout(() => {
      this.activeTab = true;
      this.titleTab = 'Sección';
      this.openEditObject = true;
      this.objectEditing = element;
    });
  }

  // Reconstruye en el canvas una sección de butacas tras cambiar sus filas/columnas.
  // Sustituye el grupo antiguo por el regenerado desde seatSections y reengancha la
  // selección SIN recrear el panel: suprime los handlers de selección para que edit-section
  // se resincronice vía ngOnChanges (soporta ediciones repetidas).
  rebuildSectionOnCanvas(sectionKey: any) {
    const key = String(sectionKey);
    const data = this.generateMapService.getSeatSections()?.[+sectionKey];
    if (!data) return;

    this.rebuildingSection = true;
    try {
      const old = this.canvas?._objects?.find((o: any) => o.groupSeat && String(o.sectionKey) === key);
      if (old) {
        this.canvas.discardActiveObject();
        this.canvas.remove(old);
      }

      this.seatSections = this.generateMapService.getSeatSections();
      this.createSectionFromData(data, +sectionKey);

      const fresh = this.canvas._objects.find((o: any) => o.groupSeat && String(o.sectionKey) === key);
      if (fresh) {
        this.canvas.setActiveObject(fresh);
        fresh.set('hasControls', true);
        // Reasignar el grupo editado: edit-section detecta el cambio (ngOnChanges) y resincroniza.
        this.objectEditing = fresh;
      }
      this.canvas.requestRenderAll();
    } finally {
      this.rebuildingSection = false;
    }
  }

  // Reconstruye la sección radial que se está editando (cada sección tiene su propio centro
  // de curvatura), manteniendo el marcador de centro activo para seguir arrastrándolo.
  rebuildRadialSectionsOnCanvas(currentKey: any) {
    const sections = this.generateMapService.getSeatSections() || {};
    this.rebuildingSection = true;
    try {
      const data = sections[+currentKey];
      if (data) {
        const old = this.canvas?._objects?.find((o: any) => o.groupSeat && String(o.sectionKey) === String(currentKey));
        if (old) this.canvas.remove(old);
        this.seatSections = this.generateMapService.getSeatSections();
        this.createSectionFromData(data, +currentKey);
      }
      const fresh = this.canvas._objects.find((o: any) => o.groupSeat && String(o.sectionKey) === String(currentKey));
      if (fresh) {
        fresh.set('hasControls', true);
        // Reasignar la referencia editada sin robar el foco: edit-section resincroniza (ngOnChanges).
        this.objectEditing = fresh;
      }
      // Mantener el marcador de centro activo para seguir arrastrándolo; si no hay, seleccionar la sección.
      const marker = this.canvas._objects.find((o: any) => o.isCurvatureCenter);
      (this.canvas as any)._pivotInternal = true;
      if (marker) {
        marker.bringToFront();
        this.canvas.setActiveObject(marker);
      } else if (fresh) {
        this.canvas.setActiveObject(fresh);
      }
      (this.canvas as any)._pivotInternal = false;
      this.canvas.requestRenderAll();
    } finally {
      this.rebuildingSection = false;
    }
  }

  clickSelectSection(element: any) {
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditScenary = false;
    this.openEditText = false;
    this.openEditImage = false;
    this.editingImageObject = null;
    this.objectEditing = null;
    if (element?.previewLayer) {
      this.refreshAvailableShapesList(element.objectId);
    }
    setTimeout(() => {
      this.activeTab = true;
      this.titleTab = 'Información de sección';
      this.openEditSection = true;
      this.objectEditing = element;
    });
  }

  clickSelectText(element: any) {
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditScenary = false;
    this.openEditImage = false;
    this.editingImageObject = null;
    this.objectEditing = null;
    this.activeTab = true;
    this.titleTab = 'Texto';
    this.openEditText = true;
    this.editingTextObject = element;
    this.editingTextFontSize = element.fontSize || 24;
    this.editingTextLineHeight = element.lineHeight || 1;
    this.editingTextContent = element.text || '';
    this.editingTextColor = element.fill || '#000000';
    this.editingTextObjectId = element.objectId || '';
  }

  clickSelectImage(element: any) {
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditScenary = false;
    this.openEditText = false;
    this.objectEditing = null;
    this.activeTab = true;
    this.titleTab = element?.isSvgImage ? 'SVG' : 'Imagen';
    this.openEditImage = true;
    this.editingImageObject = element;
    this.editingImageAngle = element.angle || 0;
  }

  // Aplica la rotación introducida (número o slider) a la imagen seleccionada.
  updateImageAngle(value: any) {
    if (!this.editingImageObject) return;
    const angle = parseInt(value, 10) || 0;
    this.editingImageObject.set('angle', angle).setCoords();
    this.canvas.renderAll();
    const objectId = this.editingImageObject.objectId;
    if (objectId && this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration.angle = angle;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Trae la imagen al frente de todos los demás objetos del canvas.
  bringImageToFront() {
    this.bringObjectToFront(this.editingImageObject);
  }

  // Manda la imagen al fondo, detrás de todos los demás objetos del canvas.
  sendImageToBack() {
    this.sendObjectToBack(this.editingImageObject);
  }

  private bringObjectToFront(obj: any) {
    if (!obj?.objectId) return;
    this.saveHistorySnapshot();
    this.canvas.bringToFront(obj);
    this.canvas.renderAll();
    this.moveCanvasObjectOrder(obj.objectId, 'front');
  }

  private sendObjectToBack(obj: any) {
    if (!obj?.objectId) return;
    this.saveHistorySnapshot();
    this.canvas.sendToBack(obj);
    this.canvas.renderAll();
    this.moveCanvasObjectOrder(obj.objectId, 'back');
  }

  // Reordena la entrada en canvasObjects para que la próxima carga del mapa reconstruya los
  // objetos en el mismo orden de apilamiento (recreateSectionsFromStorage respeta el orden
  // de inserción del diccionario al recrear cada objeto).
  private moveCanvasObjectOrder(objectId: string, position: 'front' | 'back') {
    if (!this.canvasObjects[objectId]) return;
    const entry = this.canvasObjects[objectId];
    const rest = { ...this.canvasObjects };
    delete rest[objectId];
    this.canvasObjects = position === 'front' ? { ...rest, [objectId]: entry } : { [objectId]: entry, ...rest };
    localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
    this.generateMapService.setObjectsMap(this.canvasObjects);
  }

  // ===================== Panel de capas =====================

  toggleLayersPanel() {
    this.openLayersPanel = !this.openLayersPanel;
    if (this.openLayersPanel) {
      this.refreshLayersList();
    }
  }

  // Objetos internos del editor que no son "capas" reales (marcadores, labels flotantes, recorte).
  private isLayerCandidate(obj: any): boolean {
    if (!obj) return false;
    if (obj.zoneLabelFor) return false;
    if (obj.isCurvatureCenter) return false;
    if (obj === this.cropRect) return false;
    return true;
  }

  // Icono + nombre legible de una capa, según el tipo de objeto fabric. El nombre personalizado
  // (renombrado desde el panel, guardado en configuration.name / section.name) siempre tiene
  // prioridad sobre la etiqueta por defecto de cada tipo.
  private describeLayer(obj: any): { icon: string; label: string } {
    if (obj.groupSeat) {
      const name = this.seatSections[+obj.sectionKey]?.section?.name;
      return { icon: 'fa-light fa-loveseat', label: name || 'Sección de butacas' };
    }
    const customName = obj.objectId ? this.canvasObjects[obj.objectId]?.configuration?.name : null;
    if (obj.isScenary) {
      const text = obj._objects?.find((o: any) => o.type === 'text')?.text;
      return { icon: 'fa-light fa-tv', label: customName || text || 'Escenario' };
    }
    if (obj.isInfoSection) {
      if (obj.isLine) return { icon: 'fa-light fa-slash', label: customName || 'Línea' };
      if (obj.type === 'ellipse') return { icon: 'fa-light fa-circle', label: customName || 'Círculo / Elipse' };
      if (obj.type === 'rect') return { icon: 'fa-light fa-rectangle', label: customName || 'Rectángulo' };
      return { icon: 'fa-light fa-draw-polygon', label: customName || 'Polígono' };
    }
    if ((obj.type === 'textbox' || obj.type === 'text') && obj.objectId) {
      const text = (obj.text || '').trim();
      return { icon: 'fa-light fa-input-text', label: customName || (text ? (text.length > 24 ? text.slice(0, 24) + '…' : text) : 'Texto') };
    }
    if (obj.isSvgImage && obj.objectId) {
      return { icon: 'fa-light fa-bezier-curve', label: customName || 'SVG' };
    }
    if (obj.type === 'image' && obj.objectId) {
      return { icon: 'fa-light fa-image', label: customName || 'Imagen' };
    }
    if (obj.isSection && obj.objectId) {
      const text = obj._objects?.find((o: any) => o.type === 'text')?.text;
      return { icon: 'fa-light fa-shoe-prints', label: customName || text || 'Pista' };
    }
    return { icon: 'fa-light fa-shapes', label: customName || 'Elemento' };
  }

  // Reconstruye la lista de capas a partir del orden real de apilamiento del canvas
  // (canvas.getObjects() va de fondo a frente; aquí se invierte para mostrar el frente primero).
  refreshLayersList() {
    if (!this.canvas) { this.layersList = []; return; }
    const zones = this.mapMode === 'zones';
    const objects = (this.canvas.getObjects() || []).filter((o: any) =>
      this.isLayerCandidate(o) && (zones ? !!o.previewLayer : !o.previewLayer)
    );
    const ordered = objects.map((o: any) => ({ fabricObject: o, hidden: !!o.userHiddenLayer, ...this.describeLayer(o) })).reverse();

    // Colapsa en una única entrada los elementos que comparten layerGroupId (creado con
    // "Agrupar en una capa"), conservando la posición del primero que aparece en el listado.
    const result: any[] = [];
    const groupEntries = new Map<string, any>();
    ordered.forEach((entry: any) => {
      const groupId = entry.fabricObject?.layerGroupId;
      if (!groupId) {
        result.push(entry);
        return;
      }
      let groupEntry = groupEntries.get(groupId);
      if (!groupEntry) {
        groupEntry = { isGroup: true, groupId, icon: 'fa-light fa-object-group', label: '', hidden: true, children: [] };
        groupEntries.set(groupId, groupEntry);
        result.push(groupEntry);
      }
      groupEntry.children.push(entry);
    });
    groupEntries.forEach((groupEntry) => {
      const customName = groupEntry.children.find((c: any) => c.fabricObject?.layerGroupName)?.fabricObject?.layerGroupName;
      groupEntry.label = customName || `Grupo de capas (${groupEntry.children.length})`;
      groupEntry.hidden = groupEntry.children.every((c: any) => c.hidden);
      // Distingue visualmente los grupos con curvatura guardada (ver commitCurveSelection), para
      // que se note a simple vista cuáles reabren el panel de curvatura al reseleccionarlos.
      const hasCurveConfig = groupEntry.children.some((c: any) => !!c.fabricObject?.curveConfig);
      groupEntry.icon = hasCurveConfig ? 'fa-light fa-bezier-curve' : 'fa-light fa-object-group';
    });

    this.layersList = result;
    // Una vez cargado el mapa, cada recálculo de la lista mantiene el zIndex guardado en
    // sincronía con el orden real del canvas (nuevos elementos, borrados, reordenados…), para
    // que la próxima carga (recreateAllLayers) reproduzca exactamente este apilamiento.
    if (this.loadedMap) {
      this.persistLayersZIndex();
    }
  }

  // Aplana las entradas del listado de capas (expandiendo los grupos en sus hijos) preservando
  // el orden, para operaciones que necesitan la lista real de objetos fabric (z-order, drag&drop).
  private flattenLayerEntries(list: any[]): any[] {
    const result: any[] = [];
    (list || []).forEach((entry: any) => {
      if (entry.isGroup) result.push(...(entry.children || []));
      else result.push(entry);
    });
    return result;
  }

  // Selecciona la capa en el canvas: reutiliza los listeners de selección existentes, que abren
  // el panel de edición correspondiente según el tipo de objeto. También desbloquea explícitamente
  // mover/redimensionar/rotar, para poder transformar la capa igual que si se hubiera clicado
  // directamente sobre ella en el canvas.
  selectLayer(layer: any) {
    if (!layer || !this.isSuperAdminEditMode || layer.renaming) return;
    if (layer.isGroup) {
      const objs = (layer.children || []).map((c: any) => c.fabricObject).filter((o: any) => o?.selectable);
      if (objs.length === 0) return;
      objs.forEach((o: any) => this.unlockLayerTransforms(o));
      if (objs.length === 1) {
        this.canvas.setActiveObject(objs[0]);
      } else {
        const sel = new fabric.ActiveSelection(objs, { canvas: this.canvas });
        this.canvas.setActiveObject(sel);
      }
      this.canvas.requestRenderAll();
      return;
    }
    if (!layer.fabricObject || !layer.fabricObject.selectable) return;
    this.unlockLayerTransforms(layer.fabricObject);
    this.canvas.setActiveObject(layer.fabricObject);
    this.canvas.requestRenderAll();
  }

  // Se asegura de que la capa pueda moverse, redimensionarse y rotarse al seleccionarla desde el
  // panel, sin depender de flags de bloqueo que puedan haber quedado de otros flujos.
  private unlockLayerTransforms(obj: any) {
    obj.set({
      hasControls: true,
      hasBorders: true,
      lockMovementX: false,
      lockMovementY: false,
      lockRotation: false,
      lockScalingX: false,
      lockScalingY: false,
      lockScalingFlip: false,
    });
  }

  // Oculta/muestra una capa desde el listado (icono de ojo). Una capa oculta no se renderiza y
  // queda excluida tanto del click individual como del recuadro de selección masiva (fabric
  // ignora los objetos con selectable/visible en false al recolectar la selección).
  toggleLayerVisibility(layer: any, event?: Event) {
    event?.stopPropagation();
    if (!layer) return;
    if (layer.isGroup) {
      const hide = !layer.hidden;
      (layer.children || []).forEach((c: any) => this.setLayerHidden(c.fabricObject, hide));
      this.applyMapModeVisibility();
      return;
    }
    const obj = layer.fabricObject;
    if (!obj) return;
    this.setLayerHidden(obj, !obj.userHiddenLayer);
    this.applyMapModeVisibility();
  }

  // Aplica y persiste el estado oculto/visible de un único objeto fabric.
  private setLayerHidden(obj: any, hide: boolean) {
    if (!obj) return;
    obj.userHiddenLayer = hide;
    obj.selectable = !hide;
    obj.evented = !hide;
    if (hide && this.canvas.getActiveObject() === obj) {
      this.clearedObjectSelect();
    }
    this.persistLayerHiddenState(obj, hide);
  }

  // Guarda el estado oculto/visible de una capa en su configuración persistida (canvasObjects o
  // seatSections, según el tipo), para que sobreviva a un F5 / recarga del mapa.
  private persistLayerHiddenState(obj: any, hide: boolean) {
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      if (key == null) return;
      const cfg = this.seatSections[+key]?.section?.configuration;
      if (!cfg) return;
      cfg.hidden = hide;
      this.generateMapService.setSeatSections(this.seatSections);
    } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
      this.canvasObjects[obj.objectId].configuration.hidden = hide;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Aplica el estado oculto guardado en `configuration.hidden` a los objetos recién recreados en
  // el canvas (tras cargar el mapa), para que las capas ocultadas antes de recargar sigan
  // ocultas y no puedan seleccionarse mediante la selección masiva.
  private applyHiddenLayerState() {
    (this.canvas._objects || []).forEach((obj: any) => {
      let cfg: any = null;
      if (obj.groupSeat) {
        const key = this.getSectionKeyForGroup(obj);
        cfg = key != null ? this.seatSections[+key]?.section?.configuration : null;
      } else if (obj.objectId) {
        cfg = this.canvasObjects[obj.objectId]?.configuration;
      } else {
        return;
      }
      const hidden = !!cfg?.hidden;
      obj.userHiddenLayer = hidden;
      if (hidden) {
        obj.selectable = false;
        obj.evented = false;
      }
      if (cfg?.layerGroupId) {
        obj.layerGroupId = cfg.layerGroupId;
      }
      if (cfg?.layerGroupName) {
        obj.layerGroupName = cfg.layerGroupName;
      }
      if (cfg?.curveConfig) {
        obj.curveConfig = cfg.curveConfig;
      }
    });
  }

  // Inicia el renombrado inline de una capa (o de un grupo de capas) desde el listado.
  startRenameLayer(layer: any, event?: Event) {
    event?.stopPropagation();
    if (!layer) return;
    layer.renaming = true;
    layer.renameValue = layer.label;
  }

  cancelRenameLayer(layer: any, event?: Event) {
    event?.stopPropagation();
    if (layer) layer.renaming = false;
  }

  // Confirma el renombrado: persiste el nombre en la configuración del objeto (o de todos los
  // miembros, si es una entrada de grupo) y refresca el listado para recalcular etiquetas.
  confirmRenameLayer(layer: any, event?: Event) {
    event?.stopPropagation();
    if (!layer?.renaming) return;
    layer.renaming = false;
    const newName = (layer.renameValue || '').trim();
    if (layer.isGroup) {
      (layer.children || []).forEach((c: any) => {
        if (!c.fabricObject) return;
        c.fabricObject.layerGroupName = newName || null;
        this.persistLayerGroupName(c.fabricObject, newName);
      });
    } else if (layer.fabricObject) {
      this.persistLayerName(layer.fabricObject, newName);
    } else {
      return;
    }
    this.refreshLayersList();
  }

  // Guarda (o borra) el nombre personalizado de una capa suelta: section.name para secciones de
  // butacas, configuration.name para el resto (el mismo campo que ya usan formas/imágenes).
  private persistLayerName(obj: any, name: string) {
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      if (key == null) return;
      const section = this.seatSections[+key]?.section;
      if (!section) return;
      section.name = name || null;
      this.generateMapService.setSeatSections(this.seatSections);
    } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
      this.canvasObjects[obj.objectId].configuration.name = name || null;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Guarda (o borra) el nombre personalizado de una entrada de grupo de capas, duplicado en la
  // configuración de cada miembro para que sobreviva a un F5 / recarga del mapa.
  private persistLayerGroupName(obj: any, name: string) {
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      if (key == null) return;
      const cfg = this.seatSections[+key]?.section?.configuration;
      if (!cfg) return;
      if (name) cfg.layerGroupName = name; else delete cfg.layerGroupName;
      this.generateMapService.setSeatSections(this.seatSections);
    } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
      const cfg = this.canvasObjects[obj.objectId].configuration;
      if (name) cfg.layerGroupName = name; else delete cfg.layerGroupName;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Agrupa la selección múltiple activa en una única "capa" del panel: no altera cómo se mueven,
  // redimensionan o rotan los objetos (siguen siendo independientes en el canvas), solo los liga
  // lógicamente para que aparezcan como una sola entrada y se puedan ocultar/mostrar en bloque.
  groupSelectionAsLayer() {
    const active = this.canvas?.getActiveObject() as any;
    if (!active || active.type !== 'activeSelection') return;
    const objs = this.canvas.getActiveObjects().filter((o: any) => o.groupSeat || o.objectId);
    if (objs.length < 2) return;
    this.saveHistorySnapshot();
    const groupId = `layerGroup_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    objs.forEach((o: any) => {
      o.layerGroupId = groupId;
      this.persistLayerGroupId(o, groupId);
    });
    this.refreshLayersList();
  }

  // Deshace la agrupación lógica de una entrada de grupo: cada capa vuelve a listarse por separado.
  ungroupLayer(layer: any, event?: Event) {
    event?.stopPropagation();
    if (!layer?.isGroup) return;
    this.saveHistorySnapshot();
    (layer.children || []).forEach((c: any) => {
      const obj = c.fabricObject;
      if (!obj) return;
      delete obj.layerGroupId;
      delete obj.curveConfig;
      this.persistLayerGroupId(obj, null);
      this.persistCurveConfig(obj, null);
    });
    this.refreshLayersList();
  }

  // Guarda (o borra) el layerGroupId de un objeto en su configuración persistida, para que la
  // agrupación lógica de capas sobreviva a un F5 / recarga del mapa.
  private persistLayerGroupId(obj: any, groupId: string | null) {
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      if (key == null) return;
      const cfg = this.seatSections[+key]?.section?.configuration;
      if (!cfg) return;
      if (groupId) cfg.layerGroupId = groupId; else delete cfg.layerGroupId;
      this.generateMapService.setSeatSections(this.seatSections);
    } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
      const cfg = this.canvasObjects[obj.objectId].configuration;
      if (groupId) cfg.layerGroupId = groupId; else delete cfg.layerGroupId;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Lee (sin persistir nada) la configuración de curvatura guardada de un objeto, si la tiene.
  // Contrapartida de solo-lectura de persistCurveConfig, misma ramificación que persistLayerGroupId.
  private getStoredCurveConfig(obj: any): any | null {
    if (!obj) return null;
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      return key != null ? (this.seatSections[+key]?.section?.configuration?.curveConfig || null) : null;
    }
    if (obj.objectId) {
      return this.canvasObjects[obj.objectId]?.configuration?.curveConfig || null;
    }
    return null;
  }

  // Guarda (o borra, si config es null) la configuración de curvatura de un objeto en su
  // configuración persistida, igual que persistLayerGroupId hace con layerGroupId.
  private persistCurveConfig(obj: any, config: any | null) {
    if (obj.groupSeat) {
      const key = this.getSectionKeyForGroup(obj);
      if (key == null) return;
      const cfg = this.seatSections[+key]?.section?.configuration;
      if (!cfg) return;
      if (config) cfg.curveConfig = config; else delete cfg.curveConfig;
      this.generateMapService.setSeatSections(this.seatSections);
    } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
      const cfg = this.canvasObjects[obj.objectId].configuration;
      if (config) cfg.curveConfig = config; else delete cfg.curveConfig;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  // Elimina una capa desde el listado (icono de papelera).
  deleteLayer(layer: any, event?: Event) {
    event?.stopPropagation();
    if (!layer) return;
    this.saveHistorySnapshot();
    this.clearedObjectSelect();
    if (layer.isGroup) {
      const objs = (layer.children || []).map((c: any) => c.fabricObject).filter(Boolean);
      if (objs.length === 0) return;
      objs.forEach((o: any) => this.canvas.remove(o));
    } else {
      if (!layer.fabricObject) return;
      this.canvas.remove(layer.fabricObject);
    }
    this.canvas.renderAll();
  }

  // Drag & drop de capas: reordena visualmente en el canvas y persiste el nuevo orden. Arrastrar
  // una entrada de grupo mueve todos sus miembros juntos, manteniendo su orden relativo interno.
  onLayerDrop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    this.saveHistorySnapshot();
    moveItemInArray(this.layersList, event.previousIndex, event.currentIndex);
    // layersList está de frente a fondo; fabric ordena sus objetos de fondo a frente, así que se
    // reinserta cada objeto en orden inverso llamando a canvas.moveTo con su nuevo índice.
    const bottomToTop = this.flattenLayerEntries(this.layersList).reverse().map(l => l.fabricObject);
    bottomToTop.forEach((obj, index) => this.canvas.moveTo(obj, index));
    this.canvas.requestRenderAll();
    this.persistLayersZIndex();
  }

  // Escribe en `configuration.zIndex` de cada capa (sección u objeto) su posición actual en el
  // canvas, para que la próxima carga (recreateAllLayers) reproduzca el mismo apilamiento.
  // Se guarda dentro de `configuration` porque esa es la única parte de cada entidad que el
  // backend persiste tal cual (JSON), tanto para canvasObjects (map_configuration) como para
  // secciones (columna configuration de map_sections) — no requiere cambios de backend.
  private persistLayersZIndex() {
    const bottomToTop = this.flattenLayerEntries(this.layersList).reverse();
    let changedObjects = false;
    let changedSections = false;
    bottomToTop.forEach((layer, index) => {
      const obj = layer.fabricObject;
      if (obj.groupSeat && obj.sectionKey != null && this.seatSections[+obj.sectionKey]) {
        const section = this.seatSections[+obj.sectionKey].section;
        section.configuration = section.configuration || {};
        if (section.configuration.zIndex !== index) {
          section.configuration.zIndex = index;
          changedSections = true;
        }
      } else if (obj.objectId && this.canvasObjects[obj.objectId]) {
        const cfg = this.canvasObjects[obj.objectId].configuration;
        if (cfg.zIndex !== index) {
          cfg.zIndex = index;
          changedObjects = true;
        }
      }
    });
    if (changedObjects) {
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    if (changedSections) {
      this.generateMapService.setSeatSections(this.seatSections);
    }
  }

  // Inicia el modo recorte: superpone un recuadro ajustable sobre la imagen, con la misma
  // posición/ángulo/escala, para que el usuario seleccione el área a conservar.
  startCropImage() {
    const img = this.editingImageObject;
    if (!img || this.cropModeActive) return;
    // El recorte trabaja sobre píxeles (drawImage + toDataURL), así que convertiría un SVG en
    // bitmap y volvería a pixelarse al hacer zoom. No se ofrece para vectores.
    if (img.isSvgImage) return;
    this.saveHistorySnapshot();
    this.cropModeActive = true;
    // El recuadro de recorte es un fabric.Rect "genérico" (sin objectId ni flags especiales):
    // al seleccionarlo, los listeners de selección lo tratarían como clic en vacío y cerrarían
    // el panel (clearedObjectSelect), cancelando el recorte antes de empezar. blockComponents
    // suprime esa rama mientras dure el modo recorte.
    this.blockComponents = true;

    const rect = new fabric.Rect({
      left: img.left,
      top: img.top,
      width: img.width,
      height: img.height,
      scaleX: img.scaleX,
      scaleY: img.scaleY,
      angle: img.angle || 0,
      originX: 'center',
      originY: 'center',
      fill: 'rgba(255,77,128,0.15)',
      stroke: '#FF4D80',
      strokeWidth: 1,
      strokeUniform: true,
      lockRotation: true,
      cornerColor: '#FF4D80',
      transparentCorners: false,
    });
    rect.setControlVisible('mtr', false);
    this.cropRect = rect;
    img.set({ opacity: 0.35, selectable: false, evented: false });
    this.canvas.add(rect);
    this.canvas.setActiveObject(rect);
    this.canvas.renderAll();
  }

  // Aplica el recorte: recalcula el área seleccionada en coordenadas locales (sin escala/rotación)
  // de la imagen original usando su matriz de transformación, recorta a un canvas auxiliar y
  // sustituye la imagen por la versión recortada conservando posición visual, ángulo y escala.
  async applyCropImage() {
    const img = this.editingImageObject;
    const rect = this.cropRect;
    if (!img || !rect) { this.cancelCropImage(); return; }

    const invImgMatrix = fabric.util.invertTransform(img.calcTransformMatrix());
    rect.setCoords();
    const corners = ['tl', 'tr', 'br', 'bl'].map((k: string) => (rect.aCoords as any)[k]);
    const localPts = corners.map((p: any) => fabric.util.transformPoint(p, invImgMatrix));
    const localXs = localPts.map((p: any) => p.x);
    const localYs = localPts.map((p: any) => p.y);
    const halfW = img.width / 2;
    const halfH = img.height / 2;

    const sx0 = Math.max(-halfW, Math.min(...localXs));
    const sy0 = Math.max(-halfH, Math.min(...localYs));
    const ex0 = Math.min(halfW, Math.max(...localXs));
    const ey0 = Math.min(halfH, Math.max(...localYs));
    const rawW = ex0 - sx0;
    const rawH = ey0 - sy0;
    if (rawW < 4 || rawH < 4) { this.cancelCropImage(); return; }

    const sx = Math.round(sx0 + halfW);
    const sy = Math.round(sy0 + halfH);
    const sw = Math.round(rawW);
    const sh = Math.round(rawH);

    const source = img.getElement ? img.getElement() : (img as any)._element;
    const off = document.createElement('canvas');
    off.width = sw;
    off.height = sh;
    const ctx = off.getContext('2d');
    if (!ctx) { this.cancelCropImage(); return; }
    ctx.drawImage(source, sx, sy, sw, sh, 0, 0, sw, sh);
    const newDataUrl = off.toDataURL('image/png');

    const localCenter = { x: sx - halfW + sw / 2, y: sy - halfH + sh / 2 };
    const canvasCenter = fabric.util.transformPoint(localCenter, img.calcTransformMatrix());

    const objectId = img.objectId;
    const level = img.level;
    const angle = img.angle || 0;
    const scaleX = img.scaleX;
    const scaleY = img.scaleY;
    // Capturar la configuración existente ANTES de quitar la imagen del canvas: al eliminarla,
    // el listener 'object:removed' borra su entrada de canvasObjects (removeCanvasObject), así
    // que si esperásemos a leerla después ya no existiría y el recorte no se guardaría.
    const previousConfig = this.canvasObjects[objectId]?.configuration || {};

    this.canvas.remove(rect);
    this.cropRect = null;
    this.canvas.remove(img);
    this.blockComponents = false;

    const newImg: any = await this.generateMapService.addImageObject(newDataUrl, {
      objectId, left: canvasCenter.x, top: canvasCenter.y, angle, scaleX, scaleY, level
    });
    newImg.set({ selectable: true, evented: true, hoverCursor: 'move' });
    this.canvas.add(newImg);
    this.canvas.setActiveObject(newImg);
    this.editingImageObject = newImg;
    this.objectEditing = newImg;

    this.canvasObjects[objectId] = {
      id: objectId,
      type: 'image',
      configuration: {
        ...previousConfig,
        left: newImg.left,
        top: newImg.top,
        scaleX: newImg.scaleX,
        scaleY: newImg.scaleY,
        angle: newImg.angle || 0,
        src: newDataUrl,
        objectId,
      },
    };
    localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
    this.generateMapService.setObjectsMap(this.canvasObjects);
    this.cropModeActive = false;
    this.canvas.renderAll();
  }

  // Cancela el modo recorte sin aplicar cambios, restaurando la imagen original.
  cancelCropImage() {
    if (this.cropRect) {
      this.canvas.remove(this.cropRect);
      this.cropRect = null;
    }
    this.blockComponents = false;
    if (this.editingImageObject) {
      this.editingImageObject.set({ opacity: 1, selectable: true, evented: true });
      this.canvas.setActiveObject(this.editingImageObject);
    }
    this.cropModeActive = false;
    this.canvas.renderAll();
  }

  updateTextFontSize() {
    if (!this.editingTextObject) return;
    const size = +this.editingTextFontSize;
    if (!size || size < 1) return;
    this.editingTextObject.set('fontSize', size);
    this.canvas.renderAll();
    const objectId = this.editingTextObject.objectId;
    if (objectId && this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration.fontSize = size;
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  updateTextContent() {
    if (!this.editingTextObject) return;
    this.editingTextObject.set('text', this.editingTextContent);
    this.canvas.renderAll();
    const objectId = this.editingTextObject.objectId;
    if (objectId && this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration.text = this.editingTextContent;
      this.generateMapService.setObjectsMap(this.canvasObjects);
      this.refreshAvailableShapesList();
      this.refreshLayersList();
    }
  }

  updateTextLineHeight() {
    if (!this.editingTextObject) return;
    const lineHeight = +this.editingTextLineHeight;
    if (!lineHeight || lineHeight < 0.5) return;
    this.editingTextObject.set('lineHeight', lineHeight);
    this.canvas.renderAll();
    const objectId = this.editingTextObject.objectId;
    if (objectId && this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration.lineHeight = lineHeight;
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  updateTextColor() {
    if (!this.editingTextObject) return;
    this.editingTextObject.set('fill', this.editingTextColor);
    this.canvas.renderAll();
    const objectId = this.editingTextObject.objectId;
    if (objectId && this.canvasObjects[objectId]) {
      this.canvasObjects[objectId].configuration.fill = this.editingTextColor;
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
  }

  updateTextObjectId() {
    const newId = this.editingTextObjectId?.trim();
    if (!newId || !this.editingTextObject) return;
    const oldId = this.editingTextObject.objectId;
    if (!oldId || newId === oldId) return;
    if (this.canvasObjects[newId]) return; // already taken
    this.canvasObjects[newId] = {
      ...this.canvasObjects[oldId],
      configuration: { ...this.canvasObjects[oldId].configuration, objectId: newId }
    };
    delete this.canvasObjects[oldId];
    this.editingTextObject.objectId = newId;
    this.generateMapService.setObjectsMap(this.canvasObjects);
    this.refreshAvailableShapesList();
  }

  clickSelectScenary(element: any) {
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditText = false;
    this.openEditImage = false;
    this.editingImageObject = null;
    this.objectEditing = null;
    this.editingScenaryObject = element;
    // The text element is the second child (index 1) of the group
    const textObj = element._objects?.find((o: any) => o.type === 'text');
    this.editingScenaryText = textObj?.text || element._objects?.[1]?.text || 'Escenario';
    this.editingScenaryFontSize = textObj?.fontSize || 20;
    this.editingScenaryTextColor = textObj?.fill || '#000000';
    const rectObj = element._objects?.find((o: any) => o.type === 'rect');
    this.editingScenaryColor = rectObj?.fill || '#bae4ff';
    const iconObj = element._objects?.find((o: any) => o.type !== 'rect' && o.type !== 'text');
    this.editingScenaryShowIcon = iconObj ? iconObj.visible !== false : true;
    this.openEditScenary = true;
  }

  updateScenaryText() {
    if (!this.editingScenaryObject) return;
    const textObj = this.editingScenaryObject._objects?.find((o: any) => o.type === 'text');
    if (textObj) {
      textObj.set('text', this.editingScenaryText);
      this.editingScenaryObject.dirty = true;
    }
    // Persist in canvasObjects
    if (this.editingScenaryObject.objectId && this.canvasObjects[this.editingScenaryObject.objectId]) {
      this.canvasObjects[this.editingScenaryObject.objectId].configuration.text = this.editingScenaryText;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
      this.refreshLayersList();
    }
    this.canvas.renderAll();
  }

  updateScenaryColor() {
    if (!this.editingScenaryObject) return;
    const rectObj = this.editingScenaryObject._objects?.find((o: any) => o.type === 'rect');
    if (rectObj) {
      rectObj.set('fill', this.editingScenaryColor);
      this.editingScenaryObject.dirty = true;
    }
    // Persist in canvasObjects
    if (this.editingScenaryObject.objectId && this.canvasObjects[this.editingScenaryObject.objectId]) {
      this.canvasObjects[this.editingScenaryObject.objectId].configuration.fill = this.editingScenaryColor;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    this.canvas.renderAll();
  }

  updateScenaryFontSize() {
    if (!this.editingScenaryObject) return;
    const textObj = this.editingScenaryObject._objects?.find((o: any) => o.type === 'text');
    if (textObj) {
      textObj.set('fontSize', +this.editingScenaryFontSize);
    }
    // Reposicionar y escalar el icono bajo el texto si está visible
    const iconObj = this.editingScenaryObject._objects?.find((o: any) => o.type !== 'rect' && o.type !== 'text');
    if (iconObj && iconObj.visible !== false) {
      // Posición: textTop (-30) + mitad del alto del texto (fontSize * 0.58) + margen (13)
      const iconTop = -30 + this.editingScenaryFontSize * 0.58 + 13;
      iconObj.set('top', iconTop);
      // Escala proporcional al tamaño de fuente (base 0.05 para fontSize 20)
      const baseScale = 0.05 * (this.editingScenaryFontSize / 20);
      const groupScaleX = this.editingScenaryObject.scaleX || 1;
      const groupScaleY = this.editingScenaryObject.scaleY || 1;
      iconObj._origScaleX = baseScale;
      iconObj._origScaleY = baseScale;
      iconObj.scaleX = baseScale / groupScaleX;
      iconObj.scaleY = baseScale / groupScaleY;
    }
    this.editingScenaryObject.dirty = true;
    if (this.editingScenaryObject.objectId && this.canvasObjects[this.editingScenaryObject.objectId]) {
      this.canvasObjects[this.editingScenaryObject.objectId].configuration.fontSize = +this.editingScenaryFontSize;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    this.canvas.renderAll();
  }

  updateScenaryIcon() {
    if (!this.editingScenaryObject) return;
    const iconObj = this.editingScenaryObject._objects?.find((o: any) => o.type !== 'rect' && o.type !== 'text');
    if (iconObj) {
      iconObj.set('visible', this.editingScenaryShowIcon);
    }
    // Centrar verticalmente el texto cuando no hay icono
    const textObj = this.editingScenaryObject._objects?.find((o: any) => o.type === 'text');
    if (textObj) {
      textObj.set('top', this.editingScenaryShowIcon ? -30 : 0);
    }
    this.editingScenaryObject.dirty = true;
    if (this.editingScenaryObject.objectId && this.canvasObjects[this.editingScenaryObject.objectId]) {
      this.canvasObjects[this.editingScenaryObject.objectId].configuration.showIcon = this.editingScenaryShowIcon;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    this.canvas.renderAll();
  }

  updateScenaryTextColor() {
    if (!this.editingScenaryObject) return;
    const textObj = this.editingScenaryObject._objects?.find((o: any) => o.type === 'text');
    if (textObj) {
      textObj.set('fill', this.editingScenaryTextColor);
      this.editingScenaryObject.dirty = true;
    }
    // Persist in canvasObjects
    if (this.editingScenaryObject.objectId && this.canvasObjects[this.editingScenaryObject.objectId]) {
      this.canvasObjects[this.editingScenaryObject.objectId].configuration.textColor = this.editingScenaryTextColor;
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
    }
    this.canvas.renderAll();
  }

  closeScenaryEdit() {
    this.openEditScenary = false;
    this.editingScenaryObject = null;
    this.canvas.discardActiveObject();
    this.canvas.renderAll();
  }

  clearedObjectSelect() {
    if (this.cropModeActive) this.cancelCropImage();
    this.openEditObject = false;
    this.openEditSection = false;
    this.openEditScenary = false;
    this.openEditText = false;
    this.openEditImage = false;
    this.editingScenaryObject = null;
    this.editingTextObject = null;
    this.editingImageObject = null;
    this.activeTab = false;
    this.blockComponents = false;
    this.selectedHidden = [];
    this.canvas.discardActiveObject();
    this.canvas.renderAll();
    this.clearObjects();
  }

  activeEdit(event: any) {
    this.blockComponents = true;
    // this.canvasOnEditSeats(true, 'pointer', this.objectEditing);
    this.canvas.renderAll();
  }

  setHiddenSectionEditMode(active: boolean) {
    this.hiddenSectionEditMode = active;
    if (active) {
      // Activar subTargetCheck para poder hacer clic en asientos individuales
      this.canvasOnEditSeats(true, 'pointer');
    } else {
      this.canvasOnEditSeats(false, 'default');
    }
    this.canvas.renderAll();
  }

  setSpecialSeatEditMode(event: { active: boolean; level?: any }) {
    this.specialSeatEditMode = event.active;
    this.specialSeatTargetLevel = event.level || null;
    if (event.active) {
      this.canvasOnEditSeats(true, 'pointer');
    } else {
      this.canvasOnEditSeats(false, 'default');
    }
    this.canvas.renderAll();
  }

  persistSpecialSeatChange(seat: any) {
    const storedSections = this.generateMapService.getSeatSections();
    const sectionId = seat.section?.id;
    if (!storedSections || sectionId == null) return;
    const sectionData = storedSections[sectionId];
    if (!sectionData?.elements) return;
    const el = sectionData.elements.find((e: any) => +e.row === +seat.row && +e.column === +seat.column);
    if (el?.configuration) {
      el.configuration.special_level = seat.specialLevel || null;
      el.configuration.special_color = seat.colorSpecial || null;
    }
    this.generateMapService.setSeatSections(storedSections);
  }

  clearObjects() {
    this.canvasOnEditSeats(false, 'default');
    // En modo creación, restaurar la seleccionabilidad de los grupos de butacas
    // ya que canvasOnEditSeats los deja con selectable=false al no ser eventSeat
    if (this.isSuperAdminEditMode) {
      this.canvas._objects.forEach((obj: any) => {
        if (obj.groupSeat || obj.objectId || obj.isInfoSection) {
          obj.selectable = true;
          obj.evented = true;
          obj.lockMovementX = false;
          obj.lockMovementY = false;
          obj.hoverCursor = 'move';
        }
      });
    }
    // Restaurar la visibilidad correcta según la escena activa (butacas / zonas).
    this.applyMapModeVisibility();
  }

  // Guardaar y editar mapa
  updateCanvas(exit: boolean) {
    this.clearObjects();
    this.refreshLevelsList();
    this.canvas.renderAll();
    if (exit) {
      this.closeTab();
    }
  }

  saveColorSection(cancel: boolean) {
    if (this.objectEditing?.objectId && this.canvasObjects[this.objectEditing.objectId]) {
      this.canvasObjects[this.objectEditing.objectId].configuration.fill = this.objectEditing.fill;
      this.canvasObjects[this.objectEditing.objectId].configuration.stroke = this.objectEditing.stroke;
      this.canvasObjects[this.objectEditing.objectId].configuration.strokeWidth = this.objectEditing.strokeWidth;
      this.canvasObjects[this.objectEditing.objectId].configuration.level = this.objectEditing.level;
      this.canvasObjects[this.objectEditing.objectId].configuration.angle = this.objectEditing.angle || 0;
      // Persistir metadatos de la capa preview (zona del plano general). En formas de la escena
      // de butacas quedan en false/null.
      this.canvasObjects[this.objectEditing.objectId].configuration.previewLayer = !!this.objectEditing.previewLayer;
      this.canvasObjects[this.objectEditing.objectId].configuration.name = this.objectEditing.name ?? null;
      this.canvasObjects[this.objectEditing.objectId].configuration.labelFontSize = this.objectEditing.labelFontSize ?? 40;
      this.canvasObjects[this.objectEditing.objectId].configuration.labelAngle = this.objectEditing.labelAngle ?? 0;
      this.canvasObjects[this.objectEditing.objectId].configuration.levels = Array.isArray(this.objectEditing.navZoneLevels) ? [...this.objectEditing.navZoneLevels] : [];
      this.canvasObjects[this.objectEditing.objectId].configuration.hideLabel = !!this.objectEditing.hideLabel;
      this.canvasObjects[this.objectEditing.objectId].configuration.navZoneShapes = Array.isArray(this.objectEditing.navZoneShapes) ? [...this.objectEditing.navZoneShapes] : [];
      // Persistir puntos si es polígono (pueden haber cambiado al editar la forma)
      if (this.objectEditing.type === 'polygon' && this.objectEditing.points) {
        this.canvasObjects[this.objectEditing.objectId].configuration.points = this.objectEditing.points;
        this.canvasObjects[this.objectEditing.objectId].configuration.cornerRadius = this.objectEditing.cornerRadius || 0;
        this.canvasObjects[this.objectEditing.objectId].configuration.edgeCurvatures = Array.isArray(this.objectEditing.edgeCurvatures) ? [...this.objectEditing.edgeCurvatures] : undefined;
      }
      // Persistir geometría de la línea (puntos y curvatura).
      if (this.objectEditing.isLine) {
        this.canvasObjects[this.objectEditing.objectId].configuration.points = this.objectEditing.linePoints;
        this.canvasObjects[this.objectEditing.objectId].configuration.curvature = this.objectEditing.curvature || 0;
      }
      localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
      this.generateMapService.setObjectsMap(this.canvasObjects);
      // Actualizar el label flotante de la zona en el canvas del editor.
      if (this.objectEditing.previewLayer) {
        this.syncZoneLabel(this.objectEditing);
      }
      this.refreshLayersList();
    }
    this.canvas.renderAll();
  }

  // Mueve el label flotante de una zona para que siga al shape sin recrearlo.
  syncZoneLabelPosition(shapeObj: any) {
    const label = this.canvas._objects?.find((o: any) => o.zoneLabelFor === shapeObj.objectId);
    if (!label) return;
    shapeObj.setCoords();
    const bounds = shapeObj.getBoundingRect(true);
    const cx = bounds.left + bounds.width / 2;
    const cy = bounds.top + bounds.height / 2;
    label.set({ left: cx, top: cy });
    label.setCoords();
  }

  // Crea, actualiza o elimina el fabric.Text flotante que muestra el nombre de una zona en el
  // editor. El label se identifica por la propiedad zoneLabelFor=objectId del polígono/rect,
  // así se puede encontrar y actualizar sin necesidad de un segundo canvasObjects entry.
  syncZoneLabel(shapeObj: any) {
    const name: string = shapeObj.name ?? '';
    const fontSize: number = shapeObj.labelFontSize || 40;
    const angle: number = shapeObj.labelAngle || 0;
    // Buscar label existente en el canvas.
    const existing = this.canvas._objects?.find((o: any) => o.zoneLabelFor === shapeObj.objectId);

    if (!name || shapeObj.hideLabel) {
      // Sin nombre o con etiqueta oculta → eliminar label si existía.
      if (existing) this.canvas.remove(existing);
      return;
    }

    const bounds = shapeObj.getBoundingRect(true);
    const cx = bounds.left + bounds.width / 2;
    const cy = bounds.top + bounds.height / 2;

    if (existing) {
      existing.set({ text: name, fontSize, angle, left: cx, top: cy });
      existing.dirty = true;
      existing.setCoords();
    } else {
      const label = new fabric.Text(name, {
        left: cx,
        top: cy,
        originX: 'center',
        originY: 'center',
        fontFamily: 'Satoshi-Regular',
        fontSize,
        angle,
        fill: '#222222',
        selectable: false,
        evented: false,
        previewLayer: true,
        zoneLabelFor: shapeObj.objectId,
        isNavZoneLabel: true,
      } as any);
      this.canvas.add(label);
      this.canvas.bringToFront(label);
      label.setCoords();
    }
  }

  // Activa/desactiva la navegación por zonas para este mapa (opt-in, no afecta mapas existentes).
  toggleZoneNavigation() {
    this.generateMapService.setZoneNavigation(this.zoneNavigation);
  }

  // Solicita confirmación antes de desactivar la vista general de zonas.
  // Elimina todos los objetos de la capa preview y guarda el mapa.
  confirmDisableZoneNavigation() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        title: 'Desactivar vista general',
        text: 'Se eliminarán todos los objetos del plano general de zonas y el mapa se guardará sin esta opción. ¿Continuar?',
        btnCancel: true
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // Eliminar del canvas y de canvasObjects todos los objetos previewLayer.
        const toRemove = this.canvas._objects?.filter((o: any) => !!o.previewLayer) || [];
        toRemove.forEach((o: any) => this.canvas.remove(o));
        Object.keys(this.canvasObjects).forEach(key => {
          if (this.canvasObjects[key]?.configuration?.previewLayer) {
            delete this.canvasObjects[key];
          }
        });
        this.generateMapService.setObjectsMap(this.canvasObjects);
        localStorage.setItem('canvasObjects', JSON.stringify(this.canvasObjects));
        this.zoneNavigation = false;
        this.generateMapService.setZoneNavigation(false);
        this.setMapMode('seats');
        this.save();
      }
    });
  }

  // Solicita confirmación antes de activar la preview de zonas por primera vez.
  confirmEnableZoneNavigation() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        title: 'Vista general de zonas',
        text: 'Esto activará una escena adicional donde podrás dibujar un plano general con zonas clicables. El mapa se guardará con esta opción activada. ¿Continuar?',
        btnCancel: true
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.zoneNavigation = true;
        this.generateMapService.setZoneNavigation(true);
        this.save();
        this.setMapMode('zones');
      }
    });
  }

  // Cambia entre la escena de butacas y la del plano general de zonas. Cierra cualquier panel
  // de edición abierto y alterna la visibilidad de cada escena sobre el mismo canvas.
  setMapMode(mode: 'seats' | 'zones') {
    if (this.mapMode === mode) return;
    this.mapMode = mode;
    this.clearedObjectSelect();
    this.applyMapModeVisibility();
  }

  // Muestra solo la escena activa: en 'zones' se ven los objetos previewLayer; en 'seats', el
  // resto (butacas, escenario, fondos y textos del mapa real). El fondo de cuadrícula es la
  // imagen de fondo del canvas, no un objeto, así que no se ve afectado.
  applyMapModeVisibility() {
    if (!this.canvas) return;
    const zones = this.mapMode === 'zones';
    this.canvas._objects?.forEach((obj: any) => {
      const isPreview = !!obj.previewLayer;
      obj.visible = (isPreview ? zones : !zones) && !obj.userHiddenLayer;
    });
    this.canvas.renderAll();
    this.refreshLayersList();
  }

  // Genera automáticamente un polígono de la capa preview por cada sección de butacas del
  // canvas, usando su forma, posición, rotación y color de nivel. Si ya existen zonas pide
  // confirmación antes de reemplazarlas.
  autoGenerateZoneShapes() {
    this.saveHistorySnapshot();

    const hasSections = (this.canvas._objects || []).some((o: any) => !!o.groupSeat);
    const hasPolygons = Object.values(this.canvasObjects).some((o: any) => {
      const cfg = o?.configuration;
      return cfg && !cfg.previewLayer && ['polygon', 'rect', 'ellipse'].includes(o.type) && cfg.level != null;
    });
    const hasExisting = Object.values(this.canvasObjects).some(
      (o: any) => o?.configuration?.previewLayer
    );

    if (!hasSections && !hasPolygons) {
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          title: 'Auto-generar zonas',
          text: 'No hay secciones de butacas ni polígonos con nivel asignado para generar zonas.',
          btnCancel: false,
        }
      });
      return;
    }

    const execute = (source: 'sections' | 'polygons') => {
      if (hasExisting) {
        const confirmRef = this.dialog.open(InfoCardComponent, {
          panelClass: 'info-dialog',
          data: {
            icon: false,
            title: 'Auto-generar zonas',
            text: 'Ya existen zonas en el plano general. ¿Reemplazarlas con las generadas automáticamente?',
            btnCancel: true,
          }
        });
        confirmRef.afterClosed().subscribe((confirmed: boolean) => {
          if (!confirmed) return;
          const toRemove = (this.canvas._objects || []).filter((o: any) => !!o.previewLayer);
          toRemove.forEach((o: any) => this.canvas.remove(o));
          Object.keys(this.canvasObjects).forEach(key => {
            if (this.canvasObjects[key]?.configuration?.previewLayer)
              delete this.canvasObjects[key];
          });
          source === 'polygons' ? this._executeAutoGenerateZonesFromPolygons() : this._executeAutoGenerateZones();
        });
      } else {
        source === 'polygons' ? this._executeAutoGenerateZonesFromPolygons() : this._executeAutoGenerateZones();
      }
    };

    if (hasSections && hasPolygons) {
      const choiceRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          title: 'Auto-generar zonas',
          text: 'Selecciona la fuente para generar las zonas de navegación:',
          btnCancel: true,
          choices: [
            { label: 'Secciones de butacas', value: 'sections' },
            { label: 'Polígonos con nivel asignado', value: 'polygons' },
          ],
        }
      });
      choiceRef.afterClosed().subscribe((result: string | false | null) => {
        if (!result) return;
        execute(result as 'sections' | 'polygons');
      });
    } else {
      execute(hasSections ? 'sections' : 'polygons');
    }
  }

  private _executeAutoGenerateZones() {
    if (!this.zoneNavigation) {
      this.zoneNavigation = true;
      this.generateMapService.setZoneNavigation(true);
    }
    if (this.mapMode !== 'zones') this.setMapMode('zones');

    const groupSeats = (this.canvas._objects || []).filter((o: any) => !!o.groupSeat);

    // ZONE_SCALE compresses positions (relative to bounding-box center).
    // SIZE_SCALE is slightly smaller so polygons don't touch/overlap each other.
    const ZONE_SCALE = 0.3;
    const SIZE_SCALE = ZONE_SCALE * 0.75;

    // Compute bounding-box of all seat sections.
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (const o of groupSeats) {
      minX = Math.min(minX, o.left); maxX = Math.max(maxX, o.left);
      minY = Math.min(minY, o.top);  maxY = Math.max(maxY, o.top);
    }
    const pivotX = (minX + maxX) / 2;
    const pivotY = (minY + maxY) / 2;

    // After scaling, the top-left of the zone cluster sits at the scaled minX/minY.
    // Shift the whole cluster to the top-left corner of the canvas with a small margin.
    const TARGET_X = 80;
    const TARGET_Y = 80;
    const scaledMinX = pivotX + (minX - pivotX) * ZONE_SCALE;
    const scaledMinY = pivotY + (minY - pivotY) * ZONE_SCALE;
    const offsetX = TARGET_X - scaledMinX;
    const offsetY = TARGET_Y - scaledMinY;

    for (const canvasObj of groupSeats) {
      const seatsSubGroup = canvasObj._objects?.[1];

      const firstSeat = seatsSubGroup?._objects?.find((s: any) => s.eventSeat);
      const sectionId = firstSeat?.section?.id;
      const sectionData = sectionId != null ? this.seatSections[sectionId] : null;
      const levelId: number | null = sectionData?.section?.level ?? null;
      const levelObj = levelId != null
        ? (this.levels || []).find((l: any) => +l.id === +levelId)
        : null;

      const fill = (levelObj?.color ?? '#888888') + 'aa';
      const stroke = levelObj?.color ?? '#888888';

      // Seat grid positions are stored in originX/originY (small values like -1.2, -2.4…).
      // Use ratios of visible vs all seats to scale the known group dimensions.
      const allEventSeats = (seatsSubGroup?._objects || []).filter((s: any) => s.eventSeat);
      const hiddenIds = new Set(
        (this.hiddenTypes || []).flatMap((h: any) => h.id_seats || [])
      );
      const visibleSeats = allEventSeats.filter((s: any) => !hiddenIds.has(s.id));
      const seatsForBbox = visibleSeats.length > 0 ? visibleSeats : allEventSeats;

      const originX = (s: any) => typeof s.originX === 'number' ? s.originX : 0;
      const originY = (s: any) => typeof s.originY === 'number' ? s.originY : 0;

      let aMinX = Infinity, aMaxX = -Infinity, aMinY = Infinity, aMaxY = -Infinity;
      for (const s of allEventSeats) {
        aMinX = Math.min(aMinX, originX(s)); aMaxX = Math.max(aMaxX, originX(s));
        aMinY = Math.min(aMinY, originY(s)); aMaxY = Math.max(aMaxY, originY(s));
      }
      let bMinX = Infinity, bMaxX = -Infinity, bMinY = Infinity, bMaxY = -Infinity;
      for (const s of seatsForBbox) {
        bMinX = Math.min(bMinX, originX(s)); bMaxX = Math.max(bMaxX, originX(s));
        bMinY = Math.min(bMinY, originY(s)); bMaxY = Math.max(bMaxY, originY(s));
      }

      const allRangeX = aMaxX - aMinX;
      const allRangeY = aMaxY - aMinY;
      const wRatio = allRangeX > 0 ? (bMaxX - bMinX) / allRangeX : 1;
      const hRatio = allRangeY > 0 ? (bMaxY - bMinY) / allRangeY : 1;

      const angleRad = ((canvasObj.angle ?? 0) * Math.PI) / 180;
      const cos = Math.cos(angleRad);
      const sin = Math.sin(angleRad);

      // Positions compressed by ZONE_SCALE; sizes by SIZE_SCALE (smaller) to leave gaps between zones.
      const fullSubW = (canvasObj.width * (canvasObj.scaleX ?? 1)) / 2 * SIZE_SCALE;
      const fullSubH = (canvasObj.height * (canvasObj.scaleY ?? 1)) / 2 * SIZE_SCALE;
      const subW = fullSubW * (wRatio || 1);
      const subH = fullSubH * (hRatio || 1);

      // Shift polygon center if visible seats are offset from the full grid center.
      let cx: number, cy: number;
      if (allRangeX > 0 && allRangeY > 0) {
        const deltaFracX = ((bMinX + bMaxX) / 2 - (aMinX + aMaxX) / 2) / allRangeX;
        const deltaFracY = ((bMinY + bMaxY) / 2 - (aMinY + aMaxY) / 2) / allRangeY;
        const dCanvasX = deltaFracX * (canvasObj.width  * (canvasObj.scaleX ?? 1));
        const dCanvasY = deltaFracY * (canvasObj.height * (canvasObj.scaleY ?? 1));
        const rotDx = dCanvasX * cos - dCanvasY * sin;
        const rotDy = dCanvasX * sin + dCanvasY * cos;
        cx = pivotX + (canvasObj.left + rotDx - pivotX) * ZONE_SCALE + offsetX;
        cy = pivotY + (canvasObj.top  + rotDy - pivotY) * ZONE_SCALE + offsetY;
      } else {
        cx = pivotX + (canvasObj.left - pivotX) * ZONE_SCALE + offsetX;
        cy = pivotY + (canvasObj.top  - pivotY) * ZONE_SCALE + offsetY;
      }

      const corners = [
        { x: cx + (-subW) * cos - (-subH) * sin, y: cy + (-subW) * sin + (-subH) * cos },
        { x: cx + ( subW) * cos - (-subH) * sin, y: cy + ( subW) * sin + (-subH) * cos },
        { x: cx + ( subW) * cos - ( subH) * sin, y: cy + ( subW) * sin + ( subH) * cos },
        { x: cx + (-subW) * cos - ( subH) * sin, y: cy + (-subW) * sin + ( subH) * cos },
      ];
      const points = corners.map(c => ({ x: c.x - cx, y: c.y - cy }));

      const sectionName: string = sectionData?.section?.name ?? '';
      const navZoneLevels: number[] = levelId != null ? [levelId] : [];
      const objectId = `obj_${this.objectIdCounter}`;

      const polygon = this.generateMapService.addPoligonObject({
        objectId, points,
        left: cx, top: cy,
        fill, stroke, strokeWidth: 2,
        scaleX: 1, scaleY: 1, angle: 0,
        width: subW * 2, height: subH * 2,
      });

      polygon.set({
        previewLayer: true,
        navZoneLevels,
        name: sectionName,
        labelFontSize: 28,
        labelAngle: 0,
        hideLabel: true,
        selectable: true,
        evented: true,
      } as any);

      this.canvas.add(polygon);
      this.canvas.sendToBack(polygon);

      const objectData: any = {
        points: polygon.points,
        left: polygon.left, top: polygon.top,
        fill, stroke, strokeWidth: 2,
        scaleX: 1, scaleY: 1, angle: 0,
        width: polygon.width, height: polygon.height,
        objectId,
        level: null,
        previewLayer: true,
        levels: navZoneLevels,
        name: sectionName,
        labelFontSize: 28, labelAngle: 0,
        hideLabel: true,
      };
      this.saveCanvasObject(objectId, 'polygon', objectData);
    }

    this.applyMapModeVisibility();
    this.canvas.renderAll();
  }

  private _executeAutoGenerateZonesFromPolygons() {
    if (!this.zoneNavigation) {
      this.zoneNavigation = true;
      this.generateMapService.setZoneNavigation(true);
    }
    if (this.mapMode !== 'zones') this.setMapMode('zones');

    const qualifyingShapes = Object.values(this.canvasObjects).filter((o: any) => {
      const cfg = o?.configuration;
      return cfg && !cfg.previewLayer && ['polygon', 'rect', 'ellipse'].includes(o.type) && cfg.level != null;
    });

    if (qualifyingShapes.length === 0) return;

    const ZONE_SCALE = 0.3;
    const SIZE_SCALE = ZONE_SCALE * 0.75;

    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (const shape of qualifyingShapes) {
      const cfg = (shape as any).configuration;
      minX = Math.min(minX, cfg.left); maxX = Math.max(maxX, cfg.left);
      minY = Math.min(minY, cfg.top);  maxY = Math.max(maxY, cfg.top);
    }
    const pivotX = (minX + maxX) / 2;
    const pivotY = (minY + maxY) / 2;

    const TARGET_X = 200;
    const TARGET_Y = 200;
    const scaledMinX = pivotX + (minX - pivotX) * ZONE_SCALE;
    const scaledMinY = pivotY + (minY - pivotY) * ZONE_SCALE;
    const offsetX = TARGET_X - scaledMinX;
    const offsetY = TARGET_Y - scaledMinY;

    for (const shapeObj of qualifyingShapes) {
      const cfg = (shapeObj as any).configuration;
      const levelId: number = cfg.level;
      const levelObj = (this.levels || []).find((l: any) => +l.id === +levelId);
      const fill = (levelObj?.color ?? '#888888') + 'aa';
      const stroke = levelObj?.color ?? '#888888';

      const cx: number = pivotX + (cfg.left - pivotX) * ZONE_SCALE + offsetX;
      const cy: number = pivotY + (cfg.top  - pivotY) * ZONE_SCALE + offsetY;

      const scaleX: number = cfg.scaleX ?? 1;
      const scaleY: number = cfg.scaleY ?? 1;
      const angleRad = ((cfg.angle ?? 0) * Math.PI) / 180;
      const cos = Math.cos(angleRad);
      const sin = Math.sin(angleRad);

      let points: Array<{x: number; y: number}>;
      let width: number, height: number;

      if ((shapeObj as any).type === 'polygon' && cfg.points?.length) {
        points = (cfg.points as Array<{x: number; y: number}>).map((p: any) => {
          const sx = p.x * scaleX * SIZE_SCALE;
          const sy = p.y * scaleY * SIZE_SCALE;
          return { x: sx * cos - sy * sin, y: sx * sin + sy * cos };
        });
        width = (cfg.width ?? 0) * scaleX * SIZE_SCALE;
        height = (cfg.height ?? 0) * scaleY * SIZE_SCALE;
      } else {
        const hw = (cfg.width ?? 0) * scaleX / 2 * SIZE_SCALE;
        const hh = (cfg.height ?? 0) * scaleY / 2 * SIZE_SCALE;
        points = [
          { x: (-hw) * cos - (-hh) * sin, y: (-hw) * sin + (-hh) * cos },
          { x: ( hw) * cos - (-hh) * sin, y: ( hw) * sin + (-hh) * cos },
          { x: ( hw) * cos - ( hh) * sin, y: ( hw) * sin + ( hh) * cos },
          { x: (-hw) * cos - ( hh) * sin, y: (-hw) * sin + ( hh) * cos },
        ];
        width = hw * 2;
        height = hh * 2;
      }

      const navZoneLevels: number[] = levelId != null ? [levelId] : [];
      const zoneName: string = levelObj?.name ?? '';
      const objectId = `obj_${this.objectIdCounter}`;

      const polygon = this.generateMapService.addPoligonObject({
        objectId, points,
        left: cx, top: cy,
        fill, stroke, strokeWidth: 2,
        scaleX: 1, scaleY: 1, angle: 0,
        width, height,
      });

      polygon.set({
        previewLayer: true,
        navZoneLevels,
        name: zoneName,
        labelFontSize: 28,
        labelAngle: 0,
        hideLabel: true,
        selectable: true,
        evented: true,
      } as any);

      this.canvas.add(polygon);
      this.canvas.sendToBack(polygon);

      const objectData: any = {
        points: polygon.points,
        left: polygon.left, top: polygon.top,
        fill, stroke, strokeWidth: 2,
        scaleX: 1, scaleY: 1, angle: 0,
        width: polygon.width, height: polygon.height,
        objectId,
        level: null,
        previewLayer: true,
        levels: navZoneLevels,
        name: zoneName,
        labelFontSize: 28, labelAngle: 0,
        hideLabel: true,
      };
      this.saveCanvasObject(objectId, 'polygon', objectData);
    }

    this.applyMapModeVisibility();
    this.canvas.renderAll();
  }

  // Indica si un nuevo objeto debe crearse en la capa preview (modo zonas).
  private get creatingInPreview(): boolean {
    return this.mapMode === 'zones';
  }

  save() {
    if (this.canvas) {
      this.closeTab();
      // this.saveJson();
      this.fromVenue ? this.editMap() : this.editName();
    }
  }

  saveJson() {
    const jsonMap = this.loadJson();
    this.createEventService.setJsonMap(jsonMap);
  }

  loadJson() {
    this.canvas.setBackgroundImage(null);
    this.canvas.renderAll();
    let maxHeight = 600;
    let maxWidth = 1000;
    this.canvas.renderAll.bind(this.canvas), function (o, object) {
      maxHeight = Math.max(maxHeight, Math.abs(o.top + o.height));
      maxWidth = Math.max(maxWidth, Math.abs(o.left + o.width));
    };
    this.canvas.setDimensions({ width: maxWidth + 50, height: maxHeight + 50 });
    let json = this.canvas.toDatalessJSON(this.areaSeatService.arrayParams);
    json.objects.forEach((element, index) => {
      element.hasControls = false;
    });
    this.getHiddenSeats();
    let svgData = JSON.stringify(json);
    let jsonMap = {
      name: this.titleMap,
      capacity: this.capacity,
      levels: this.levels,
      hiddenSeats: this.hiddenTypes,
      map: svgData,
      private: this.privateMap,
      sectionsData: this.seatSections // **NUEVO: Incluir datos estructurados**
    }
    this.canvas.setBackgroundImage();
    return jsonMap;
  }

  editMap() {
    // const jsonMap = this.loadJson();
    // this.seatMapService.editMap(jsonMap, this.idMap).subscribe({
    //   next: (res) => {
    //     this.openInfo('Se han guardado tus cambios correctamente.');
    //   },
    //   error: (err) => {
    //     this.openError();
    //   }
    // })
  }

  createMap(jsonMap: any) {
    // this.seatMapService.createMap(jsonMap).subscribe({
    //   next: (res) => {
    //     this.openInfo('Se ha guardado correctamente. Ya puedes empezar a usar tu mapa en todos los eventos.')
    //     this.router.navigate(['/profile/seat-maps'])
    //   },
    //   error: (err) => {
    //     this.openError();
    //   }
    // })
  }

  openError() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: '¡Vaya, algo ha ido mal! Vuelve a itentarlo más tarde.',
        btnCancel: false
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.editEvent ? this.location.back() :
          this.router.navigate(['/profile/seat-maps']);
      }
    })
  }

  editName() {
    const dialogRef = this.dialog.open(NameMapComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: { edit: this.idMap != null, name: this.titleMap }
    });
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result.edit) {
          this.titleMap = result.name;
          // let jsonMap = this.loadJson();
          // jsonMap.name = result.name;
          // this.createMap(jsonMap);
        }
      }
    })
  }

  deleteMap() {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que deseas eliminar el mapa de asientos? Todos los datos se perderán.',
        btnCancel: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.seatMapService.deleteMap(this.idMap).subscribe({
          next: () => {
            this.openInfo('Se han guardado tus cambios correctamente')
            this.router.navigate(['/profile/seat-maps'])
          },
          error: (err) => {
            this.openError();
          }
        })
      }
    })
  }

  openInfo(text: any) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: false,
        text: text,
        btnCancel: false
      }
    });
  }

  // Levels & Hidden
  openLevelsHidden(type: string) {
    this.canvas.discardActiveObject();
    const pointer = 'default';
    this.canvasOnEditSeats(true, pointer);
    this.canvasColorHidden(true);
    this.titleTab = 'Asientos bloqueados';
    this.activeTab = true;
    this.openedHidden = true;
  }

  assignedSeatsHidden(assigned: any) {
    this.hiddenTypes = assigned;
    this.generateMapService.setBlockedSeats(this.hiddenTypes);
    this.canvasOnEditSeats(false, 'default');
    this.canvasColorHidden(this.bookedSeatsShowed);
    this.hiddenTypeEdit = null;
  }

  activeEditHidden(hiddenEdit: any) {
    this.hiddenTypeEdit = hiddenEdit;
    // this.selectedHidden = this.hiddenTypeEdit.elements;
    this.canvasOnEditSeats(true, 'pointer');
  }

  closeTab() {
    if (!this.fromEvent) {
      if (this.openedHidden) {
        let pointer = this.fromCreate ? 'default' : 'pointer';
        this.canvasOnEditSeats(false, pointer);
        this.canvasColorHidden(false);
        if (this.idEvent || this.fromCreate) {
          this.activeEdit(true);
        }
      }
      this.openedHidden = false;
      this.levelEdit = null;
      this.selectedSeats = [];
      this.selectedHidden = [];
      this.hiddenTypeEdit = null;
      this.activeTab = false;
      this.openEditSection = false;
      this.openEditText = false;
      this.editingTextObject = null;
      this.clearedObjectSelect();
    }
  }

  // Update Colors
  canvasOnEditSeats(edit: boolean = true, pointer: string = 'pointer', editElement?: any) {
    // Permitir seleccionar solo los asientos que no están reservados, cambiar puntero y parametros del mapa para editarlo
    const objects = this.generateSeatsService.canvasOnEditSeats(this.canvas, edit, pointer, editElement, this.bookings);
    this.canvas.renderAll();
  }

  canvasColorHidden(bookedActive: boolean) {
    let objects = this.canvas._objects;
    objects.forEach(element => {
      if (element.isSection) {
        let defaultColor = element.isSection ? element.hiddenType?.color || this.colorDefaultSeat : (this.fromCreate || this.fromEvent ? this.colorDefaultBasic : this.colorDefaultSeat);
        element = this.generateMapService.changeSeatColor(element, bookedActive ? defaultColor : (this.fromCreate || this.fromEvent ? this.colorDefaultBasic : this.colorDefaultSeat));
      }
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach(seat => {
          if (!seat.eventSeat) return; // skip row labels
          let hiddenType = this.hiddenTypes?.find(hiddenType => {
            return hiddenType.id_seats?.includes(seat.id);
          });


          let exist = false;
          if (this.idEvent) {
            exist = this.bookedSeats?.find(value => value == seat.id);
          }
          if (exist) {
            let colorSeat = (bookedActive || !this.fromEvent) ? this.colorDefaultHidden : hiddenType?.color || seat.colorSpecial || seat.color;
            seat = this.generateMapService.changeSeatColor(seat, colorSeat);
            seat.selectable = !bookedActive;
          } else if (hiddenType) {
            let defaultColorSeat = hiddenType.color || seat.colorSpecial || seat.color || this.colorDefaultSeat;
            seat = this.generateMapService.changeSeatColor(seat, defaultColorSeat);
          } else {
            let resetColor = seat.colorSpecial || seat.color || (this.fromCreate || this.fromEvent ? this.colorDefaultBasic : this.colorDefaultSeat);
            seat = this.generateMapService.changeSeatColor(seat, resetColor);
          }
        });
      }
    });
    this.canvas.renderAll();
  }

  canvasOnEditHidden(saveLevel: boolean = false, item: any) {
    let hiddenIndex = this.hiddenTypes.findIndex(value => value?.orderBuy == item.orderBuy);
    let hiddenElements = [];
    this.selectedHidden.forEach(element => {
      if (element.eventSeat && saveLevel) {
        element.hiddenType = {
          name: item.name,
          color: item.color,
          orderBuy: item.orderBuy,
          seats: item.seats
        }
        element.assign = true
      }
      let defaultColor = element.isSection ? this.colorDefaultFree : this.colorDefaultSeat;
      let color = element.hiddenType ? element.hiddenType.color : defaultColor;

      element = this.generateMapService.changeSeatColor(element, saveLevel ? item.color : color);
      hiddenElements.push({ section: element.section.id, row: element.row, seat: element.seat, column: element.column, isVisible: element.isVisible });

      // Actualizar el element de los asientos guardados en seatSection


    });
    this.hiddenTypes[hiddenIndex].elements = hiddenElements;
    this.hiddenTypes[hiddenIndex].numSeats = hiddenElements.length;
    this.hiddenTypes[hiddenIndex].seats = hiddenElements.length;
    this.generateMapService.setBlockedSeats(this.hiddenTypes);
    this.selectedHidden = [];
    this.canvas.renderAll();
  }

  getHiddenSeats() {
    let objects = this.canvas._objects;
    objects.forEach(element => {
      if (element.groupSeat) {
        let arrayObject = element._objects[1];
        arrayObject._objects.forEach(seat => {
          if (seat.eventSeat && seat.hidden) {
            this.hiddenSeats.push({ section: seat.section, row: seat.row, seat: seat.seat, level: seat.level, hiddenType: seat.hiddenType });
          }
        });
      }
    });

    this.hiddenTypes.forEach(element => {
      const seats = this.hiddenSeats.filter(value => value.hiddenType?.orderBuy == element.orderBuy);
      const objectSeats = seats.map(seat => { return { section: seat.section, row: seat.row, seat: seat.seat, level: seat.level } })
      element.objectsSeats = objectSeats;
      element.seats = seats?.length;
    });
  }

  removeSectionData(sectionId: number) {
    if (this.seatSections[sectionId]) {
      delete this.seatSections[sectionId];
      this.generateMapService.setSeatSections(this.seatSections);
      this.refreshLevelsList();
    }
    this.openEditSection = false;
    this.activeTab = false;
    this.blockComponents = true;
    this.canvas.renderAll();
  }

  createOrUpdateSectionData(groupObject: any) {
    if (!groupObject.groupSeat) return;

    let seatsGroup = groupObject._objects.find(value => value.section);

    if (!seatsGroup || !seatsGroup.section) return;

    const sectionId = seatsGroup.section.id;

    // Si ya existe, solo actualizar la configuración
    if (this.seatSections[sectionId]) {
      const prevConfig = this.seatSections[sectionId].section.configuration || {};
      let seatsGroupConfig = prevConfig.seatsGroupConfig;

      // Secciones radiales/elípticas con centro de curvatura: el ángulo final del grupo se
      // RECALCULA en cada reconstrucción (carga, undo, mover C…) a partir de la posición y de C
      // — ver generateMapService.addGroupSeats. Si aquí guardásemos tal cual `groupObject.angle`
      // (el resultado de arrastrar el tirador de rotación), esa reconstrucción lo pisaría con el
      // ángulo "mirando a C" y la rotación manual se perdería (quedando "ligeramente distinta"
      // tras un F5). Por eso separamos cuánto de ese ángulo es auto-orientación hacia C y cuánto
      // es el ajuste manual del usuario, y persistimos solo el offset: así sobrevive a la
      // reconstrucción y sigue rotando junto con la sección si C se mueve después.
      const curvatureMode = seatsGroupConfig?.curvatureMode;
      const isRadial = (curvatureMode === 'radial' || curvatureMode === 'elliptical') && !!seatsGroupConfig?.curvatureCenter;
      if (isRadial) {
        const baseAngle = this.generateMapService.computeRadialBaseAngleDeg(
          groupObject.left, groupObject.top, seatsGroupConfig.curvatureCenter
        );
        seatsGroupConfig = { ...seatsGroupConfig, manualAngleOffsetDeg: (groupObject.angle || 0) - baseAngle };
      }

      this.seatSections[sectionId].section.configuration = {
        ...prevConfig,
        left: groupObject.left,
        top: groupObject.top,
        scaleX: groupObject.scaleX,
        scaleY: groupObject.scaleY,
        angle: groupObject.angle || 0,
        originX: groupObject.originX,
        originY: groupObject.originY,
        seatsGroupConfig
      };

      this.generateMapService.setSeatSections(this.seatSections);
    }
  }

  ngOnDestroy() {
    this.subscribeSaveBtn?.unsubscribe();
    this.removeFileDropListeners?.();
    this.removeFileDropListeners = null;
    if (this.curveCenterMarker) this.removeCurveCenterMarker();
  }

}


function keepPositionInBounds(canvas: any, e: any) {
  const zoom = canvas.getZoom();
  const vpt = canvas.viewportTransform;
  const vw = canvas.getWidth();
  const vh = canvas.getHeight();

  let newTx = vpt[4] + e.e.movementX;
  let newTy = vpt[5] + e.e.movementY;

  // Límites de paneo basados en el bounding box real del contenido (en coordenadas de
  // objeto, sin viewportTransform), no en un múltiplo fijo del viewport. Con la fórmula
  // anterior (2.5 × viewport) los mapas altos no se podían desplazar hasta el fondo a
  // mucho zoom: el desplazamiento necesario crecía más rápido que el tope permitido.
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const obj of canvas.getObjects()) {
    const r = obj.getBoundingRect(true, true); // absolute=true → sin viewportTransform
    if (r.left < minX) minX = r.left;
    if (r.top < minY) minY = r.top;
    if (r.left + r.width > maxX) maxX = r.left + r.width;
    if (r.top + r.height > maxY) maxY = r.top + r.height;
  }

  if (isFinite(minX)) {
    // Cuánto contenido debe permanecer visible dentro del viewport para no perder el mapa.
    const margin = Math.min(vw, vh) * 0.2;

    // Rango de traslación permitido para que el contenido no salga del viewport.
    const txMin = margin - maxX * zoom;
    const txMax = vw - margin - minX * zoom;
    const tyMin = margin - maxY * zoom;
    const tyMax = vh - margin - minY * zoom;

    // Solo restringimos cuando el contenido es mayor que el viewport (rango válido); si es
    // más pequeño (rango invertido) dejamos mover libremente para no bloquear el paneo.
    if (txMin <= txMax) newTx = Math.min(Math.max(newTx, txMin), txMax);
    if (tyMin <= tyMax) newTy = Math.min(Math.max(newTy, tyMin), tyMax);
  }

  canvas.relativePan(new fabric.Point(newTx - vpt[4], newTy - vpt[5]));
  return canvas;
}
